export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  Number: any;
  QueryArgument: any;
};

export type AssetCriteriaInput = {
  /** Narrows the query results to only elements that have been archived. */
  archived?: InputMaybe<Scalars['Boolean']>;
  /** Narrows the query results based on the elements’ creation dates. */
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results based on the assets’ files’ last-modified dates. */
  dateModified?: InputMaybe<Scalars['String']>;
  /** Narrows the query results based on the elements’ last-updated dates. */
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results based on whether the elements are enabled in the site they’re being queried in, per the `site` argument. */
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  /** Narrows the query results based on the assets’ filenames. */
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Causes the query results to be returned in the order specified by the `id` argument. */
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  /** Narrows the query results based on the folders the assets belong to, per the folders’ IDs. */
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results based on the assets’ image heights. */
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results based on the elements’ IDs. */
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Causes the query results to be returned in reverse order. */
  inReverse?: InputMaybe<Scalars['Boolean']>;
  /** Broadens the query results to include assets from any of the subfolders of the folder specified by `folderId`. */
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  /** Narrows the query results based on the assets’ file kinds. */
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Sets the limit for paginated results. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Sets the offset for paginated results. */
  offset?: InputMaybe<Scalars['Int']>;
  /** Sets the field the returned elements should be ordered by. */
  orderBy?: InputMaybe<Scalars['String']>;
  /** Determines which site should be selected when querying multi-site elements. */
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results based on a reference string. */
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results to elements that relate to the provided element IDs. This argument is ignored, if `relatedToAll` is also used. */
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results to elements that relate to *all* of the provided element IDs. Using this argument will cause `relatedTo` argument to be ignored. **This argument is deprecated.** `relatedTo: ["and", ...ids]` should be used instead. */
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results to elements that relate to an asset list defined with this argument. */
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  /** Narrows the query results to elements that relate to a category list defined with this argument. */
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  /** Narrows the query results to elements that relate to an entry list defined with this argument. */
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  /** Narrows the query results to elements that relate to a tag list defined with this argument. */
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  /** Narrows the query results to elements that relate to a use list defined with this argument. */
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  /** Narrows the query results to only elements that match a search query. */
  search?: InputMaybe<Scalars['String']>;
  /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results based on the unique identifier for an element-site relation. */
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results based on the assets’ file sizes (in bytes). */
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results based on the elements’ slugs. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results based on the elements’ statuses. */
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results based on the elements’ titles. */
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results to only elements that have been soft-deleted. */
  trashed?: InputMaybe<Scalars['Boolean']>;
  /** Narrows the query results based on the elements’ UIDs. */
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Determines whether only elements with unique IDs should be returned by the query. */
  unique?: InputMaybe<Scalars['Boolean']>;
  /** Narrows the query results based on the user the assets were uploaded by, per the user’s ID. */
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  /** Narrows the query results based on the elements’ URIs. */
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results based on the volumes the assets belong to, per the volumes’ handles. */
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results based on the volumes the assets belong to, per the volumes’ IDs. */
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results based on the assets’ image widths. */
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** A list of transform handles to preload. */
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** This is the interface implemented by all assets. */
export type AssetInterface = {
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the asset file was last modified. */
  dateModified?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** This queries for a single embedded asset. */
  embeddedAsset?: Maybe<EmbeddedAssetInterface>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The file extension for the asset file. */
  extension?: Maybe<Scalars['String']>;
  /** The filename of the asset file. */
  filename?: Maybe<Scalars['String']>;
  /** The focal point represented as an array with `x` and `y` keys, or null if it’s not an image. */
  focalPoint?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** The ID of the folder that the asset belongs to. */
  folderId?: Maybe<Scalars['Int']>;
  /** Whether a user-defined focal point is set on the asset. */
  hasFocalPoint?: Maybe<Scalars['Boolean']>;
  /** The height in pixels or null if it’s not an image. */
  height?: Maybe<Scalars['Int']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** An `<img>` tag based on this asset. */
  img?: Maybe<Scalars['String']>;
  /** The file kind. */
  kind?: Maybe<Scalars['String']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The file’s MIME type, if it can be determined. */
  mimeType?: Maybe<Scalars['String']>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<AssetInterface>;
  /** The asset’s path in the volume. */
  path?: Maybe<Scalars['String']>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<AssetInterface>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The file size in bytes. */
  size?: Maybe<Scalars['String']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** Returns a `srcset` attribute value based on the given widths or x-descriptors. */
  srcset?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The user who first added this asset (if known). */
  uploader?: Maybe<UserInterface>;
  /** The ID of the user who first added this asset (if known). */
  uploaderId?: Maybe<Scalars['Int']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  /** The full URL of the asset. This field accepts the same fields as the `transform` directive. */
  url?: Maybe<Scalars['String']>;
  /** The ID of the volume that the asset belongs to. */
  volumeId?: Maybe<Scalars['Int']>;
  /** The width in pixels or null if it’s not an image. */
  width?: Maybe<Scalars['Int']>;
};


/** This is the interface implemented by all assets. */
export type AssetInterface_CountArgs = {
  field: Scalars['String'];
};


/** This is the interface implemented by all assets. */
export type AssetInterfaceHeightArgs = {
  format?: InputMaybe<Scalars['String']>;
  handle?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  immediately?: InputMaybe<Scalars['Boolean']>;
  interlace?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  quality?: InputMaybe<Scalars['Int']>;
  transform?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};


/** This is the interface implemented by all assets. */
export type AssetInterfaceNextArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** This is the interface implemented by all assets. */
export type AssetInterfacePrevArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** This is the interface implemented by all assets. */
export type AssetInterfaceSrcsetArgs = {
  sizes: Array<Scalars['String']>;
};


/** This is the interface implemented by all assets. */
export type AssetInterfaceUploaderArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  email?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasPhoto?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  username?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** This is the interface implemented by all assets. */
export type AssetInterfaceUrlArgs = {
  format?: InputMaybe<Scalars['String']>;
  handle?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  immediately?: InputMaybe<Scalars['Boolean']>;
  interlace?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  quality?: InputMaybe<Scalars['Int']>;
  transform?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};


/** This is the interface implemented by all assets. */
export type AssetInterfaceWidthArgs = {
  format?: InputMaybe<Scalars['String']>;
  handle?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  immediately?: InputMaybe<Scalars['Boolean']>;
  interlace?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  quality?: InputMaybe<Scalars['Int']>;
  transform?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type CategoryCriteriaInput = {
  /** Narrows the query results to only elements that are up to a certain distance away from the element in its structure specified by `ancestorOf`. */
  ancestorDist?: InputMaybe<Scalars['Int']>;
  /** Narrows the query results to only elements that are ancestors of another element in its structure, provided by its ID. */
  ancestorOf?: InputMaybe<Scalars['Int']>;
  /** Narrows the query results to only elements that have been archived. */
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results based on the elements’ creation dates. */
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results based on the elements’ last-updated dates. */
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results to only elements that are up to a certain distance away from the element in its structure specified by `descendantOf`. */
  descendantDist?: InputMaybe<Scalars['Int']>;
  /** Narrows the query results to only elements that are descendants of another element in its structure provided by its ID. */
  descendantOf?: InputMaybe<Scalars['Int']>;
  /** Whether to only return categories that the user has permission to edit. */
  editable?: InputMaybe<Scalars['Boolean']>;
  /** Narrows the query results based on whether the elements are enabled in the site they’re being queried in, per the `site` argument. */
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  /** Causes the query results to be returned in the order specified by the `id` argument. */
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  /** Narrows the query results based on the category groups the categories belong to per the group’s handles. */
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results based on the category groups the categories belong to, per the groups’ IDs. */
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results based on whether the elements have any descendants in their structure. */
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  /** Narrows the query results based on the elements’ IDs. */
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Causes the query results to be returned in reverse order. */
  inReverse?: InputMaybe<Scalars['Boolean']>;
  /** Narrows the query results based on whether the elements are “leaves” in their structure (element with no descendants). */
  leaves?: InputMaybe<Scalars['Boolean']>;
  /** Narrows the query results based on the elements’ level within the structure. */
  level?: InputMaybe<Scalars['Int']>;
  /** Sets the limit for paginated results. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Narrows the query results to only the entry that comes immediately after another element in its structure, provided by its ID. */
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  /** Sets the offset for paginated results. */
  offset?: InputMaybe<Scalars['Int']>;
  /** Sets the field the returned elements should be ordered by. */
  orderBy?: InputMaybe<Scalars['String']>;
  /** Narrows the query results to only entries that are positioned after another element in its structure, provided by its ID. */
  positionedAfter?: InputMaybe<Scalars['Int']>;
  /** Narrows the query results to only entries that are positioned before another element in its structure, provided by its ID. */
  positionedBefore?: InputMaybe<Scalars['Int']>;
  /** Determines which site should be selected when querying multi-site elements. */
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results to only the entry that comes immediately before another element in its structure, provided by its ID. */
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  /** Narrows the query results based on a reference string. */
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results to elements that relate to the provided element IDs. This argument is ignored, if `relatedToAll` is also used. */
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results to elements that relate to *all* of the provided element IDs. Using this argument will cause `relatedTo` argument to be ignored. **This argument is deprecated.** `relatedTo: ["and", ...ids]` should be used instead. */
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results to elements that relate to an asset list defined with this argument. */
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  /** Narrows the query results to elements that relate to a category list defined with this argument. */
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  /** Narrows the query results to elements that relate to an entry list defined with this argument. */
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  /** Narrows the query results to elements that relate to a tag list defined with this argument. */
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  /** Narrows the query results to elements that relate to a use list defined with this argument. */
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  /** Narrows the query results to only elements that match a search query. */
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results based on the unique identifier for an element-site relation. */
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results based on the elements’ slugs. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results based on the elements’ statuses. */
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Determines which structure data should be joined into the query. */
  structureId?: InputMaybe<Scalars['Int']>;
  /** Narrows the query results based on the elements’ titles. */
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results to only elements that have been soft-deleted. */
  trashed?: InputMaybe<Scalars['Boolean']>;
  /** Narrows the query results based on the elements’ UIDs. */
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Determines whether only elements with unique IDs should be returned by the query. */
  unique?: InputMaybe<Scalars['Boolean']>;
  /** Narrows the query results based on the elements’ URIs. */
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Explicitly determines whether the query should join in the structure data. */
  withStructure?: InputMaybe<Scalars['Boolean']>;
};

/** This is the interface implemented by all categories. */
export type CategoryInterface = {
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The category’s children. */
  children?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The handle of the group that contains the category. */
  groupHandle?: Maybe<Scalars['String']>;
  /** The ID of the group that contains the category. */
  groupId?: Maybe<Scalars['Int']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']>;
  /** The same element in other locales. */
  localized?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<CategoryInterface>;
  /** The category’s parent. */
  parent?: Maybe<CategoryInterface>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<CategoryInterface>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']>;
};


/** This is the interface implemented by all categories. */
export type CategoryInterface_CountArgs = {
  field: Scalars['String'];
};


/** This is the interface implemented by all categories. */
export type CategoryInterfaceChildrenArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


/** This is the interface implemented by all categories. */
export type CategoryInterfaceLocalizedArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


/** This is the interface implemented by all categories. */
export type CategoryInterfaceNextArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


/** This is the interface implemented by all categories. */
export type CategoryInterfaceParentArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


/** This is the interface implemented by all categories. */
export type CategoryInterfacePrevArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Element = ElementInterface & {
  __typename: 'Element';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
};


export type Element_CountArgs = {
  field: Scalars['String'];
};

/** This is the interface implemented by all elements. */
export type ElementInterface = {
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
};


/** This is the interface implemented by all elements. */
export type ElementInterface_CountArgs = {
  field: Scalars['String'];
};

export type EmbeddedAsset = EmbeddedAssetInterface & {
  __typename: 'EmbeddedAsset';
  /** The aspect ratio for the embedded asset. */
  aspectRatio?: Maybe<Scalars['Float']>;
  /** The author name for the embedded asset. */
  authorName?: Maybe<Scalars['String']>;
  /** The author URL for the embedded asset. */
  authorUrl?: Maybe<Scalars['String']>;
  /** The code for the embedded asset. */
  code?: Maybe<Scalars['String']>;
  /** The description of the embedded asset. */
  description?: Maybe<Scalars['String']>;
  /** The feeds for the embedded asset. */
  feeds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The height for the embedded asset. */
  height?: Maybe<Scalars['Int']>;
  /** The embed HTML for the embedded asset. */
  html?: Maybe<Scalars['String']>;
  /** The embed code for the embedded asset, if the embedded asset's code is an iframe. */
  iframeCode?: Maybe<Scalars['String']>;
  /** The embed URL for the embedded asset, if the embedded asset's code is an iframe. */
  iframeSrc?: Maybe<Scalars['String']>;
  /** The image for the embedded asset. */
  image?: Maybe<Scalars['String']>;
  /** The image height for the embedded asset. */
  imageHeight?: Maybe<Scalars['Int']>;
  /** The image width for the embedded asset. */
  imageWidth?: Maybe<Scalars['Int']>;
  /** The images for the embedded asset. */
  images?: Maybe<Array<Maybe<EmbeddedAssetImageInterface>>>;
  /** Whether or not the the embed code is safe to use. */
  isSafe?: Maybe<Scalars['Boolean']>;
  /** The license for the embedded asset. */
  license?: Maybe<Scalars['String']>;
  /** The provider icon for the embedded asset. */
  providerIcon?: Maybe<Scalars['String']>;
  /** The provider icons for the embedded asset. */
  providerIcons?: Maybe<Array<Maybe<EmbeddedAssetImageInterface>>>;
  /** The provider name for the embedded asset. */
  providerName?: Maybe<Scalars['String']>;
  /** The provider URL for the embedded asset. */
  providerUrl?: Maybe<Scalars['String']>;
  /** The published time of the embedded asset. */
  publishedTime?: Maybe<Scalars['String']>;
  /** The tags for the embedded asset. */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The title of the embedded asset. */
  title?: Maybe<Scalars['String']>;
  /** The type of the embedded asset. */
  type?: Maybe<Scalars['String']>;
  /** The url of the embedded asset. */
  url?: Maybe<Scalars['String']>;
  /** The width for the embedded asset. */
  width?: Maybe<Scalars['Int']>;
};


export type EmbeddedAssetIframeCodeArgs = {
  params: Array<InputMaybe<Scalars['String']>>;
};


export type EmbeddedAssetIframeSrcArgs = {
  params: Array<InputMaybe<Scalars['String']>>;
};

/** Embedded asset image data */
export type EmbeddedAssetImage = EmbeddedAssetImageInterface & {
  __typename: 'EmbeddedAssetImage';
  /** The height of the image. */
  height?: Maybe<Scalars['Int']>;
  /** The MIME type of the image. */
  mime?: Maybe<Scalars['String']>;
  /** The size of the image. */
  size?: Maybe<Scalars['Int']>;
  /** The URL of the image. */
  url?: Maybe<Scalars['String']>;
  /** The width of the image. */
  width?: Maybe<Scalars['Int']>;
};

/** This is the interface implemented by all embedded asset images. */
export type EmbeddedAssetImageInterface = {
  /** The height of the image. */
  height?: Maybe<Scalars['Int']>;
  /** The MIME type of the image. */
  mime?: Maybe<Scalars['String']>;
  /** The size of the image. */
  size?: Maybe<Scalars['Int']>;
  /** The URL of the image. */
  url?: Maybe<Scalars['String']>;
  /** The width of the image. */
  width?: Maybe<Scalars['Int']>;
};

/** This is the interface implemented by all embedded assets. */
export type EmbeddedAssetInterface = {
  /** The aspect ratio for the embedded asset. */
  aspectRatio?: Maybe<Scalars['Float']>;
  /** The author name for the embedded asset. */
  authorName?: Maybe<Scalars['String']>;
  /** The author URL for the embedded asset. */
  authorUrl?: Maybe<Scalars['String']>;
  /** The code for the embedded asset. */
  code?: Maybe<Scalars['String']>;
  /** The description of the embedded asset. */
  description?: Maybe<Scalars['String']>;
  /** The feeds for the embedded asset. */
  feeds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The height for the embedded asset. */
  height?: Maybe<Scalars['Int']>;
  /** The embed HTML for the embedded asset. */
  html?: Maybe<Scalars['String']>;
  /** The embed code for the embedded asset, if the embedded asset's code is an iframe. */
  iframeCode?: Maybe<Scalars['String']>;
  /** The embed URL for the embedded asset, if the embedded asset's code is an iframe. */
  iframeSrc?: Maybe<Scalars['String']>;
  /** The image for the embedded asset. */
  image?: Maybe<Scalars['String']>;
  /** The image height for the embedded asset. */
  imageHeight?: Maybe<Scalars['Int']>;
  /** The image width for the embedded asset. */
  imageWidth?: Maybe<Scalars['Int']>;
  /** The images for the embedded asset. */
  images?: Maybe<Array<Maybe<EmbeddedAssetImageInterface>>>;
  /** Whether or not the the embed code is safe to use. */
  isSafe?: Maybe<Scalars['Boolean']>;
  /** The license for the embedded asset. */
  license?: Maybe<Scalars['String']>;
  /** The provider icon for the embedded asset. */
  providerIcon?: Maybe<Scalars['String']>;
  /** The provider icons for the embedded asset. */
  providerIcons?: Maybe<Array<Maybe<EmbeddedAssetImageInterface>>>;
  /** The provider name for the embedded asset. */
  providerName?: Maybe<Scalars['String']>;
  /** The provider URL for the embedded asset. */
  providerUrl?: Maybe<Scalars['String']>;
  /** The published time of the embedded asset. */
  publishedTime?: Maybe<Scalars['String']>;
  /** The tags for the embedded asset. */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The title of the embedded asset. */
  title?: Maybe<Scalars['String']>;
  /** The type of the embedded asset. */
  type?: Maybe<Scalars['String']>;
  /** The url of the embedded asset. */
  url?: Maybe<Scalars['String']>;
  /** The width for the embedded asset. */
  width?: Maybe<Scalars['Int']>;
};


/** This is the interface implemented by all embedded assets. */
export type EmbeddedAssetInterfaceIframeCodeArgs = {
  params: Array<InputMaybe<Scalars['String']>>;
};


/** This is the interface implemented by all embedded assets. */
export type EmbeddedAssetInterfaceIframeSrcArgs = {
  params: Array<InputMaybe<Scalars['String']>>;
};

export type EntryCriteriaInput = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results to only entries that were posted on or after a certain date. */
  after?: InputMaybe<Scalars['String']>;
  /** Narrows the query results to only elements that are up to a certain distance away from the element in its structure specified by `ancestorOf`. */
  ancestorDist?: InputMaybe<Scalars['Int']>;
  /** Narrows the query results to only elements that are ancestors of another element in its structure, provided by its ID. */
  ancestorOf?: InputMaybe<Scalars['Int']>;
  /** Narrows the query results to only elements that have been archived. */
  archived?: InputMaybe<Scalars['Boolean']>;
  /** Narrows the query results based on the user group the entries’ authors belong to. */
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results based on the user group the entries’ authors belong to, per the groups’ IDs. */
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results based on the entries’ authors. */
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results to only entries that were posted before a certain date. */
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results based on the elements’ creation dates. */
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results based on the elements’ last-updated dates. */
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results to only elements that are up to a certain distance away from the element in its structure specified by `descendantOf`. */
  descendantDist?: InputMaybe<Scalars['Int']>;
  /** Narrows the query results to only elements that are descendants of another element in its structure provided by its ID. */
  descendantOf?: InputMaybe<Scalars['Int']>;
  /** The drafts’ creator ID */
  draftCreator?: InputMaybe<Scalars['Int']>;
  /** The ID of the draft to return (from the `drafts` table) */
  draftId?: InputMaybe<Scalars['Int']>;
  /** Narrows the query results to only drafts of a given element.  Set to `false` to fetch unpublished drafts. */
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  /** Whether draft elements should be returned. */
  drafts?: InputMaybe<Scalars['Boolean']>;
  /** Whether to only return entries that the user has permission to edit. */
  editable?: InputMaybe<Scalars['Boolean']>;
  /** Narrows the query results based on whether the elements are enabled in the site they’re being queried in, per the `site` argument. */
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results based on the entries’ expiry dates. */
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Causes the query results to be returned in the order specified by the `id` argument. */
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results based on whether the elements have any descendants in their structure. */
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  /** Narrows the query results based on the elements’ IDs. */
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Causes the query results to be returned in reverse order. */
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results based on whether the elements are “leaves” in their structure (element with no descendants). */
  leaves?: InputMaybe<Scalars['Boolean']>;
  /** Narrows the query results based on the elements’ level within the structure. */
  level?: InputMaybe<Scalars['Int']>;
  /** Sets the limit for paginated results. */
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results to only the entry that comes immediately after another element in its structure, provided by its ID. */
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  /** Sets the offset for paginated results. */
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Sets the field the returned elements should be ordered by. */
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results to only entries that are positioned after another element in its structure, provided by its ID. */
  positionedAfter?: InputMaybe<Scalars['Int']>;
  /** Narrows the query results to only entries that are positioned before another element in its structure, provided by its ID. */
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results based on the entries’ post dates. */
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Determines which site should be selected when querying multi-site elements. */
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results to only the entry that comes immediately before another element in its structure, provided by its ID. */
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Whether provisional drafts should be returned. */
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results based on a reference string. */
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results to elements that relate to the provided element IDs. This argument is ignored, if `relatedToAll` is also used. */
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results to elements that relate to *all* of the provided element IDs. Using this argument will cause `relatedTo` argument to be ignored. **This argument is deprecated.** `relatedTo: ["and", ...ids]` should be used instead. */
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results to elements that relate to an asset list defined with this argument. */
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  /** Narrows the query results to elements that relate to a category list defined with this argument. */
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  /** Narrows the query results to elements that relate to an entry list defined with this argument. */
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  /** Narrows the query results to elements that relate to a tag list defined with this argument. */
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  /** Narrows the query results to elements that relate to a use list defined with this argument. */
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  /** The revisions’ creator ID */
  revisionCreator?: InputMaybe<Scalars['Int']>;
  /** The ID of the revision to return (from the `revisions` table) */
  revisionId?: InputMaybe<Scalars['Int']>;
  /** The source element ID that revisions should be returned for */
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  /** Whether revision elements should be returned. */
  revisions?: InputMaybe<Scalars['Boolean']>;
  /** Narrows the query results to only elements that match a search query. */
  search?: InputMaybe<Scalars['String']>;
  /** Narrows the query results based on the section handles the entries belong to. */
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results based on the sections the entries belong to, per the sections’ IDs. */
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results based on the unique identifier for an element-site relation. */
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results based on the elements’ slugs. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results based on the elements’ statuses. */
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Determines which structure data should be joined into the query. */
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results based on the elements’ titles. */
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results to only elements that have been soft-deleted. */
  trashed?: InputMaybe<Scalars['Boolean']>;
  /** Narrows the query results based on the entries’ entry type handles. */
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results based on the entries’ entry types, per the types’ IDs. */
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results based on the elements’ UIDs. */
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Determines whether only elements with unique IDs should be returned by the query. */
  unique?: InputMaybe<Scalars['Boolean']>;
  /** Narrows the query results based on the elements’ URIs. */
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Explicitly determines whether the query should join in the structure data. */
  withStructure?: InputMaybe<Scalars['Boolean']>;
};

/** This is the interface implemented by all entries. */
export type EntryInterface = {
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The entry’s author. */
  author?: Maybe<UserInterface>;
  /** The ID of the author of this entry. */
  authorId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical ID. */
  canonicalId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical UUID. */
  canonicalUid?: Maybe<Scalars['String']>;
  /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
  children?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The current revision for the entry. */
  currentRevision?: Maybe<EntryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The creator of a given draft. */
  draftCreator?: Maybe<UserInterface>;
  /** The draft ID (from the `drafts` table). */
  draftId?: Maybe<Scalars['Int']>;
  /** The name of the draft. */
  draftName?: Maybe<Scalars['String']>;
  /** The notes for the draft. */
  draftNotes?: Maybe<Scalars['String']>;
  /** The drafts for the entry. */
  drafts?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The expiry date of the entry. */
  expiryDate?: Maybe<Scalars['DateTime']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** Returns whether this is a draft. */
  isDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is a revision. */
  isRevision?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. */
  isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. **This field is deprecated.** `isUnpublishedDraft` should be used instead. */
  isUnsavedDraft?: Maybe<Scalars['Boolean']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']>;
  /** The same element in other locales. */
  localized?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<EntryInterface>;
  /** The entry’s parent, if the section is a structure. */
  parent?: Maybe<EntryInterface>;
  /** The entry’s post date. */
  postDate?: Maybe<Scalars['DateTime']>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<EntryInterface>;
  /** The creator of a given revision. */
  revisionCreator?: Maybe<UserInterface>;
  /** The revision ID (from the `revisions` table). */
  revisionId?: Maybe<Scalars['Int']>;
  /** The revisions for the entry. */
  revisions?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The handle of the section that contains the entry. */
  sectionHandle?: Maybe<Scalars['String']>;
  /** The ID of the section that contains the entry. */
  sectionId?: Maybe<Scalars['Int']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /**
   * Returns the entry’s canonical ID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
   */
  sourceId?: Maybe<Scalars['Int']>;
  /**
   * Returns the entry’s canonical UUID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
   */
  sourceUid?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the entry type that contains the entry. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the entry type that contains the entry. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']>;
};


/** This is the interface implemented by all entries. */
export type EntryInterface_CountArgs = {
  field: Scalars['String'];
};


/** This is the interface implemented by all entries. */
export type EntryInterfaceAncestorsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


/** This is the interface implemented by all entries. */
export type EntryInterfaceChildrenArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


/** This is the interface implemented by all entries. */
export type EntryInterfaceDescendantsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


/** This is the interface implemented by all entries. */
export type EntryInterfaceDraftsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


/** This is the interface implemented by all entries. */
export type EntryInterfaceLocalizedArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


/** This is the interface implemented by all entries. */
export type EntryInterfaceNextArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


/** This is the interface implemented by all entries. */
export type EntryInterfaceParentArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


/** This is the interface implemented by all entries. */
export type EntryInterfacePrevArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


/** This is the interface implemented by all entries. */
export type EntryInterfaceRevisionsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Ether_SeoKeyword = {
  __typename: 'Ether_SEOKeyword';
  keyword?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['String']>;
};

/** Robots and canonical data */
export type Ether_SeoAdvanced = {
  __typename: 'Ether_SeoAdvanced';
  canonical?: Maybe<Scalars['String']>;
  robots?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Ether_SeoData = {
  __typename: 'Ether_SeoData';
  advanced?: Maybe<Ether_SeoAdvanced>;
  description?: Maybe<Scalars['String']>;
  keywords?: Maybe<Array<Maybe<Ether_SeoKeyword>>>;
  social?: Maybe<Ether_SeoSocialNetworks>;
  title?: Maybe<Scalars['String']>;
};

/** Social data for an individual Social network */
export type Ether_SeoSocialData = {
  __typename: 'Ether_SeoSocialData';
  description?: Maybe<Scalars['String']>;
  image?: Maybe<AssetInterface>;
  title?: Maybe<Scalars['String']>;
};

export type Ether_SeoSocialNetworks = {
  __typename: 'Ether_SeoSocialNetworks';
  facebook?: Maybe<Ether_SeoSocialData>;
  twitter?: Maybe<Ether_SeoSocialData>;
};

export type FieldAttribute = {
  __typename: 'FieldAttribute';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** This is the interface implemented by all fields. */
export type FieldInterface = {
  /** The field’s conditions. */
  conditions?: Maybe<Scalars['String']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']>;
  /** The field’s display name. */
  displayName?: Maybe<Scalars['String']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s GQL input name. */
  inputTypeName?: Maybe<Scalars['String']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']>;
  /** The field’s instructions position. */
  instructionsPosition?: Maybe<Scalars['String']>;
  /** The field’s label position. */
  labelPosition?: Maybe<Scalars['String']>;
  /** Whether the field should limit content. */
  limit?: Maybe<Scalars['Boolean']>;
  /** The field’s limit amount. */
  limitAmount?: Maybe<Scalars['Int']>;
  /** The field’s limit type. */
  limitType?: Maybe<Scalars['String']>;
  /** The field’s name. */
  name?: Maybe<Scalars['String']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']>;
  /** The field’s GQL type. */
  typeName?: Maybe<Scalars['String']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']>;
};

export type Field_Address = FieldInterface & {
  __typename: 'Field_Address';
  address1Collapsed?: Maybe<Scalars['Boolean']>;
  address1DefaultValue?: Maybe<Scalars['String']>;
  address1Enabled?: Maybe<Scalars['Boolean']>;
  address1ErrorMessage?: Maybe<Scalars['String']>;
  address1Hidden?: Maybe<Scalars['Boolean']>;
  address1Label?: Maybe<Scalars['String']>;
  address1Placeholder?: Maybe<Scalars['String']>;
  address1PrePopulate?: Maybe<Scalars['String']>;
  address1Required?: Maybe<Scalars['Boolean']>;
  address2Collapsed?: Maybe<Scalars['Boolean']>;
  address2DefaultValue?: Maybe<Scalars['String']>;
  address2Enabled?: Maybe<Scalars['Boolean']>;
  address2ErrorMessage?: Maybe<Scalars['String']>;
  address2Hidden?: Maybe<Scalars['Boolean']>;
  address2Label?: Maybe<Scalars['String']>;
  address2Placeholder?: Maybe<Scalars['String']>;
  address2PrePopulate?: Maybe<Scalars['String']>;
  address2Required?: Maybe<Scalars['Boolean']>;
  address3Collapsed?: Maybe<Scalars['Boolean']>;
  address3DefaultValue?: Maybe<Scalars['String']>;
  address3Enabled?: Maybe<Scalars['Boolean']>;
  address3ErrorMessage?: Maybe<Scalars['String']>;
  address3Hidden?: Maybe<Scalars['Boolean']>;
  address3Label?: Maybe<Scalars['String']>;
  address3Placeholder?: Maybe<Scalars['String']>;
  address3PrePopulate?: Maybe<Scalars['String']>;
  address3Required?: Maybe<Scalars['Boolean']>;
  autocompleteCollapsed?: Maybe<Scalars['Boolean']>;
  autocompleteCurrentLocation?: Maybe<Scalars['String']>;
  autocompleteDefaultValue?: Maybe<Scalars['String']>;
  autocompleteEnabled?: Maybe<Scalars['Boolean']>;
  autocompleteErrorMessage?: Maybe<Scalars['String']>;
  autocompleteIntegration?: Maybe<Scalars['String']>;
  autocompleteLabel?: Maybe<Scalars['String']>;
  autocompletePlaceholder?: Maybe<Scalars['String']>;
  autocompletePrePopulate?: Maybe<Scalars['String']>;
  autocompleteRequired?: Maybe<Scalars['String']>;
  cityCollapsed?: Maybe<Scalars['Boolean']>;
  cityDefaultValue?: Maybe<Scalars['String']>;
  cityEnabled?: Maybe<Scalars['Boolean']>;
  cityErrorMessage?: Maybe<Scalars['String']>;
  cityHidden?: Maybe<Scalars['Boolean']>;
  cityLabel?: Maybe<Scalars['String']>;
  cityPlaceholder?: Maybe<Scalars['String']>;
  cityPrePopulate?: Maybe<Scalars['String']>;
  cityRequired?: Maybe<Scalars['Boolean']>;
  columnWidth?: Maybe<Scalars['String']>;
  conditions?: Maybe<Scalars['String']>;
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  countryCollapsed?: Maybe<Scalars['Boolean']>;
  countryDefaultValue?: Maybe<Scalars['String']>;
  countryEnabled?: Maybe<Scalars['Boolean']>;
  countryErrorMessage?: Maybe<Scalars['String']>;
  countryHidden?: Maybe<Scalars['Boolean']>;
  countryLabel?: Maybe<Scalars['String']>;
  countryOptions?: Maybe<Array<Maybe<FieldAttribute>>>;
  countryPlaceholder?: Maybe<Scalars['String']>;
  countryPrePopulate?: Maybe<Scalars['String']>;
  countryRequired?: Maybe<Scalars['Boolean']>;
  cssClasses?: Maybe<Scalars['String']>;
  defaultValue?: Maybe<Scalars['String']>;
  /** The field’s display name. */
  displayName?: Maybe<Scalars['String']>;
  enableAutocomplete?: Maybe<Scalars['String']>;
  enableConditions?: Maybe<Scalars['Boolean']>;
  enableContentEncryption?: Maybe<Scalars['Boolean']>;
  errorMessage?: Maybe<Scalars['String']>;
  formId?: Maybe<Scalars['String']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  includeInEmail?: Maybe<Scalars['Boolean']>;
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s GQL input name. */
  inputTypeName?: Maybe<Scalars['String']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']>;
  instructionsPosition?: Maybe<Scalars['String']>;
  isNested?: Maybe<Scalars['String']>;
  labelPosition?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Boolean']>;
  limitAmount?: Maybe<Scalars['Int']>;
  limitType?: Maybe<Scalars['String']>;
  matchField?: Maybe<Scalars['String']>;
  /** The field’s name. */
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  prePopulate?: Maybe<Scalars['String']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']>;
  stateCollapsed?: Maybe<Scalars['Boolean']>;
  stateDefaultValue?: Maybe<Scalars['String']>;
  stateEnabled?: Maybe<Scalars['Boolean']>;
  stateErrorMessage?: Maybe<Scalars['String']>;
  stateHidden?: Maybe<Scalars['Boolean']>;
  stateLabel?: Maybe<Scalars['String']>;
  statePlaceholder?: Maybe<Scalars['String']>;
  statePrePopulate?: Maybe<Scalars['String']>;
  stateRequired?: Maybe<Scalars['Boolean']>;
  subfieldLabelPosition?: Maybe<Scalars['String']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']>;
  /** The field’s GQL type. */
  typeName?: Maybe<Scalars['String']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  visibility?: Maybe<Scalars['String']>;
  zipCollapsed?: Maybe<Scalars['Boolean']>;
  zipDefaultValue?: Maybe<Scalars['String']>;
  zipEnabled?: Maybe<Scalars['Boolean']>;
  zipErrorMessage?: Maybe<Scalars['String']>;
  zipHidden?: Maybe<Scalars['Boolean']>;
  zipLabel?: Maybe<Scalars['String']>;
  zipPlaceholder?: Maybe<Scalars['String']>;
  zipPrePopulate?: Maybe<Scalars['String']>;
  zipRequired?: Maybe<Scalars['Boolean']>;
};

export type Field_Agree = FieldInterface & {
  __typename: 'Field_Agree';
  checkedValue?: Maybe<Scalars['String']>;
  columnWidth?: Maybe<Scalars['String']>;
  conditions?: Maybe<Scalars['String']>;
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  cssClasses?: Maybe<Scalars['String']>;
  defaultState?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  descriptionHtml?: Maybe<Scalars['String']>;
  /** The field’s display name. */
  displayName?: Maybe<Scalars['String']>;
  enableConditions?: Maybe<Scalars['Boolean']>;
  enableContentEncryption?: Maybe<Scalars['Boolean']>;
  errorMessage?: Maybe<Scalars['String']>;
  formId?: Maybe<Scalars['String']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  includeInEmail?: Maybe<Scalars['Boolean']>;
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s GQL input name. */
  inputTypeName?: Maybe<Scalars['String']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']>;
  instructionsPosition?: Maybe<Scalars['String']>;
  isNested?: Maybe<Scalars['String']>;
  labelPosition?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Boolean']>;
  limitAmount?: Maybe<Scalars['Int']>;
  limitType?: Maybe<Scalars['String']>;
  matchField?: Maybe<Scalars['String']>;
  /** The field’s name. */
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  prePopulate?: Maybe<Scalars['String']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']>;
  /** The field’s GQL type. */
  typeName?: Maybe<Scalars['String']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  uncheckedValue?: Maybe<Scalars['String']>;
  visibility?: Maybe<Scalars['String']>;
};

export type Field_Categories = FieldInterface & {
  __typename: 'Field_Categories';
  allowLimit?: Maybe<Scalars['String']>;
  allowMultipleSources?: Maybe<Scalars['String']>;
  allowSelfRelations?: Maybe<Scalars['String']>;
  branchLimit?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  columnWidth?: Maybe<Scalars['String']>;
  conditions?: Maybe<Scalars['String']>;
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  cssClasses?: Maybe<Scalars['String']>;
  defaultCategory?: Maybe<CategoryInterface>;
  /** The field’s display name. */
  displayName?: Maybe<Scalars['String']>;
  displayType?: Maybe<Scalars['String']>;
  enableConditions?: Maybe<Scalars['Boolean']>;
  enableContentEncryption?: Maybe<Scalars['Boolean']>;
  errorMessage?: Maybe<Scalars['String']>;
  formId?: Maybe<Scalars['String']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  includeInEmail?: Maybe<Scalars['Boolean']>;
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s GQL input name. */
  inputTypeName?: Maybe<Scalars['String']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']>;
  instructionsPosition?: Maybe<Scalars['String']>;
  isNested?: Maybe<Scalars['String']>;
  labelPosition?: Maybe<Scalars['String']>;
  labelSource?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Boolean']>;
  limitAmount?: Maybe<Scalars['Int']>;
  limitOptions?: Maybe<Scalars['String']>;
  limitType?: Maybe<Scalars['String']>;
  localizeRelations?: Maybe<Scalars['String']>;
  matchField?: Maybe<Scalars['String']>;
  multiple?: Maybe<Scalars['Boolean']>;
  /** The field’s name. */
  name?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  prePopulate?: Maybe<Scalars['String']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']>;
  rootCategory?: Maybe<CategoryInterface>;
  searchable?: Maybe<Scalars['String']>;
  selectionLabel?: Maybe<Scalars['String']>;
  showSiteMenu?: Maybe<Scalars['String']>;
  showStructure?: Maybe<Scalars['Boolean']>;
  source?: Maybe<Scalars['String']>;
  sources?: Maybe<Scalars['String']>;
  targetSiteId?: Maybe<Scalars['String']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']>;
  /** The field’s GQL type. */
  typeName?: Maybe<Scalars['String']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  validateRelatedElements?: Maybe<Scalars['String']>;
  viewMode?: Maybe<Scalars['String']>;
  visibility?: Maybe<Scalars['String']>;
};


export type Field_CategoriesCategoriesArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Field_CategoriesDefaultCategoryArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Field_CategoriesRootCategoryArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Field_Checkboxes = FieldInterface & {
  __typename: 'Field_Checkboxes';
  columnWidth?: Maybe<Scalars['String']>;
  conditions?: Maybe<Scalars['String']>;
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  cssClasses?: Maybe<Scalars['String']>;
  defaultValue?: Maybe<Scalars['String']>;
  /** The field’s display name. */
  displayName?: Maybe<Scalars['String']>;
  enableConditions?: Maybe<Scalars['Boolean']>;
  enableContentEncryption?: Maybe<Scalars['Boolean']>;
  errorMessage?: Maybe<Scalars['String']>;
  formId?: Maybe<Scalars['String']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  includeInEmail?: Maybe<Scalars['Boolean']>;
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s GQL input name. */
  inputTypeName?: Maybe<Scalars['String']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']>;
  instructionsPosition?: Maybe<Scalars['String']>;
  isNested?: Maybe<Scalars['String']>;
  labelPosition?: Maybe<Scalars['String']>;
  layout?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Boolean']>;
  limitAmount?: Maybe<Scalars['Int']>;
  limitType?: Maybe<Scalars['String']>;
  matchField?: Maybe<Scalars['String']>;
  multi?: Maybe<Scalars['String']>;
  /** The field’s name. */
  name?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Maybe<KeyValueType>>>;
  placeholder?: Maybe<Scalars['String']>;
  prePopulate?: Maybe<Scalars['String']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']>;
  toggleCheckbox?: Maybe<Scalars['String']>;
  toggleCheckboxLabel?: Maybe<Scalars['String']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']>;
  /** The field’s GQL type. */
  typeName?: Maybe<Scalars['String']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  visibility?: Maybe<Scalars['String']>;
};

export type Field_Date = FieldInterface & {
  __typename: 'Field_Date';
  ampmLabel?: Maybe<Scalars['String']>;
  ampmPlaceholder?: Maybe<Scalars['String']>;
  columnWidth?: Maybe<Scalars['String']>;
  conditions?: Maybe<Scalars['String']>;
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  cssClasses?: Maybe<Scalars['String']>;
  dateFormat?: Maybe<Scalars['String']>;
  datePickerOptions?: Maybe<Array<Maybe<KeyValueType>>>;
  dayLabel?: Maybe<Scalars['String']>;
  dayPlaceholder?: Maybe<Scalars['String']>;
  defaultDate?: Maybe<Scalars['DateTime']>;
  defaultOption?: Maybe<Scalars['String']>;
  /** The field’s display name. */
  displayName?: Maybe<Scalars['String']>;
  displayType?: Maybe<Scalars['String']>;
  enableConditions?: Maybe<Scalars['Boolean']>;
  enableContentEncryption?: Maybe<Scalars['Boolean']>;
  errorMessage?: Maybe<Scalars['String']>;
  formId?: Maybe<Scalars['String']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']>;
  hourLabel?: Maybe<Scalars['String']>;
  hourPlaceholder?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  includeDate?: Maybe<Scalars['Boolean']>;
  includeInEmail?: Maybe<Scalars['Boolean']>;
  includeTime?: Maybe<Scalars['Boolean']>;
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s GQL input name. */
  inputTypeName?: Maybe<Scalars['String']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']>;
  instructionsPosition?: Maybe<Scalars['String']>;
  isNested?: Maybe<Scalars['String']>;
  labelPosition?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Boolean']>;
  limitAmount?: Maybe<Scalars['Int']>;
  limitType?: Maybe<Scalars['String']>;
  matchField?: Maybe<Scalars['String']>;
  maxDate?: Maybe<Scalars['DateTime']>;
  minDate?: Maybe<Scalars['DateTime']>;
  minuteLabel?: Maybe<Scalars['String']>;
  minutePlaceholder?: Maybe<Scalars['String']>;
  monthLabel?: Maybe<Scalars['String']>;
  monthPlaceholder?: Maybe<Scalars['String']>;
  /** The field’s name. */
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  prePopulate?: Maybe<Scalars['String']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']>;
  secondLabel?: Maybe<Scalars['String']>;
  secondPlaceholder?: Maybe<Scalars['String']>;
  subfieldLabelPosition?: Maybe<Scalars['String']>;
  timeFormat?: Maybe<Scalars['String']>;
  timeLabel?: Maybe<Scalars['String']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']>;
  /** The field’s GQL type. */
  typeName?: Maybe<Scalars['String']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  useDatePicker?: Maybe<Scalars['Boolean']>;
  visibility?: Maybe<Scalars['String']>;
  yearLabel?: Maybe<Scalars['String']>;
  yearPlaceholder?: Maybe<Scalars['String']>;
};

export type Field_Dropdown = FieldInterface & {
  __typename: 'Field_Dropdown';
  columnWidth?: Maybe<Scalars['String']>;
  conditions?: Maybe<Scalars['String']>;
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  cssClasses?: Maybe<Scalars['String']>;
  defaultValue?: Maybe<Scalars['String']>;
  /** The field’s display name. */
  displayName?: Maybe<Scalars['String']>;
  enableConditions?: Maybe<Scalars['Boolean']>;
  enableContentEncryption?: Maybe<Scalars['Boolean']>;
  errorMessage?: Maybe<Scalars['String']>;
  formId?: Maybe<Scalars['String']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  includeInEmail?: Maybe<Scalars['Boolean']>;
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s GQL input name. */
  inputTypeName?: Maybe<Scalars['String']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']>;
  instructionsPosition?: Maybe<Scalars['String']>;
  isNested?: Maybe<Scalars['String']>;
  labelPosition?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Boolean']>;
  limitAmount?: Maybe<Scalars['Int']>;
  limitType?: Maybe<Scalars['String']>;
  matchField?: Maybe<Scalars['String']>;
  multi?: Maybe<Scalars['String']>;
  multiple?: Maybe<Scalars['Boolean']>;
  /** The field’s name. */
  name?: Maybe<Scalars['String']>;
  optgroups?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Maybe<KeyValueType>>>;
  placeholder?: Maybe<Scalars['String']>;
  prePopulate?: Maybe<Scalars['String']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']>;
  /** The field’s GQL type. */
  typeName?: Maybe<Scalars['String']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  visibility?: Maybe<Scalars['String']>;
};

export type Field_Email = FieldInterface & {
  __typename: 'Field_Email';
  blockedDomains?: Maybe<Array<Maybe<KeyValueType>>>;
  columnWidth?: Maybe<Scalars['String']>;
  conditions?: Maybe<Scalars['String']>;
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  cssClasses?: Maybe<Scalars['String']>;
  defaultValue?: Maybe<Scalars['String']>;
  /** The field’s display name. */
  displayName?: Maybe<Scalars['String']>;
  enableConditions?: Maybe<Scalars['Boolean']>;
  enableContentEncryption?: Maybe<Scalars['Boolean']>;
  errorMessage?: Maybe<Scalars['String']>;
  formId?: Maybe<Scalars['String']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  includeInEmail?: Maybe<Scalars['Boolean']>;
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s GQL input name. */
  inputTypeName?: Maybe<Scalars['String']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']>;
  instructionsPosition?: Maybe<Scalars['String']>;
  isNested?: Maybe<Scalars['String']>;
  labelPosition?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Boolean']>;
  limitAmount?: Maybe<Scalars['Int']>;
  limitType?: Maybe<Scalars['String']>;
  matchField?: Maybe<Scalars['String']>;
  /** The field’s name. */
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  prePopulate?: Maybe<Scalars['String']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']>;
  /** The field’s GQL type. */
  typeName?: Maybe<Scalars['String']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  uniqueValue?: Maybe<Scalars['Boolean']>;
  validateDomain?: Maybe<Scalars['Boolean']>;
  visibility?: Maybe<Scalars['String']>;
};

export type Field_Entries = FieldInterface & {
  __typename: 'Field_Entries';
  allowSelfRelations?: Maybe<Scalars['String']>;
  columnWidth?: Maybe<Scalars['String']>;
  conditions?: Maybe<Scalars['String']>;
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  cssClasses?: Maybe<Scalars['String']>;
  defaultEntry?: Maybe<EntryInterface>;
  /** The field’s display name. */
  displayName?: Maybe<Scalars['String']>;
  displayType?: Maybe<Scalars['String']>;
  enableConditions?: Maybe<Scalars['Boolean']>;
  enableContentEncryption?: Maybe<Scalars['Boolean']>;
  entries?: Maybe<Array<Maybe<EntryInterface>>>;
  errorMessage?: Maybe<Scalars['String']>;
  formId?: Maybe<Scalars['String']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  includeInEmail?: Maybe<Scalars['Boolean']>;
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s GQL input name. */
  inputTypeName?: Maybe<Scalars['String']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']>;
  instructionsPosition?: Maybe<Scalars['String']>;
  isNested?: Maybe<Scalars['String']>;
  labelPosition?: Maybe<Scalars['String']>;
  labelSource?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Boolean']>;
  limitAmount?: Maybe<Scalars['Int']>;
  limitOptions?: Maybe<Scalars['String']>;
  limitType?: Maybe<Scalars['String']>;
  localizeRelations?: Maybe<Scalars['String']>;
  matchField?: Maybe<Scalars['String']>;
  multiple?: Maybe<Scalars['Boolean']>;
  /** The field’s name. */
  name?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  prePopulate?: Maybe<Scalars['String']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']>;
  searchable?: Maybe<Scalars['String']>;
  selectionLabel?: Maybe<Scalars['String']>;
  showSiteMenu?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  sources?: Maybe<Scalars['String']>;
  targetSiteId?: Maybe<Scalars['String']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']>;
  /** The field’s GQL type. */
  typeName?: Maybe<Scalars['String']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  validateRelatedElements?: Maybe<Scalars['String']>;
  viewMode?: Maybe<Scalars['String']>;
  visibility?: Maybe<Scalars['String']>;
};


export type Field_EntriesDefaultEntryArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Field_EntriesEntriesArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Field_FileUpload = FieldInterface & {
  __typename: 'Field_FileUpload';
  allowSelfRelations?: Maybe<Scalars['String']>;
  allowUploads?: Maybe<Scalars['String']>;
  allowedKinds?: Maybe<Array<Maybe<Scalars['String']>>>;
  columnWidth?: Maybe<Scalars['String']>;
  conditions?: Maybe<Scalars['String']>;
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  cssClasses?: Maybe<Scalars['String']>;
  defaultUploadLocationSource?: Maybe<Scalars['String']>;
  defaultUploadLocationSubpath?: Maybe<Scalars['String']>;
  defaultValue?: Maybe<Scalars['String']>;
  /** The field’s display name. */
  displayName?: Maybe<Scalars['String']>;
  displayType?: Maybe<Scalars['String']>;
  enableConditions?: Maybe<Scalars['Boolean']>;
  enableContentEncryption?: Maybe<Scalars['Boolean']>;
  errorMessage?: Maybe<Scalars['String']>;
  formId?: Maybe<Scalars['String']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  includeInEmail?: Maybe<Scalars['Boolean']>;
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s GQL input name. */
  inputTypeName?: Maybe<Scalars['String']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']>;
  instructionsPosition?: Maybe<Scalars['String']>;
  isNested?: Maybe<Scalars['String']>;
  labelPosition?: Maybe<Scalars['String']>;
  labelSource?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Boolean']>;
  limitAmount?: Maybe<Scalars['Int']>;
  limitFiles?: Maybe<Scalars['String']>;
  limitOptions?: Maybe<Scalars['String']>;
  limitType?: Maybe<Scalars['String']>;
  localizeRelations?: Maybe<Scalars['String']>;
  matchField?: Maybe<Scalars['String']>;
  multiple?: Maybe<Scalars['Boolean']>;
  /** The field’s name. */
  name?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  prePopulate?: Maybe<Scalars['String']>;
  previewMode?: Maybe<Scalars['String']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']>;
  restrictFiles?: Maybe<Scalars['String']>;
  searchable?: Maybe<Scalars['String']>;
  selectionLabel?: Maybe<Scalars['String']>;
  showSiteMenu?: Maybe<Scalars['String']>;
  showUnpermittedFiles?: Maybe<Scalars['String']>;
  showUnpermittedVolumes?: Maybe<Scalars['String']>;
  singleUploadLocationSource?: Maybe<Scalars['String']>;
  singleUploadLocationSubpath?: Maybe<Scalars['String']>;
  sizeLimit?: Maybe<Scalars['String']>;
  sizeMinLimit?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  sources?: Maybe<Scalars['String']>;
  targetSiteId?: Maybe<Scalars['String']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']>;
  /** The field’s GQL type. */
  typeName?: Maybe<Scalars['String']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  uploadLocationSource?: Maybe<Scalars['String']>;
  uploadLocationSubpath?: Maybe<Scalars['String']>;
  useSingleFolder?: Maybe<Scalars['String']>;
  validateRelatedElements?: Maybe<Scalars['String']>;
  viewMode?: Maybe<Scalars['String']>;
  visibility?: Maybe<Scalars['String']>;
  volumeHandle?: Maybe<Scalars['String']>;
};

export type Field_Group = FieldInterface & {
  __typename: 'Field_Group';
  columnWidth?: Maybe<Scalars['String']>;
  conditions?: Maybe<Scalars['String']>;
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  contentTable?: Maybe<Scalars['String']>;
  cssClasses?: Maybe<Scalars['String']>;
  defaultValue?: Maybe<Scalars['String']>;
  /** The field’s display name. */
  displayName?: Maybe<Scalars['String']>;
  enableConditions?: Maybe<Scalars['Boolean']>;
  enableContentEncryption?: Maybe<Scalars['Boolean']>;
  errorMessage?: Maybe<Scalars['String']>;
  /** The field’s nested fields. */
  fields?: Maybe<Array<Maybe<FieldInterface>>>;
  formId?: Maybe<Scalars['String']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  includeInEmail?: Maybe<Scalars['Boolean']>;
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s GQL input name. */
  inputTypeName?: Maybe<Scalars['String']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']>;
  instructionsPosition?: Maybe<Scalars['String']>;
  isNested?: Maybe<Scalars['String']>;
  labelPosition?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Boolean']>;
  limitAmount?: Maybe<Scalars['Int']>;
  limitType?: Maybe<Scalars['String']>;
  matchField?: Maybe<Scalars['String']>;
  /** The field’s name. */
  name?: Maybe<Scalars['String']>;
  /** The field’s nested rows. */
  nestedRows?: Maybe<Array<Maybe<RowInterface>>>;
  placeholder?: Maybe<Scalars['String']>;
  prePopulate?: Maybe<Scalars['String']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']>;
  /** The field’s GQL type. */
  typeName?: Maybe<Scalars['String']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  visibility?: Maybe<Scalars['String']>;
};

export type Field_Heading = FieldInterface & {
  __typename: 'Field_Heading';
  columnWidth?: Maybe<Scalars['String']>;
  conditions?: Maybe<Scalars['String']>;
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  cssClasses?: Maybe<Scalars['String']>;
  defaultValue?: Maybe<Scalars['String']>;
  /** The field’s display name. */
  displayName?: Maybe<Scalars['String']>;
  enableConditions?: Maybe<Scalars['Boolean']>;
  enableContentEncryption?: Maybe<Scalars['Boolean']>;
  errorMessage?: Maybe<Scalars['String']>;
  formId?: Maybe<Scalars['String']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']>;
  headingSize?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  includeInEmail?: Maybe<Scalars['Boolean']>;
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s GQL input name. */
  inputTypeName?: Maybe<Scalars['String']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']>;
  instructionsPosition?: Maybe<Scalars['String']>;
  isNested?: Maybe<Scalars['String']>;
  labelPosition?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Boolean']>;
  limitAmount?: Maybe<Scalars['Int']>;
  limitType?: Maybe<Scalars['String']>;
  matchField?: Maybe<Scalars['String']>;
  /** The field’s name. */
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  prePopulate?: Maybe<Scalars['String']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']>;
  /** The field’s GQL type. */
  typeName?: Maybe<Scalars['String']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  visibility?: Maybe<Scalars['String']>;
};

export type Field_Hidden = FieldInterface & {
  __typename: 'Field_Hidden';
  columnType?: Maybe<Scalars['String']>;
  columnWidth?: Maybe<Scalars['String']>;
  conditions?: Maybe<Scalars['String']>;
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  cookieName?: Maybe<Scalars['String']>;
  cssClasses?: Maybe<Scalars['String']>;
  defaultOption?: Maybe<Scalars['String']>;
  defaultValue?: Maybe<Scalars['String']>;
  /** The field’s display name. */
  displayName?: Maybe<Scalars['String']>;
  enableConditions?: Maybe<Scalars['Boolean']>;
  enableContentEncryption?: Maybe<Scalars['Boolean']>;
  errorMessage?: Maybe<Scalars['String']>;
  formId?: Maybe<Scalars['String']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  includeInEmail?: Maybe<Scalars['Boolean']>;
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s GQL input name. */
  inputTypeName?: Maybe<Scalars['String']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']>;
  instructionsPosition?: Maybe<Scalars['String']>;
  isNested?: Maybe<Scalars['String']>;
  labelPosition?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Boolean']>;
  limitAmount?: Maybe<Scalars['Int']>;
  limitType?: Maybe<Scalars['String']>;
  matchField?: Maybe<Scalars['String']>;
  /** The field’s name. */
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  prePopulate?: Maybe<Scalars['String']>;
  queryParameter?: Maybe<Scalars['String']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']>;
  /** The field’s GQL type. */
  typeName?: Maybe<Scalars['String']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  visibility?: Maybe<Scalars['String']>;
};

export type Field_Html = FieldInterface & {
  __typename: 'Field_Html';
  columnWidth?: Maybe<Scalars['String']>;
  conditions?: Maybe<Scalars['String']>;
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  cssClasses?: Maybe<Scalars['String']>;
  defaultValue?: Maybe<Scalars['String']>;
  /** The field’s display name. */
  displayName?: Maybe<Scalars['String']>;
  enableConditions?: Maybe<Scalars['Boolean']>;
  enableContentEncryption?: Maybe<Scalars['Boolean']>;
  errorMessage?: Maybe<Scalars['String']>;
  formId?: Maybe<Scalars['String']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']>;
  htmlContent?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  includeInEmail?: Maybe<Scalars['Boolean']>;
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s GQL input name. */
  inputTypeName?: Maybe<Scalars['String']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']>;
  instructionsPosition?: Maybe<Scalars['String']>;
  isNested?: Maybe<Scalars['String']>;
  labelPosition?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Boolean']>;
  limitAmount?: Maybe<Scalars['Int']>;
  limitType?: Maybe<Scalars['String']>;
  matchField?: Maybe<Scalars['String']>;
  /** The field’s name. */
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  prePopulate?: Maybe<Scalars['String']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']>;
  /** The field’s GQL type. */
  typeName?: Maybe<Scalars['String']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  visibility?: Maybe<Scalars['String']>;
};

export type Field_MissingField = FieldInterface & {
  __typename: 'Field_MissingField';
  columnWidth?: Maybe<Scalars['String']>;
  conditions?: Maybe<Scalars['String']>;
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  cssClasses?: Maybe<Scalars['String']>;
  defaultValue?: Maybe<Scalars['String']>;
  /** The field’s display name. */
  displayName?: Maybe<Scalars['String']>;
  enableConditions?: Maybe<Scalars['Boolean']>;
  enableContentEncryption?: Maybe<Scalars['Boolean']>;
  errorMessage?: Maybe<Scalars['String']>;
  expectedType?: Maybe<Scalars['String']>;
  formId?: Maybe<Scalars['String']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  includeInEmail?: Maybe<Scalars['Boolean']>;
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s GQL input name. */
  inputTypeName?: Maybe<Scalars['String']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']>;
  instructionsPosition?: Maybe<Scalars['String']>;
  isNested?: Maybe<Scalars['String']>;
  labelPosition?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Boolean']>;
  limitAmount?: Maybe<Scalars['Int']>;
  limitType?: Maybe<Scalars['String']>;
  matchField?: Maybe<Scalars['String']>;
  /** The field’s name. */
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  prePopulate?: Maybe<Scalars['String']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']>;
  settings?: Maybe<Scalars['String']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']>;
  /** The field’s GQL type. */
  typeName?: Maybe<Scalars['String']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  visibility?: Maybe<Scalars['String']>;
};

export type Field_MultiLineText = FieldInterface & {
  __typename: 'Field_MultiLineText';
  columnWidth?: Maybe<Scalars['String']>;
  conditions?: Maybe<Scalars['String']>;
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  cssClasses?: Maybe<Scalars['String']>;
  defaultValue?: Maybe<Scalars['String']>;
  /** The field’s display name. */
  displayName?: Maybe<Scalars['String']>;
  enableConditions?: Maybe<Scalars['Boolean']>;
  enableContentEncryption?: Maybe<Scalars['Boolean']>;
  errorMessage?: Maybe<Scalars['String']>;
  formId?: Maybe<Scalars['String']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  includeInEmail?: Maybe<Scalars['Boolean']>;
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s GQL input name. */
  inputTypeName?: Maybe<Scalars['String']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']>;
  instructionsPosition?: Maybe<Scalars['String']>;
  isNested?: Maybe<Scalars['String']>;
  labelPosition?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Boolean']>;
  limitAmount?: Maybe<Scalars['Int']>;
  limitType?: Maybe<Scalars['String']>;
  matchField?: Maybe<Scalars['String']>;
  /** The field’s name. */
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  prePopulate?: Maybe<Scalars['String']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']>;
  richTextButtons?: Maybe<Scalars['String']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']>;
  /** The field’s GQL type. */
  typeName?: Maybe<Scalars['String']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  useRichText?: Maybe<Scalars['Boolean']>;
  visibility?: Maybe<Scalars['String']>;
};

export type Field_Name = FieldInterface & {
  __typename: 'Field_Name';
  columnWidth?: Maybe<Scalars['String']>;
  conditions?: Maybe<Scalars['String']>;
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  cssClasses?: Maybe<Scalars['String']>;
  defaultValue?: Maybe<Scalars['String']>;
  /** The field’s display name. */
  displayName?: Maybe<Scalars['String']>;
  enableConditions?: Maybe<Scalars['Boolean']>;
  enableContentEncryption?: Maybe<Scalars['Boolean']>;
  errorMessage?: Maybe<Scalars['String']>;
  firstNameCollapsed?: Maybe<Scalars['Boolean']>;
  firstNameDefaultValue?: Maybe<Scalars['String']>;
  firstNameEnabled?: Maybe<Scalars['Boolean']>;
  firstNameErrorMessage?: Maybe<Scalars['String']>;
  firstNameLabel?: Maybe<Scalars['String']>;
  firstNamePlaceholder?: Maybe<Scalars['String']>;
  firstNamePrePopulate?: Maybe<Scalars['String']>;
  firstNameRequired?: Maybe<Scalars['Boolean']>;
  formId?: Maybe<Scalars['String']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  includeInEmail?: Maybe<Scalars['Boolean']>;
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s GQL input name. */
  inputTypeName?: Maybe<Scalars['String']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']>;
  instructionsPosition?: Maybe<Scalars['String']>;
  isNested?: Maybe<Scalars['String']>;
  labelPosition?: Maybe<Scalars['String']>;
  lastNameCollapsed?: Maybe<Scalars['Boolean']>;
  lastNameDefaultValue?: Maybe<Scalars['String']>;
  lastNameEnabled?: Maybe<Scalars['Boolean']>;
  lastNameErrorMessage?: Maybe<Scalars['String']>;
  lastNameLabel?: Maybe<Scalars['String']>;
  lastNamePlaceholder?: Maybe<Scalars['String']>;
  lastNamePrePopulate?: Maybe<Scalars['String']>;
  lastNameRequired?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Boolean']>;
  limitAmount?: Maybe<Scalars['Int']>;
  limitType?: Maybe<Scalars['String']>;
  matchField?: Maybe<Scalars['String']>;
  middleNameCollapsed?: Maybe<Scalars['Boolean']>;
  middleNameDefaultValue?: Maybe<Scalars['String']>;
  middleNameEnabled?: Maybe<Scalars['Boolean']>;
  middleNameErrorMessage?: Maybe<Scalars['String']>;
  middleNameLabel?: Maybe<Scalars['String']>;
  middleNamePlaceholder?: Maybe<Scalars['String']>;
  middleNamePrePopulate?: Maybe<Scalars['String']>;
  middleNameRequired?: Maybe<Scalars['Boolean']>;
  /** The field’s name. */
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  prePopulate?: Maybe<Scalars['String']>;
  prefixCollapsed?: Maybe<Scalars['Boolean']>;
  prefixDefaultValue?: Maybe<Scalars['String']>;
  prefixEnabled?: Maybe<Scalars['Boolean']>;
  prefixErrorMessage?: Maybe<Scalars['String']>;
  prefixLabel?: Maybe<Scalars['String']>;
  prefixOptions?: Maybe<Array<Maybe<FieldAttribute>>>;
  prefixPlaceholder?: Maybe<Scalars['String']>;
  prefixPrePopulate?: Maybe<Scalars['String']>;
  prefixRequired?: Maybe<Scalars['Boolean']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']>;
  subfieldLabelPosition?: Maybe<Scalars['String']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']>;
  /** The field’s GQL type. */
  typeName?: Maybe<Scalars['String']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  useMultipleFields?: Maybe<Scalars['Boolean']>;
  visibility?: Maybe<Scalars['String']>;
};

export type Field_Number = FieldInterface & {
  __typename: 'Field_Number';
  columnWidth?: Maybe<Scalars['String']>;
  conditions?: Maybe<Scalars['String']>;
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  cssClasses?: Maybe<Scalars['String']>;
  decimals?: Maybe<Scalars['String']>;
  defaultValue?: Maybe<Scalars['String']>;
  /** The field’s display name. */
  displayName?: Maybe<Scalars['String']>;
  enableConditions?: Maybe<Scalars['Boolean']>;
  enableContentEncryption?: Maybe<Scalars['Boolean']>;
  errorMessage?: Maybe<Scalars['String']>;
  formId?: Maybe<Scalars['String']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  includeInEmail?: Maybe<Scalars['Boolean']>;
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s GQL input name. */
  inputTypeName?: Maybe<Scalars['String']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']>;
  instructionsPosition?: Maybe<Scalars['String']>;
  isNested?: Maybe<Scalars['String']>;
  labelPosition?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Boolean']>;
  limitAmount?: Maybe<Scalars['Int']>;
  limitType?: Maybe<Scalars['String']>;
  matchField?: Maybe<Scalars['String']>;
  max?: Maybe<Scalars['String']>;
  min?: Maybe<Scalars['String']>;
  /** The field’s name. */
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  prePopulate?: Maybe<Scalars['String']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']>;
  /** The field’s GQL type. */
  typeName?: Maybe<Scalars['String']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  visibility?: Maybe<Scalars['String']>;
};

export type Field_Phone = FieldInterface & {
  __typename: 'Field_Phone';
  columnWidth?: Maybe<Scalars['String']>;
  conditions?: Maybe<Scalars['String']>;
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  countryAllowed?: Maybe<Scalars['String']>;
  countryCollapsed?: Maybe<Scalars['Boolean']>;
  countryDefaultValue?: Maybe<Scalars['String']>;
  countryEnabled?: Maybe<Scalars['Boolean']>;
  countryOptions?: Maybe<Array<Maybe<FieldAttribute>>>;
  countryShowDialCode?: Maybe<Scalars['Boolean']>;
  cssClasses?: Maybe<Scalars['String']>;
  defaultValue?: Maybe<Scalars['String']>;
  /** The field’s display name. */
  displayName?: Maybe<Scalars['String']>;
  enableConditions?: Maybe<Scalars['Boolean']>;
  enableContentEncryption?: Maybe<Scalars['Boolean']>;
  errorMessage?: Maybe<Scalars['String']>;
  formId?: Maybe<Scalars['String']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  includeInEmail?: Maybe<Scalars['Boolean']>;
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s GQL input name. */
  inputTypeName?: Maybe<Scalars['String']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']>;
  instructionsPosition?: Maybe<Scalars['String']>;
  isNested?: Maybe<Scalars['String']>;
  labelPosition?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Boolean']>;
  limitAmount?: Maybe<Scalars['Int']>;
  limitType?: Maybe<Scalars['String']>;
  matchField?: Maybe<Scalars['String']>;
  /** The field’s name. */
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  prePopulate?: Maybe<Scalars['String']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']>;
  subfieldLabelPosition?: Maybe<Scalars['String']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']>;
  /** The field’s GQL type. */
  typeName?: Maybe<Scalars['String']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  visibility?: Maybe<Scalars['String']>;
};

export type Field_Repeater = FieldInterface & {
  __typename: 'Field_Repeater';
  addLabel?: Maybe<Scalars['String']>;
  columnWidth?: Maybe<Scalars['String']>;
  conditions?: Maybe<Scalars['String']>;
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  contentTable?: Maybe<Scalars['String']>;
  cssClasses?: Maybe<Scalars['String']>;
  defaultValue?: Maybe<Scalars['String']>;
  /** The field’s display name. */
  displayName?: Maybe<Scalars['String']>;
  enableConditions?: Maybe<Scalars['Boolean']>;
  enableContentEncryption?: Maybe<Scalars['Boolean']>;
  errorMessage?: Maybe<Scalars['String']>;
  /** The field’s nested fields. */
  fields?: Maybe<Array<Maybe<FieldInterface>>>;
  formId?: Maybe<Scalars['String']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  includeInEmail?: Maybe<Scalars['Boolean']>;
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s GQL input name. */
  inputTypeName?: Maybe<Scalars['String']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']>;
  instructionsPosition?: Maybe<Scalars['String']>;
  isNested?: Maybe<Scalars['String']>;
  labelPosition?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Boolean']>;
  limitAmount?: Maybe<Scalars['Int']>;
  limitType?: Maybe<Scalars['String']>;
  matchField?: Maybe<Scalars['String']>;
  maxRows?: Maybe<Scalars['String']>;
  minRows?: Maybe<Scalars['String']>;
  /** The field’s name. */
  name?: Maybe<Scalars['String']>;
  /** The field’s nested rows. */
  nestedRows?: Maybe<Array<Maybe<RowInterface>>>;
  placeholder?: Maybe<Scalars['String']>;
  prePopulate?: Maybe<Scalars['String']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']>;
  /** The field’s GQL type. */
  typeName?: Maybe<Scalars['String']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  visibility?: Maybe<Scalars['String']>;
};

export type Field_Section = FieldInterface & {
  __typename: 'Field_Section';
  borderColor?: Maybe<Scalars['String']>;
  borderStyle?: Maybe<Scalars['String']>;
  borderWidth?: Maybe<Scalars['String']>;
  columnWidth?: Maybe<Scalars['String']>;
  conditions?: Maybe<Scalars['String']>;
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  cssClasses?: Maybe<Scalars['String']>;
  defaultValue?: Maybe<Scalars['String']>;
  /** The field’s display name. */
  displayName?: Maybe<Scalars['String']>;
  enableConditions?: Maybe<Scalars['Boolean']>;
  enableContentEncryption?: Maybe<Scalars['Boolean']>;
  errorMessage?: Maybe<Scalars['String']>;
  formId?: Maybe<Scalars['String']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  includeInEmail?: Maybe<Scalars['Boolean']>;
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s GQL input name. */
  inputTypeName?: Maybe<Scalars['String']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']>;
  instructionsPosition?: Maybe<Scalars['String']>;
  isNested?: Maybe<Scalars['String']>;
  labelPosition?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Boolean']>;
  limitAmount?: Maybe<Scalars['Int']>;
  limitType?: Maybe<Scalars['String']>;
  matchField?: Maybe<Scalars['String']>;
  /** The field’s name. */
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  prePopulate?: Maybe<Scalars['String']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']>;
  /** The field’s GQL type. */
  typeName?: Maybe<Scalars['String']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  visibility?: Maybe<Scalars['String']>;
};

export type Field_SingleLineText = FieldInterface & {
  __typename: 'Field_SingleLineText';
  columnWidth?: Maybe<Scalars['String']>;
  conditions?: Maybe<Scalars['String']>;
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  cssClasses?: Maybe<Scalars['String']>;
  defaultValue?: Maybe<Scalars['String']>;
  /** The field’s display name. */
  displayName?: Maybe<Scalars['String']>;
  enableConditions?: Maybe<Scalars['Boolean']>;
  enableContentEncryption?: Maybe<Scalars['Boolean']>;
  errorMessage?: Maybe<Scalars['String']>;
  formId?: Maybe<Scalars['String']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  includeInEmail?: Maybe<Scalars['Boolean']>;
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s GQL input name. */
  inputTypeName?: Maybe<Scalars['String']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']>;
  instructionsPosition?: Maybe<Scalars['String']>;
  isNested?: Maybe<Scalars['String']>;
  labelPosition?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Boolean']>;
  limitAmount?: Maybe<Scalars['Int']>;
  limitType?: Maybe<Scalars['String']>;
  matchField?: Maybe<Scalars['String']>;
  /** The field’s name. */
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  prePopulate?: Maybe<Scalars['String']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']>;
  /** The field’s GQL type. */
  typeName?: Maybe<Scalars['String']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  visibility?: Maybe<Scalars['String']>;
};

export type Field_Table = FieldInterface & {
  __typename: 'Field_Table';
  addRowLabel?: Maybe<Scalars['String']>;
  columnType?: Maybe<Scalars['String']>;
  columnWidth?: Maybe<Scalars['String']>;
  columns?: Maybe<Array<Maybe<KeyValueType>>>;
  conditions?: Maybe<Scalars['String']>;
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  cssClasses?: Maybe<Scalars['String']>;
  defaultValue?: Maybe<Scalars['String']>;
  defaults?: Maybe<Array<Maybe<KeyValueType>>>;
  /** The field’s display name. */
  displayName?: Maybe<Scalars['String']>;
  enableConditions?: Maybe<Scalars['Boolean']>;
  enableContentEncryption?: Maybe<Scalars['Boolean']>;
  errorMessage?: Maybe<Scalars['String']>;
  formId?: Maybe<Scalars['String']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  includeInEmail?: Maybe<Scalars['Boolean']>;
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s GQL input name. */
  inputTypeName?: Maybe<Scalars['String']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']>;
  instructionsPosition?: Maybe<Scalars['String']>;
  isNested?: Maybe<Scalars['String']>;
  labelPosition?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Boolean']>;
  limitAmount?: Maybe<Scalars['Int']>;
  limitType?: Maybe<Scalars['String']>;
  matchField?: Maybe<Scalars['String']>;
  maxRows?: Maybe<Scalars['String']>;
  minRows?: Maybe<Scalars['String']>;
  /** The field’s name. */
  name?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  prePopulate?: Maybe<Scalars['String']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']>;
  searchable?: Maybe<Scalars['String']>;
  static?: Maybe<Scalars['Boolean']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']>;
  /** The field’s GQL type. */
  typeName?: Maybe<Scalars['String']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  visibility?: Maybe<Scalars['String']>;
};

export type Field_Tags = FieldInterface & {
  __typename: 'Field_Tags';
  allowLimit?: Maybe<Scalars['String']>;
  allowMultipleSources?: Maybe<Scalars['String']>;
  allowSelfRelations?: Maybe<Scalars['String']>;
  columnWidth?: Maybe<Scalars['String']>;
  conditions?: Maybe<Scalars['String']>;
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  cssClasses?: Maybe<Scalars['String']>;
  defaultTag?: Maybe<TagInterface>;
  /** The field’s display name. */
  displayName?: Maybe<Scalars['String']>;
  displayType?: Maybe<Scalars['String']>;
  enableConditions?: Maybe<Scalars['Boolean']>;
  enableContentEncryption?: Maybe<Scalars['Boolean']>;
  errorMessage?: Maybe<Scalars['String']>;
  formId?: Maybe<Scalars['String']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  includeInEmail?: Maybe<Scalars['Boolean']>;
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s GQL input name. */
  inputTypeName?: Maybe<Scalars['String']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']>;
  instructionsPosition?: Maybe<Scalars['String']>;
  isNested?: Maybe<Scalars['String']>;
  labelPosition?: Maybe<Scalars['String']>;
  labelSource?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Boolean']>;
  limitAmount?: Maybe<Scalars['Int']>;
  limitOptions?: Maybe<Scalars['String']>;
  limitType?: Maybe<Scalars['String']>;
  localizeRelations?: Maybe<Scalars['String']>;
  matchField?: Maybe<Scalars['String']>;
  multiple?: Maybe<Scalars['Boolean']>;
  /** The field’s name. */
  name?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  prePopulate?: Maybe<Scalars['String']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']>;
  searchable?: Maybe<Scalars['String']>;
  selectionLabel?: Maybe<Scalars['String']>;
  showSiteMenu?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  sources?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<TagInterface>>>;
  targetSiteId?: Maybe<Scalars['String']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']>;
  /** The field’s GQL type. */
  typeName?: Maybe<Scalars['String']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  validateRelatedElements?: Maybe<Scalars['String']>;
  viewMode?: Maybe<Scalars['String']>;
  visibility?: Maybe<Scalars['String']>;
};


export type Field_TagsDefaultTagArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Field_TagsTagsArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Field_Users = FieldInterface & {
  __typename: 'Field_Users';
  allowSelfRelations?: Maybe<Scalars['String']>;
  columnWidth?: Maybe<Scalars['String']>;
  conditions?: Maybe<Scalars['String']>;
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  cssClasses?: Maybe<Scalars['String']>;
  defaultUser?: Maybe<UserInterface>;
  /** The field’s display name. */
  displayName?: Maybe<Scalars['String']>;
  displayType?: Maybe<Scalars['String']>;
  enableConditions?: Maybe<Scalars['Boolean']>;
  enableContentEncryption?: Maybe<Scalars['Boolean']>;
  errorMessage?: Maybe<Scalars['String']>;
  formId?: Maybe<Scalars['String']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  includeInEmail?: Maybe<Scalars['Boolean']>;
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s GQL input name. */
  inputTypeName?: Maybe<Scalars['String']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']>;
  instructionsPosition?: Maybe<Scalars['String']>;
  isNested?: Maybe<Scalars['String']>;
  labelPosition?: Maybe<Scalars['String']>;
  labelSource?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Boolean']>;
  limitAmount?: Maybe<Scalars['Int']>;
  limitOptions?: Maybe<Scalars['String']>;
  limitType?: Maybe<Scalars['String']>;
  localizeRelations?: Maybe<Scalars['String']>;
  matchField?: Maybe<Scalars['String']>;
  multiple?: Maybe<Scalars['Boolean']>;
  /** The field’s name. */
  name?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  prePopulate?: Maybe<Scalars['String']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']>;
  searchable?: Maybe<Scalars['String']>;
  selectionLabel?: Maybe<Scalars['String']>;
  showSiteMenu?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  sources?: Maybe<Scalars['String']>;
  targetSiteId?: Maybe<Scalars['String']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']>;
  /** The field’s GQL type. */
  typeName?: Maybe<Scalars['String']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  users?: Maybe<Array<Maybe<UserInterface>>>;
  validateRelatedElements?: Maybe<Scalars['String']>;
  viewMode?: Maybe<Scalars['String']>;
  visibility?: Maybe<Scalars['String']>;
};


export type Field_UsersDefaultUserArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  email?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasPhoto?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  username?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Field_UsersUsersArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  email?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasPhoto?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  username?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type FileInput = {
  /** The contents of the file in Base64 format. If provided, takes precedence over the URL. */
  fileData?: InputMaybe<Scalars['String']>;
  /** The file name to use (including the extension) data with the `fileData` field. */
  filename?: InputMaybe<Scalars['String']>;
  /** The URL of the file. */
  url?: InputMaybe<Scalars['String']>;
};

export type FileUploadInput = {
  /** The ID of an already-uploaded asset. */
  assetId?: InputMaybe<Scalars['Int']>;
  /** The contents of the file in Base64 format. If provided, takes precedence over the URL. */
  fileData?: InputMaybe<Scalars['String']>;
  /** The file name to use (including the extension) data with the `fileData` field. */
  filename?: InputMaybe<Scalars['String']>;
};

export type FormIntegrationsType = {
  __typename: 'FormIntegrationsType';
  enabled?: Maybe<Scalars['Boolean']>;
  handle?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['String']>;
};

/** This is the interface implemented by all forms. */
export type FormInterface = {
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** A list of captcha values (name and value) to assist with spam protection */
  captchas?: Maybe<Array<Maybe<FormieCaptchaType>>>;
  /** The form’s config as JSON. */
  configJson?: Maybe<Scalars['String']>;
  /** A CSRF token (name and value) */
  csrfToken?: Maybe<FormieCsrfTokenType>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The form’s fields. */
  fields?: Maybe<Array<Maybe<FieldInterface>>>;
  /** The form’s handle. */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The form’s pages. */
  pages?: Maybe<Array<Maybe<PageInterface>>>;
  /** The form’s rows. */
  rows?: Maybe<Array<Maybe<RowInterface>>>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The form’s settings. */
  settings?: Maybe<FormSettingsType>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The form’s rendered HTML. */
  templateHtml?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
};


/** This is the interface implemented by all forms. */
export type FormInterface_CountArgs = {
  field: Scalars['String'];
};


/** This is the interface implemented by all forms. */
export type FormInterfaceTemplateHtmlArgs = {
  options?: InputMaybe<Scalars['String']>;
  populateFormValues?: InputMaybe<Scalars['String']>;
};

export type FormSettingsType = {
  __typename: 'FormSettingsType';
  /** The form’s default instructions position for fields. */
  defaultInstructionsPosition?: Maybe<Scalars['String']>;
  /** The form’s default label position for fields. */
  defaultLabelPosition?: Maybe<Scalars['String']>;
  /** Whether to show the form’s current page title. */
  displayCurrentPageTitle?: Maybe<Scalars['Boolean']>;
  /** Whether to show the form’s title. */
  displayFormTitle?: Maybe<Scalars['Boolean']>;
  /** Whether to show the form’s page progress. */
  displayPageProgress?: Maybe<Scalars['Boolean']>;
  /** Whether to show the form’s page tabs. */
  displayPageTabs?: Maybe<Scalars['Boolean']>;
  /** The form’s submit error message. */
  errorMessageHtml?: Maybe<Scalars['String']>;
  /** The form’s integrations. */
  integrations?: Maybe<Array<Maybe<FormIntegrationsType>>>;
  /** Whether to show the form’s loading indicator. */
  loadingIndicator?: Maybe<Scalars['Boolean']>;
  /** The form’s loading indicator text. */
  loadingIndicatorText?: Maybe<Scalars['String']>;
  /** The form’s progress bar position. */
  progressPosition?: Maybe<Scalars['String']>;
  /** The form’s submit action entry (for redirection). */
  redirectEntry?: Maybe<EntryInterface>;
  /** The form’s submit action redirect URL. */
  redirectUrl?: Maybe<Scalars['String']>;
  /** Whether to the form should scroll to the top of the page when submitted. */
  scrollToTop?: Maybe<Scalars['Boolean']>;
  /** The form’s submit action. */
  submitAction?: Maybe<Scalars['String']>;
  /** Whether to hide the form’s success message. */
  submitActionFormHide?: Maybe<Scalars['Boolean']>;
  /** The form’s submit success message. */
  submitActionMessageHtml?: Maybe<Scalars['String']>;
  /** The form’s submit success message timeout. */
  submitActionMessageTimeout?: Maybe<Scalars['Int']>;
  /** The form’s submit redirect option (if in new tab or same tab). */
  submitActionTab?: Maybe<Scalars['String']>;
  /** The form’s submit action URL. */
  submitActionUrl?: Maybe<Scalars['String']>;
  /** The form’s submit method. */
  submitMethod?: Maybe<Scalars['String']>;
  /** Whether to validate the form’s on focus. */
  validationOnFocus?: Maybe<Scalars['Boolean']>;
  /** Whether to validate the form’s on submit. */
  validationOnSubmit?: Maybe<Scalars['Boolean']>;
};


export type FormSettingsTypeRedirectEntryArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type FormieCaptchaType = {
  __typename: 'FormieCaptchaType';
  /** The captcha handle. */
  handle?: Maybe<Scalars['String']>;
  /** The captcha name. */
  name?: Maybe<Scalars['String']>;
  /** The catpcha value. */
  value?: Maybe<Scalars['String']>;
};

export type FormieCsrfTokenType = {
  __typename: 'FormieCsrfTokenType';
  /** The CSRF name. */
  name?: Maybe<Scalars['String']>;
  /** The CSRF token. */
  value?: Maybe<Scalars['String']>;
};

/** This is the interface implemented by all global sets. */
export type GlobalSetInterface = {
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The handle of the global set. */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The name of the global set. */
  name?: Maybe<Scalars['String']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
};


/** This is the interface implemented by all global sets. */
export type GlobalSetInterface_CountArgs = {
  field: Scalars['String'];
};

export type KeyValueType = {
  __typename: 'KeyValueType';
  default?: Maybe<Scalars['Boolean']>;
  handle?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  isOptgroup?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  optgroup?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['String']>;
};

/** This is the interface implemented by all matrix blocks. */
export type MatrixBlockInterface = {
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The ID of the field that owns the matrix block. */
  fieldId?: Maybe<Scalars['Int']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The ID of the element that owns the matrix block. */
  ownerId?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The sort order of the matrix block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the matrix block’s type. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the matrix block’s type. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
};


/** This is the interface implemented by all matrix blocks. */
export type MatrixBlockInterface_CountArgs = {
  field: Scalars['String'];
};

export type Mutation = {
  __typename: 'Mutation';
  /** Create a draft for an entry and return the draft ID. */
  createDraft?: Maybe<Scalars['ID']>;
  /** Delete an asset. */
  deleteAsset?: Maybe<Scalars['Boolean']>;
  /** Delete a category. */
  deleteCategory?: Maybe<Scalars['Boolean']>;
  /** Delete an entry. */
  deleteEntry?: Maybe<Scalars['Boolean']>;
  /** Delete a submission. */
  deleteSubmission?: Maybe<Scalars['Boolean']>;
  ping?: Maybe<Scalars['String']>;
  /** Publish a draft for the entry and return the entry ID. */
  publishDraft?: Maybe<Scalars['ID']>;
  /** Save the “About Kubaparis” draft. */
  save_aboutKubaparis_aboutKubaparis_Draft?: Maybe<AboutKubaparis_AboutKubaparis_Entry>;
  /** Save the “About Kubaparis” entry. */
  save_aboutKubaparis_aboutKubaparis_Entry?: Maybe<AboutKubaparis_AboutKubaparis_Entry>;
  /** Save the “About Studio SH” draft. */
  save_aboutStudioSh_aboutStudioSh_Draft?: Maybe<AboutStudioSh_AboutStudioSh_Entry>;
  /** Save the “About Studio SH” entry. */
  save_aboutStudioSh_aboutStudioSh_Entry?: Maybe<AboutStudioSh_AboutStudioSh_Entry>;
  /** Save a “Content Banner” entry draft in the “Ads” section. */
  save_ads_contentBanner_Draft?: Maybe<Ads_ContentBanner_Entry>;
  /** Save a “Content Banner” entry in the “Ads” section. */
  save_ads_contentBanner_Entry?: Maybe<Ads_ContentBanner_Entry>;
  /** Save a “Landingpage Banner” entry draft in the “Ads” section. */
  save_ads_landingpageBanner_Draft?: Maybe<Ads_LandingpageBanner_Entry>;
  /** Save a “Landingpage Banner” entry in the “Ads” section. */
  save_ads_landingpageBanner_Entry?: Maybe<Ads_LandingpageBanner_Entry>;
  /** Save a “Sidebar Banner” entry draft in the “Ads” section. */
  save_ads_sidebarBanner_Draft?: Maybe<Ads_SidebarBanner_Entry>;
  /** Save a “Sidebar Banner” entry in the “Ads” section. */
  save_ads_sidebarBanner_Entry?: Maybe<Ads_SidebarBanner_Entry>;
  /** Save the “Advertise” draft. */
  save_advertise_advertise_Draft?: Maybe<Advertise_Advertise_Entry>;
  /** Save the “Advertise” entry. */
  save_advertise_advertise_Entry?: Maybe<Advertise_Advertise_Entry>;
  /** Save an asset. */
  save_archiveAssets_Asset?: Maybe<ArchiveAssets_Asset>;
  /** Save the “Archive” draft. */
  save_archive_archive_Draft?: Maybe<Archive_Archive_Entry>;
  /** Save the “Archive” entry. */
  save_archive_archive_Entry?: Maybe<Archive_Archive_Entry>;
  /** Save a “Default” entry draft in the “Archived Post” section. */
  save_archivedPost_default_Draft?: Maybe<ArchivedPost_Default_Entry>;
  /** Save a “Default” entry in the “Archived Post” section. */
  save_archivedPost_default_Entry?: Maybe<ArchivedPost_Default_Entry>;
  /** Save an asset. */
  save_assets_Asset?: Maybe<Assets_Asset>;
  /** Save the “Calendar” draft. */
  save_calendar_calendar_Draft?: Maybe<Calendar_Calendar_Entry>;
  /** Save the “Calendar” entry. */
  save_calendar_calendar_Entry?: Maybe<Calendar_Calendar_Entry>;
  /** Save the “Colors” category. */
  save_colors_Category?: Maybe<Colors_Category>;
  /** Save the “Event Category” category. */
  save_eventCategory_Category?: Maybe<EventCategory_Category>;
  /** Save the “Event” submission. */
  save_event_Submission?: Maybe<Event_Submission>;
  /** Save the “Exhibition” submission. */
  save_exhibition_Submission?: Maybe<Exhibition_Submission>;
  /** Update the ”Footer“ global set. */
  save_footer_GlobalSet?: Maybe<Footer_GlobalSet>;
  /** Save the “Imprint” draft. */
  save_imprint_imprint_Draft?: Maybe<Imprint_Imprint_Entry>;
  /** Save the “Imprint” entry. */
  save_imprint_imprint_Entry?: Maybe<Imprint_Imprint_Entry>;
  /** Update the ”Landing Page Videos“ global set. */
  save_landingPageVideos_GlobalSet?: Maybe<LandingPageVideos_GlobalSet>;
  /** Save the “Landing Page” draft. */
  save_landingPage_landingPage_Draft?: Maybe<LandingPage_LandingPage_Entry>;
  /** Save the “Landing Page” entry. */
  save_landingPage_landingPage_Entry?: Maybe<LandingPage_LandingPage_Entry>;
  /** Update the ”Kubaparis Menu“ global set. */
  save_menu_GlobalSet?: Maybe<Menu_GlobalSet>;
  /** Save a “Color” entry draft in the “News” section. */
  save_news_color_Draft?: Maybe<News_Color_Entry>;
  /** Save a “Color” entry in the “News” section. */
  save_news_color_Entry?: Maybe<News_Color_Entry>;
  /** Save a “Image” entry draft in the “News” section. */
  save_news_image_Draft?: Maybe<News_Image_Entry>;
  /** Save a “Image” entry in the “News” section. */
  save_news_image_Entry?: Maybe<News_Image_Entry>;
  /** Save the “Post Category” category. */
  save_postCategory_Category?: Maybe<PostCategory_Category>;
  /** Save a “Default” entry draft in the “Posts” section. */
  save_posts_default_Draft?: Maybe<Posts_Default_Entry>;
  /** Save a “Default” entry in the “Posts” section. */
  save_posts_default_Entry?: Maybe<Posts_Default_Entry>;
  /** Save the “Privacy Policy” draft. */
  save_privacyPolicy_privacyPolicy_Draft?: Maybe<PrivacyPolicy_PrivacyPolicy_Entry>;
  /** Save the “Privacy Policy” entry. */
  save_privacyPolicy_privacyPolicy_Entry?: Maybe<PrivacyPolicy_PrivacyPolicy_Entry>;
  /** Save a “Default” entry draft in the “Projects” section. */
  save_projects_default_Draft?: Maybe<Projects_Default_Entry>;
  /** Save a “Default” entry in the “Projects” section. */
  save_projects_default_Entry?: Maybe<Projects_Default_Entry>;
  /** Save an asset. */
  save_studioShAssets_Asset?: Maybe<StudioShAssets_Asset>;
  /** Update the ”Studio SH Menu“ global set. */
  save_studioShMenu_GlobalSet?: Maybe<StudioShMenu_GlobalSet>;
  /** Save the “Submission Successful” draft. */
  save_submissionSuccessful_submissionSuccessful_Draft?: Maybe<SubmissionSuccessful_SubmissionSuccessful_Entry>;
  /** Save the “Submission Successful” entry. */
  save_submissionSuccessful_submissionSuccessful_Entry?: Maybe<SubmissionSuccessful_SubmissionSuccessful_Entry>;
  /** Save an asset. */
  save_submissions_Asset?: Maybe<Submissions_Asset>;
  /** Save the “Submit Event” draft. */
  save_submitEvent_submitEvent_Draft?: Maybe<SubmitEvent_SubmitEvent_Entry>;
  /** Save the “Submit Event” entry. */
  save_submitEvent_submitEvent_Entry?: Maybe<SubmitEvent_SubmitEvent_Entry>;
  /** Save the “Submit Exhibition” draft. */
  save_submitExhibition_submitExhibition_Draft?: Maybe<SubmitExhibition_SubmitExhibition_Entry>;
  /** Save the “Submit Exhibition” entry. */
  save_submitExhibition_submitExhibition_Entry?: Maybe<SubmitExhibition_SubmitExhibition_Entry>;
};


export type MutationCreateDraftArgs = {
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  provisional?: InputMaybe<Scalars['Boolean']>;
};


export type MutationDeleteAssetArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteCategoryArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteEntryArgs = {
  id: Scalars['Int'];
  siteId?: InputMaybe<Scalars['Int']>;
};


export type MutationDeleteSubmissionArgs = {
  id: Scalars['Int'];
  siteId: Scalars['Int'];
};


export type MutationPublishDraftArgs = {
  id: Scalars['Int'];
  provisional?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSave_AboutKubaparis_AboutKubaparis_DraftArgs = {
  contactKubaparis?: InputMaybe<Scalars['String']>;
  draftId: Scalars['ID'];
  draftName?: InputMaybe<Scalars['String']>;
  draftNotes?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  provisional?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  team?: InputMaybe<Team_MatrixInput>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationSave_AboutKubaparis_AboutKubaparis_EntryArgs = {
  contactKubaparis?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  redactor?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  team?: InputMaybe<Team_MatrixInput>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationSave_AboutStudioSh_AboutStudioSh_DraftArgs = {
  aboutStudioSh?: InputMaybe<AboutStudioSh_SuperTableInput>;
  draftId: Scalars['ID'];
  draftName?: InputMaybe<Scalars['String']>;
  draftNotes?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  provisional?: InputMaybe<Scalars['Boolean']>;
  seo?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationSave_AboutStudioSh_AboutStudioSh_EntryArgs = {
  aboutStudioSh?: InputMaybe<AboutStudioSh_SuperTableInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  seo?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationSave_Ads_ContentBanner_DraftArgs = {
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  authorId?: InputMaybe<Scalars['ID']>;
  clickCounter?: InputMaybe<Scalars['Number']>;
  draftId: Scalars['ID'];
  draftName?: InputMaybe<Scalars['String']>;
  draftNotes?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  externalLink?: InputMaybe<Scalars['String']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  provisional?: InputMaybe<Scalars['Boolean']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationSave_Ads_ContentBanner_EntryArgs = {
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  appendTo?: InputMaybe<Scalars['ID']>;
  appendToRoot?: InputMaybe<Scalars['Boolean']>;
  authorId?: InputMaybe<Scalars['ID']>;
  clickCounter?: InputMaybe<Scalars['Number']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  externalLink?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  insertAfter?: InputMaybe<Scalars['ID']>;
  insertBefore?: InputMaybe<Scalars['ID']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  prependTo?: InputMaybe<Scalars['ID']>;
  prependToRoot?: InputMaybe<Scalars['Boolean']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
};


export type MutationSave_Ads_LandingpageBanner_DraftArgs = {
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  authorId?: InputMaybe<Scalars['ID']>;
  clickCounter?: InputMaybe<Scalars['Number']>;
  draftId: Scalars['ID'];
  draftName?: InputMaybe<Scalars['String']>;
  draftNotes?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  externalLink?: InputMaybe<Scalars['String']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  provisional?: InputMaybe<Scalars['Boolean']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationSave_Ads_LandingpageBanner_EntryArgs = {
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  appendTo?: InputMaybe<Scalars['ID']>;
  appendToRoot?: InputMaybe<Scalars['Boolean']>;
  authorId?: InputMaybe<Scalars['ID']>;
  clickCounter?: InputMaybe<Scalars['Number']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  externalLink?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  insertAfter?: InputMaybe<Scalars['ID']>;
  insertBefore?: InputMaybe<Scalars['ID']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  prependTo?: InputMaybe<Scalars['ID']>;
  prependToRoot?: InputMaybe<Scalars['Boolean']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
};


export type MutationSave_Ads_SidebarBanner_DraftArgs = {
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  authorId?: InputMaybe<Scalars['ID']>;
  clickCounter?: InputMaybe<Scalars['Number']>;
  draftId: Scalars['ID'];
  draftName?: InputMaybe<Scalars['String']>;
  draftNotes?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  externalLink?: InputMaybe<Scalars['String']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  provisional?: InputMaybe<Scalars['Boolean']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationSave_Ads_SidebarBanner_EntryArgs = {
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  appendTo?: InputMaybe<Scalars['ID']>;
  appendToRoot?: InputMaybe<Scalars['Boolean']>;
  authorId?: InputMaybe<Scalars['ID']>;
  clickCounter?: InputMaybe<Scalars['Number']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  externalLink?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  insertAfter?: InputMaybe<Scalars['ID']>;
  insertBefore?: InputMaybe<Scalars['ID']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  prependTo?: InputMaybe<Scalars['ID']>;
  prependToRoot?: InputMaybe<Scalars['Boolean']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
};


export type MutationSave_Advertise_Advertise_DraftArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  draftId: Scalars['ID'];
  draftName?: InputMaybe<Scalars['String']>;
  draftNotes?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  label?: InputMaybe<Scalars['String']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  provisional?: InputMaybe<Scalars['Boolean']>;
  seo?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationSave_Advertise_Advertise_EntryArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  label?: InputMaybe<Scalars['String']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  seo?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationSave_ArchiveAssets_AssetArgs = {
  _file?: InputMaybe<FileInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  newFolderId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
  uploaderId?: InputMaybe<Scalars['ID']>;
};


export type MutationSave_Archive_Archive_DraftArgs = {
  draftId: Scalars['ID'];
  draftName?: InputMaybe<Scalars['String']>;
  draftNotes?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  provisional?: InputMaybe<Scalars['Boolean']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationSave_Archive_Archive_EntryArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationSave_ArchivedPost_Default_DraftArgs = {
  authorId?: InputMaybe<Scalars['ID']>;
  curatorArchive?: InputMaybe<Scalars['String']>;
  draftId: Scalars['ID'];
  draftName?: InputMaybe<Scalars['String']>;
  draftNotes?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Scalars['DateTime']>;
  exhibitionTitle?: InputMaybe<Scalars['String']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  imagesArchive?: InputMaybe<ImagesArchive_MatrixInput>;
  linkToLocationArchive?: InputMaybe<Scalars['String']>;
  linkToVideo?: InputMaybe<Scalars['String']>;
  locationNameArchiv?: InputMaybe<Scalars['String']>;
  names?: InputMaybe<Scalars['String']>;
  openingExhibition?: InputMaybe<Scalars['DateTime']>;
  photographer?: InputMaybe<Scalars['String']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  provisional?: InputMaybe<Scalars['Boolean']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  subheadline?: InputMaybe<Scalars['String']>;
  textArchive?: InputMaybe<Scalars['String']>;
  textAuthor?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationSave_ArchivedPost_Default_EntryArgs = {
  authorId?: InputMaybe<Scalars['ID']>;
  curatorArchive?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Scalars['DateTime']>;
  exhibitionTitle?: InputMaybe<Scalars['String']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  imagesArchive?: InputMaybe<ImagesArchive_MatrixInput>;
  linkToLocationArchive?: InputMaybe<Scalars['String']>;
  linkToVideo?: InputMaybe<Scalars['String']>;
  locationNameArchiv?: InputMaybe<Scalars['String']>;
  names?: InputMaybe<Scalars['String']>;
  openingExhibition?: InputMaybe<Scalars['DateTime']>;
  photographer?: InputMaybe<Scalars['String']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  subheadline?: InputMaybe<Scalars['String']>;
  textArchive?: InputMaybe<Scalars['String']>;
  textAuthor?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
};


export type MutationSave_Assets_AssetArgs = {
  _file?: InputMaybe<FileInput>;
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  newFolderId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
  uploaderId?: InputMaybe<Scalars['ID']>;
};


export type MutationSave_Calendar_Calendar_DraftArgs = {
  bgColor?: InputMaybe<Scalars['String']>;
  draftId: Scalars['ID'];
  draftName?: InputMaybe<Scalars['String']>;
  draftNotes?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  fontColor?: InputMaybe<Scalars['String']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  provisional?: InputMaybe<Scalars['Boolean']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationSave_Calendar_Calendar_EntryArgs = {
  bgColor?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  fontColor?: InputMaybe<Scalars['String']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationSave_Colors_CategoryArgs = {
  appendTo?: InputMaybe<Scalars['ID']>;
  appendToRoot?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  insertAfter?: InputMaybe<Scalars['ID']>;
  insertBefore?: InputMaybe<Scalars['ID']>;
  prependTo?: InputMaybe<Scalars['ID']>;
  prependToRoot?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
};


export type MutationSave_EventCategory_CategoryArgs = {
  appendTo?: InputMaybe<Scalars['ID']>;
  appendToRoot?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  insertAfter?: InputMaybe<Scalars['ID']>;
  insertBefore?: InputMaybe<Scalars['ID']>;
  prependTo?: InputMaybe<Scalars['ID']>;
  prependToRoot?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
};


export type MutationSave_Event_SubmissionArgs = {
  city?: InputMaybe<Scalars['String']>;
  consent?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  eventCategory?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  eventTitle?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  linkToLocation?: InputMaybe<Scalars['String']>;
  locationName?: InputMaybe<Scalars['String']>;
  namesInvolved?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  statusId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
};


export type MutationSave_Exhibition_SubmissionArgs = {
  artistsName?: InputMaybe<Scalars['String']>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  consent?: InputMaybe<Scalars['String']>;
  curator?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  exhibitionEnd?: InputMaybe<Scalars['DateTime']>;
  exhibitionOpening?: InputMaybe<Scalars['DateTime']>;
  exhibitionTitle?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  images?: InputMaybe<Exhibition_Images_FormieRepeaterInput>;
  keyImage?: InputMaybe<Array<InputMaybe<FileUploadInput>>>;
  linkToLocation?: InputMaybe<Scalars['String']>;
  linkToVideo?: InputMaybe<Scalars['String']>;
  locationName?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Scalars['String']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  siteId?: InputMaybe<Scalars['Int']>;
  socialMediaInfo?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  statusId?: InputMaybe<Scalars['Int']>;
  subheadline?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
  textAuthor?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  uid?: InputMaybe<Scalars['String']>;
  yourEMail?: InputMaybe<Scalars['String']>;
};


export type MutationSave_Footer_GlobalSetArgs = {
  about?: InputMaybe<About_MatrixInput>;
  blogContactEmail?: InputMaybe<Scalars['String']>;
  blogContactLabel?: InputMaybe<Scalars['String']>;
  followUs?: InputMaybe<FollowUs_MatrixInput>;
  linkToSingles?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  newsletterLabel?: InputMaybe<Scalars['String']>;
  newsletterLink?: InputMaybe<Scalars['String']>;
  studioContactEmail?: InputMaybe<Scalars['String']>;
  studioContactLabel?: InputMaybe<Scalars['String']>;
};


export type MutationSave_Imprint_Imprint_DraftArgs = {
  draftId: Scalars['ID'];
  draftName?: InputMaybe<Scalars['String']>;
  draftNotes?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  provisional?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationSave_Imprint_Imprint_EntryArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  redactor?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationSave_LandingPageVideos_GlobalSetArgs = {
  kubaparisVideos?: InputMaybe<KubaparisVideos_SuperTableInput>;
};


export type MutationSave_LandingPage_LandingPage_DraftArgs = {
  draftId: Scalars['ID'];
  draftName?: InputMaybe<Scalars['String']>;
  draftNotes?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  landingHero?: InputMaybe<LandingHero_SuperTableInput>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  provisional?: InputMaybe<Scalars['Boolean']>;
  seo?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationSave_LandingPage_LandingPage_EntryArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  landingHero?: InputMaybe<LandingHero_SuperTableInput>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  seo?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationSave_Menu_GlobalSetArgs = {
  menuSubpages?: InputMaybe<MenuSubpages_MatrixInput>;
  socialMediaLinks?: InputMaybe<Array<InputMaybe<SocialMediaLinks_TableRowInput>>>;
};


export type MutationSave_News_Color_DraftArgs = {
  authorId?: InputMaybe<Scalars['ID']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  draftId: Scalars['ID'];
  draftName?: InputMaybe<Scalars['String']>;
  draftNotes?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  newsLink?: InputMaybe<Scalars['String']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  provisional?: InputMaybe<Scalars['Boolean']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationSave_News_Color_EntryArgs = {
  authorId?: InputMaybe<Scalars['ID']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  newsLink?: InputMaybe<Scalars['String']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
};


export type MutationSave_News_Image_DraftArgs = {
  authorId?: InputMaybe<Scalars['ID']>;
  draftId: Scalars['ID'];
  draftName?: InputMaybe<Scalars['String']>;
  draftNotes?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  newsLink?: InputMaybe<Scalars['String']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  provisional?: InputMaybe<Scalars['Boolean']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationSave_News_Image_EntryArgs = {
  authorId?: InputMaybe<Scalars['ID']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  newsLink?: InputMaybe<Scalars['String']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
};


export type MutationSave_PostCategory_CategoryArgs = {
  appendTo?: InputMaybe<Scalars['ID']>;
  appendToRoot?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  insertAfter?: InputMaybe<Scalars['ID']>;
  insertBefore?: InputMaybe<Scalars['ID']>;
  prependTo?: InputMaybe<Scalars['ID']>;
  prependToRoot?: InputMaybe<Scalars['Boolean']>;
  seo?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
};


export type MutationSave_Posts_Default_DraftArgs = {
  authorId?: InputMaybe<Scalars['ID']>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  contentBlocks?: InputMaybe<ContentBlocks_MatrixInput>;
  draftId: Scalars['ID'];
  draftName?: InputMaybe<Scalars['String']>;
  draftNotes?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  projectInfo?: InputMaybe<Array<InputMaybe<ProjectInfo_TableRowInput>>>;
  provisional?: InputMaybe<Scalars['Boolean']>;
  seo?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  subheading?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type MutationSave_Posts_Default_EntryArgs = {
  authorId?: InputMaybe<Scalars['ID']>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  contentBlocks?: InputMaybe<ContentBlocks_MatrixInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  projectInfo?: InputMaybe<Array<InputMaybe<ProjectInfo_TableRowInput>>>;
  seo?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  subheading?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  uid?: InputMaybe<Scalars['String']>;
};


export type MutationSave_PrivacyPolicy_PrivacyPolicy_DraftArgs = {
  draftId: Scalars['ID'];
  draftName?: InputMaybe<Scalars['String']>;
  draftNotes?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  provisional?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationSave_PrivacyPolicy_PrivacyPolicy_EntryArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  redactor?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationSave_Projects_Default_DraftArgs = {
  authorId?: InputMaybe<Scalars['ID']>;
  draftId: Scalars['ID'];
  draftName?: InputMaybe<Scalars['String']>;
  draftNotes?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  mobileDescription?: InputMaybe<Scalars['String']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  projectSlider?: InputMaybe<ProjectSlider_MatrixInput>;
  provisional?: InputMaybe<Scalars['Boolean']>;
  seo?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationSave_Projects_Default_EntryArgs = {
  appendTo?: InputMaybe<Scalars['ID']>;
  appendToRoot?: InputMaybe<Scalars['Boolean']>;
  authorId?: InputMaybe<Scalars['ID']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  insertAfter?: InputMaybe<Scalars['ID']>;
  insertBefore?: InputMaybe<Scalars['ID']>;
  mobileDescription?: InputMaybe<Scalars['String']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  prependTo?: InputMaybe<Scalars['ID']>;
  prependToRoot?: InputMaybe<Scalars['Boolean']>;
  projectSlider?: InputMaybe<ProjectSlider_MatrixInput>;
  seo?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
};


export type MutationSave_StudioShAssets_AssetArgs = {
  _file?: InputMaybe<FileInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  newFolderId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
  uploaderId?: InputMaybe<Scalars['ID']>;
};


export type MutationSave_StudioShMenu_GlobalSetArgs = {
  menuSubpages?: InputMaybe<MenuSubpages_MatrixInput>;
  socialMediaLinks?: InputMaybe<Array<InputMaybe<SocialMediaLinks_TableRowInput>>>;
};


export type MutationSave_SubmissionSuccessful_SubmissionSuccessful_DraftArgs = {
  draftId: Scalars['ID'];
  draftName?: InputMaybe<Scalars['String']>;
  draftNotes?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  infoText?: InputMaybe<Scalars['String']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  provisional?: InputMaybe<Scalars['Boolean']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationSave_SubmissionSuccessful_SubmissionSuccessful_EntryArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  infoText?: InputMaybe<Scalars['String']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationSave_Submissions_AssetArgs = {
  _file?: InputMaybe<FileInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  newFolderId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
  uploaderId?: InputMaybe<Scalars['ID']>;
};


export type MutationSave_SubmitEvent_SubmitEvent_DraftArgs = {
  draftId: Scalars['ID'];
  draftName?: InputMaybe<Scalars['String']>;
  draftNotes?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  infoText?: InputMaybe<Scalars['String']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  provisional?: InputMaybe<Scalars['Boolean']>;
  seo?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationSave_SubmitEvent_SubmitEvent_EntryArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  infoText?: InputMaybe<Scalars['String']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  seo?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationSave_SubmitExhibition_SubmitExhibition_DraftArgs = {
  draftId: Scalars['ID'];
  draftName?: InputMaybe<Scalars['String']>;
  draftNotes?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  infoText?: InputMaybe<Scalars['String']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  provisional?: InputMaybe<Scalars['Boolean']>;
  seo?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationSave_SubmitExhibition_SubmitExhibition_EntryArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  infoText?: InputMaybe<Scalars['String']>;
  postDate?: InputMaybe<Scalars['DateTime']>;
  seo?: InputMaybe<Scalars['String']>;
  siteId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** This is the interface implemented by all pages. */
export type PageInterface = {
  /** The page’s fields. */
  fields?: Maybe<Array<Maybe<FieldInterface>>>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The page’s name. */
  name?: Maybe<Scalars['String']>;
  /** The page’s rows. */
  rows?: Maybe<Array<Maybe<RowInterface>>>;
  /** The page’s settings. */
  settings?: Maybe<PageSettingsInterface>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
};

/** This is the interface implemented by all pages. */
export type PageSettingsInterface = {
  /** The page’s back button label. */
  backButtonLabel?: Maybe<Scalars['String']>;
  /** The page’s button positions. */
  buttonsPosition?: Maybe<Scalars['String']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']>;
  /** Whether the page has conditions enabled. */
  enableNextButtonConditions?: Maybe<Scalars['Boolean']>;
  /** Whether the page has conditions enabled. */
  enablePageConditions?: Maybe<Scalars['Boolean']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The page’s conditions. */
  nextButtonConditions?: Maybe<Scalars['String']>;
  /** The page’s conditions. */
  pageConditions?: Maybe<Scalars['String']>;
  /** Whether to show the page’s back button. */
  showBackButton?: Maybe<Scalars['Boolean']>;
  /** The page’s submit button label. */
  submitButtonLabel?: Maybe<Scalars['String']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
};

export type PageSettingsType = PageSettingsInterface & {
  __typename: 'PageSettingsType';
  /** The page’s back button label. */
  backButtonLabel?: Maybe<Scalars['String']>;
  /** The page’s button positions. */
  buttonsPosition?: Maybe<Scalars['String']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']>;
  /** Whether the page has conditions enabled. */
  enableNextButtonConditions?: Maybe<Scalars['Boolean']>;
  /** Whether the page has conditions enabled. */
  enablePageConditions?: Maybe<Scalars['Boolean']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The page’s conditions. */
  nextButtonConditions?: Maybe<Scalars['String']>;
  /** The page’s conditions. */
  pageConditions?: Maybe<Scalars['String']>;
  /** Whether to show the page’s back button. */
  showBackButton?: Maybe<Scalars['Boolean']>;
  /** The page’s submit button label. */
  submitButtonLabel?: Maybe<Scalars['String']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
};

export type PageType = PageInterface & {
  __typename: 'PageType';
  /** The page’s fields. */
  fields?: Maybe<Array<Maybe<FieldInterface>>>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The page’s name. */
  name?: Maybe<Scalars['String']>;
  /** The page’s rows. */
  rows?: Maybe<Array<Maybe<RowInterface>>>;
  /** The page’s settings. */
  settings?: Maybe<PageSettingsInterface>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename: 'Query';
  /** This query is used to query for a single asset. */
  asset?: Maybe<AssetInterface>;
  /** This query is used to return the number of assets. */
  assetCount: Scalars['Int'];
  /** This query is used to query for assets. */
  assets?: Maybe<Array<Maybe<AssetInterface>>>;
  /** This query is used to query for categories. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** This query is used to query for a single category. */
  category?: Maybe<CategoryInterface>;
  /** This query is used to return the number of categories. */
  categoryCount: Scalars['Int'];
  /** This query is used to query for entries. */
  entries?: Maybe<Array<Maybe<EntryInterface>>>;
  /** This query is used to query for a single entry. */
  entry?: Maybe<EntryInterface>;
  /** This query is used to return the number of entries. */
  entryCount: Scalars['Int'];
  /** This query is used to query for a single form. */
  form?: Maybe<FormInterface>;
  /** This query is used to return the number of forms. */
  formCount: Scalars['Int'];
  /** This query is used to query for a single form. */
  formieForm?: Maybe<FormInterface>;
  /** This query is used to return the number of forms. */
  formieFormCount: Scalars['Int'];
  /** This query is used to query for forms. */
  formieForms?: Maybe<Array<Maybe<FormInterface>>>;
  /** This query is used to query for a single submission. */
  formieSubmission?: Maybe<SubmissionInterface>;
  /** This query is used to return the number of submissions. */
  formieSubmissionCount: Scalars['Int'];
  /** This query is used to query for submissions. */
  formieSubmissions?: Maybe<Array<Maybe<SubmissionInterface>>>;
  /** This query is used to query for forms. */
  forms?: Maybe<Array<Maybe<FormInterface>>>;
  /** This query is used to query for a single global set. */
  globalSet?: Maybe<GlobalSetInterface>;
  /** This query is used to query for global sets. */
  globalSets?: Maybe<Array<Maybe<GlobalSetInterface>>>;
  ping?: Maybe<Scalars['String']>;
  /** This query is used to query for a single submission. */
  submission?: Maybe<SubmissionInterface>;
  /** This query is used to return the number of submissions. */
  submissionCount: Scalars['Int'];
  /** This query is used to query for submissions. */
  submissions?: Maybe<Array<Maybe<SubmissionInterface>>>;
  /** This query is used to query for a single tag. */
  tag?: Maybe<TagInterface>;
  /** This query is used to return the number of tags. */
  tagCount: Scalars['Int'];
  /** This query is used to query for tags. */
  tags?: Maybe<Array<Maybe<TagInterface>>>;
  /** This query is used to query for a single user. */
  user?: Maybe<UserInterface>;
  /** This query is used to return the number of users. */
  userCount: Scalars['Int'];
  /** This query is used to query for users. */
  users?: Maybe<Array<Maybe<UserInterface>>>;
};


export type QueryAssetArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryAssetCountArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryAssetsArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryCategoriesArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCategoryArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCategoryCountArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type QueryEntriesArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type QueryEntryArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type QueryEntryCountArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFormArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  handle?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryFormCountArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  handle?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryFormieFormArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  handle?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryFormieFormCountArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  handle?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryFormieFormsArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  handle?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryFormieSubmissionArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  form?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  isIncomplete?: InputMaybe<Scalars['Boolean']>;
  isSpam?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryFormieSubmissionCountArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  form?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  isIncomplete?: InputMaybe<Scalars['Boolean']>;
  isSpam?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryFormieSubmissionsArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  form?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  isIncomplete?: InputMaybe<Scalars['Boolean']>;
  isSpam?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryFormsArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  handle?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryGlobalSetArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  blogContactEmail?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  blogContactLabel?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  handle?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToSingles?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsletterLabel?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsletterLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  socialMediaLinks?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  studioContactEmail?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  studioContactLabel?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryGlobalSetsArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  blogContactEmail?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  blogContactLabel?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  handle?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToSingles?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsletterLabel?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsletterLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  socialMediaLinks?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  studioContactEmail?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  studioContactLabel?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QuerySubmissionArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  form?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  isIncomplete?: InputMaybe<Scalars['Boolean']>;
  isSpam?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QuerySubmissionCountArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  form?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  isIncomplete?: InputMaybe<Scalars['Boolean']>;
  isSpam?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QuerySubmissionsArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  form?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  isIncomplete?: InputMaybe<Scalars['Boolean']>;
  isSpam?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryTagArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryTagCountArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryTagsArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryUserArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  email?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasPhoto?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  username?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryUserCountArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  email?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasPhoto?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  username?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryUsersArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  email?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasPhoto?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  username?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** This is the interface implemented by all rows. */
export type RowInterface = {
  /** The row’s fields. */
  fields?: Maybe<Array<Maybe<FieldInterface>>>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
};

export type RowType = RowInterface & {
  __typename: 'RowType';
  /** The row’s fields. */
  fields?: Maybe<Array<Maybe<FieldInterface>>>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
};

/** This is the interface implemented by all submissions. */
export type SubmissionInterface = {
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The submission’s IP Address. */
  ipAddress?: Maybe<Scalars['String']>;
  /** Whether the submission is incomplete. */
  isIncomplete?: Maybe<Scalars['Boolean']>;
  /** Whether the submission is spam. */
  isSpam?: Maybe<Scalars['Boolean']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The submission’s spam reason. */
  spamReason?: Maybe<Scalars['String']>;
  /** The submission’s status. */
  status?: Maybe<Scalars['String']>;
  /** The submission’s status ID. */
  statusId?: Maybe<Scalars['Int']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
};


/** This is the interface implemented by all submissions. */
export type SubmissionInterface_CountArgs = {
  field: Scalars['String'];
};

/** This is the interface implemented by all Super Table blocks. */
export type SuperTableBlockInterface = {
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The ID of the field that owns the Super Table block. */
  fieldId?: Maybe<Scalars['Int']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The ID of the element that owns the Super Table block. */
  ownerId?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The sort order of the Super Table block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The ID of the Super Table block's type. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
};


/** This is the interface implemented by all Super Table blocks. */
export type SuperTableBlockInterface_CountArgs = {
  field: Scalars['String'];
};

export type TagCriteriaInput = {
  /** Narrows the query results to only elements that have been archived. */
  archived?: InputMaybe<Scalars['Boolean']>;
  /** Narrows the query results based on the elements’ creation dates. */
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results based on the elements’ last-updated dates. */
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results based on whether the elements are enabled in the site they’re being queried in, per the `site` argument. */
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  /** Causes the query results to be returned in the order specified by the `id` argument. */
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  /** Narrows the query results based on the tag groups the tags belong to per the group’s handles. */
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results based on the tag groups the tags belong to, per the groups’ IDs. */
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results based on the elements’ IDs. */
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Causes the query results to be returned in reverse order. */
  inReverse?: InputMaybe<Scalars['Boolean']>;
  /** Sets the limit for paginated results. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Sets the offset for paginated results. */
  offset?: InputMaybe<Scalars['Int']>;
  /** Sets the field the returned elements should be ordered by. */
  orderBy?: InputMaybe<Scalars['String']>;
  /** Determines which site should be selected when querying multi-site elements. */
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results based on a reference string. */
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results to elements that relate to the provided element IDs. This argument is ignored, if `relatedToAll` is also used. */
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results to elements that relate to *all* of the provided element IDs. Using this argument will cause `relatedTo` argument to be ignored. **This argument is deprecated.** `relatedTo: ["and", ...ids]` should be used instead. */
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results to elements that relate to an asset list defined with this argument. */
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  /** Narrows the query results to elements that relate to a category list defined with this argument. */
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  /** Narrows the query results to elements that relate to an entry list defined with this argument. */
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  /** Narrows the query results to elements that relate to a tag list defined with this argument. */
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  /** Narrows the query results to elements that relate to a use list defined with this argument. */
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  /** Narrows the query results to only elements that match a search query. */
  search?: InputMaybe<Scalars['String']>;
  /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results based on the unique identifier for an element-site relation. */
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results based on the elements’ slugs. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results based on the elements’ statuses. */
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results based on the elements’ titles. */
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results to only elements that have been soft-deleted. */
  trashed?: InputMaybe<Scalars['Boolean']>;
  /** Narrows the query results based on the elements’ UIDs. */
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Determines whether only elements with unique IDs should be returned by the query. */
  unique?: InputMaybe<Scalars['Boolean']>;
  /** Narrows the query results based on the elements’ URIs. */
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** This is the interface implemented by all tags. */
export type TagInterface = {
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The handle of the group that contains the tag. */
  groupHandle?: Maybe<Scalars['String']>;
  /** The ID of the group that contains the tag. */
  groupId?: Maybe<Scalars['Int']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
};


/** This is the interface implemented by all tags. */
export type TagInterface_CountArgs = {
  field: Scalars['String'];
};

export type User = ElementInterface & UserInterface & {
  __typename: 'User';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** The user’s email. */
  email?: Maybe<Scalars['String']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The user’s first name. */
  firstName?: Maybe<Scalars['String']>;
  /** The user’s first name or username. */
  friendlyName?: Maybe<Scalars['String']>;
  /** The user’s full name. */
  fullName?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The user’s last name. */
  lastName?: Maybe<Scalars['String']>;
  /** The user’s full name or username. */
  name?: Maybe<Scalars['String']>;
  /** The user’s preferences. */
  preferences?: Maybe<Scalars['String']>;
  /** The user’s preferred language. */
  preferredLanguage?: Maybe<Scalars['String']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  /** The username. */
  username?: Maybe<Scalars['String']>;
};


export type User_CountArgs = {
  field: Scalars['String'];
};

export type UserCriteriaInput = {
  /** Narrows the query results to only elements that have been archived. */
  archived?: InputMaybe<Scalars['Boolean']>;
  /** Narrows the query results based on the elements’ creation dates. */
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results based on the elements’ last-updated dates. */
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results based on the users’ email addresses. */
  email?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results based on whether the elements are enabled in the site they’re being queried in, per the `site` argument. */
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  /** Narrows the query results based on the users’ first names. */
  firstName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Causes the query results to be returned in the order specified by the `id` argument. */
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  /** Narrows the query results based on the user group the users belong to. */
  group?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results based on the user group the users belong to, per the groups’ IDs. */
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results to only users that have (or don’t have) a user photo. */
  hasPhoto?: InputMaybe<Scalars['Boolean']>;
  /** Narrows the query results based on the elements’ IDs. */
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Causes the query results to be returned in reverse order. */
  inReverse?: InputMaybe<Scalars['Boolean']>;
  /** Narrows the query results based on the users’ last names. */
  lastName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Sets the limit for paginated results. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Sets the offset for paginated results. */
  offset?: InputMaybe<Scalars['Int']>;
  /** Sets the field the returned elements should be ordered by. */
  orderBy?: InputMaybe<Scalars['String']>;
  /** Determines which site should be selected when querying multi-site elements. */
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results based on a reference string. */
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results to elements that relate to the provided element IDs. This argument is ignored, if `relatedToAll` is also used. */
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results to elements that relate to *all* of the provided element IDs. Using this argument will cause `relatedTo` argument to be ignored. **This argument is deprecated.** `relatedTo: ["and", ...ids]` should be used instead. */
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results to elements that relate to an asset list defined with this argument. */
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  /** Narrows the query results to elements that relate to a category list defined with this argument. */
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  /** Narrows the query results to elements that relate to an entry list defined with this argument. */
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  /** Narrows the query results to elements that relate to a tag list defined with this argument. */
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  /** Narrows the query results to elements that relate to a use list defined with this argument. */
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  /** Narrows the query results to only elements that match a search query. */
  search?: InputMaybe<Scalars['String']>;
  /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results based on the unique identifier for an element-site relation. */
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  /** Narrows the query results based on the elements’ slugs. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results based on the elements’ statuses. */
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results based on the elements’ titles. */
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results to only elements that have been soft-deleted. */
  trashed?: InputMaybe<Scalars['Boolean']>;
  /** Narrows the query results based on the elements’ UIDs. */
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Determines whether only elements with unique IDs should be returned by the query. */
  unique?: InputMaybe<Scalars['Boolean']>;
  /** Narrows the query results based on the elements’ URIs. */
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Narrows the query results based on the users’ usernames. */
  username?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** This is the interface implemented by all users. */
export type UserInterface = {
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** The user’s email. */
  email?: Maybe<Scalars['String']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The user’s first name. */
  firstName?: Maybe<Scalars['String']>;
  /** The user’s first name or username. */
  friendlyName?: Maybe<Scalars['String']>;
  /** The user’s full name. */
  fullName?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The user’s last name. */
  lastName?: Maybe<Scalars['String']>;
  /** The user’s full name or username. */
  name?: Maybe<Scalars['String']>;
  /** The user’s preferences. */
  preferences?: Maybe<Scalars['String']>;
  /** The user’s preferred language. */
  preferredLanguage?: Maybe<Scalars['String']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  /** The username. */
  username?: Maybe<Scalars['String']>;
};


/** This is the interface implemented by all users. */
export type UserInterface_CountArgs = {
  field: Scalars['String'];
};

export type AboutKubaparis_AboutKubaparis_Entry = ElementInterface & EntryInterface & {
  __typename: 'aboutKubaparis_aboutKubaparis_Entry';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The entry’s author. */
  author?: Maybe<UserInterface>;
  /** The ID of the author of this entry. */
  authorId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical ID. */
  canonicalId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical UUID. */
  canonicalUid?: Maybe<Scalars['String']>;
  /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
  children?: Maybe<Array<Maybe<EntryInterface>>>;
  contactKubaparis?: Maybe<Scalars['String']>;
  /** The current revision for the entry. */
  currentRevision?: Maybe<EntryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The creator of a given draft. */
  draftCreator?: Maybe<UserInterface>;
  /** The draft ID (from the `drafts` table). */
  draftId?: Maybe<Scalars['Int']>;
  /** The name of the draft. */
  draftName?: Maybe<Scalars['String']>;
  /** The notes for the draft. */
  draftNotes?: Maybe<Scalars['String']>;
  /** The drafts for the entry. */
  drafts?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The expiry date of the entry. */
  expiryDate?: Maybe<Scalars['DateTime']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** Returns whether this is a draft. */
  isDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is a revision. */
  isRevision?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. */
  isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. **This field is deprecated.** `isUnpublishedDraft` should be used instead. */
  isUnsavedDraft?: Maybe<Scalars['Boolean']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']>;
  /** The same element in other locales. */
  localized?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<EntryInterface>;
  /** The entry’s parent, if the section is a structure. */
  parent?: Maybe<EntryInterface>;
  /** The entry’s post date. */
  postDate?: Maybe<Scalars['DateTime']>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<EntryInterface>;
  redactor?: Maybe<Scalars['String']>;
  /** The creator of a given revision. */
  revisionCreator?: Maybe<UserInterface>;
  /** The revision ID (from the `revisions` table). */
  revisionId?: Maybe<Scalars['Int']>;
  /** The revisions for the entry. */
  revisions?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The handle of the section that contains the entry. */
  sectionHandle?: Maybe<Scalars['String']>;
  /** The ID of the section that contains the entry. */
  sectionId?: Maybe<Scalars['Int']>;
  seo?: Maybe<Ether_SeoData>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /**
   * Returns the entry’s canonical ID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
   */
  sourceId?: Maybe<Scalars['Int']>;
  /**
   * Returns the entry’s canonical UUID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
   */
  sourceUid?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']>;
  team?: Maybe<Array<Maybe<Team_MatrixField>>>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the entry type that contains the entry. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the entry type that contains the entry. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']>;
};


export type AboutKubaparis_AboutKubaparis_Entry_CountArgs = {
  field: Scalars['String'];
};


export type AboutKubaparis_AboutKubaparis_EntryAncestorsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type AboutKubaparis_AboutKubaparis_EntryChildrenArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type AboutKubaparis_AboutKubaparis_EntryDescendantsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type AboutKubaparis_AboutKubaparis_EntryDraftsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type AboutKubaparis_AboutKubaparis_EntryLocalizedArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type AboutKubaparis_AboutKubaparis_EntryNextArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type AboutKubaparis_AboutKubaparis_EntryParentArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type AboutKubaparis_AboutKubaparis_EntryPrevArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type AboutKubaparis_AboutKubaparis_EntryRevisionsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type AboutKubaparis_AboutKubaparis_EntryTeamArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AboutStudioSh_3_SuperTableBlockInput = {
  contactDesignStudio?: InputMaybe<Array<InputMaybe<ContactDesignStudio_TableRowInput>>>;
  contactEditorial?: InputMaybe<Array<InputMaybe<ContactEditorial_TableRowInput>>>;
  id?: InputMaybe<Scalars['ID']>;
  intoText?: InputMaybe<Scalars['String']>;
  socialMediaEntries?: InputMaybe<Array<InputMaybe<SocialMediaEntries_TableRowInput>>>;
  socialMediaHeading?: InputMaybe<Scalars['String']>;
};

export type AboutStudioSh_BlockType = ElementInterface & SuperTableBlockInterface & {
  __typename: 'aboutStudioSh_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  contactDesignStudio?: Maybe<Array<Maybe<ContactDesignStudio_TableRow>>>;
  contactEditorial?: Maybe<Array<Maybe<ContactEditorial_TableRow>>>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The ID of the field that owns the Super Table block. */
  fieldId?: Maybe<Scalars['Int']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  intoText?: Maybe<Scalars['String']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The ID of the element that owns the Super Table block. */
  ownerId?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  socialMediaEntries?: Maybe<Array<Maybe<SocialMediaEntries_TableRow>>>;
  socialMediaHeading?: Maybe<Scalars['String']>;
  /** The sort order of the Super Table block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The ID of the Super Table block's type. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
};


export type AboutStudioSh_BlockType_CountArgs = {
  field: Scalars['String'];
};

export type AboutStudioSh_SuperTableBlockContainerInput = {
  type_3?: InputMaybe<AboutStudioSh_3_SuperTableBlockInput>;
};

export type AboutStudioSh_SuperTableField = AboutStudioSh_BlockType;

export type AboutStudioSh_SuperTableInput = {
  blocks?: InputMaybe<Array<InputMaybe<AboutStudioSh_SuperTableBlockContainerInput>>>;
  sortOrder?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
};

export type AboutStudioSh_AboutStudioSh_Entry = ElementInterface & EntryInterface & {
  __typename: 'aboutStudioSh_aboutStudioSh_Entry';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  aboutStudioSh?: Maybe<Array<Maybe<AboutStudioSh_SuperTableField>>>;
  /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The entry’s author. */
  author?: Maybe<UserInterface>;
  /** The ID of the author of this entry. */
  authorId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical ID. */
  canonicalId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical UUID. */
  canonicalUid?: Maybe<Scalars['String']>;
  /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
  children?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The current revision for the entry. */
  currentRevision?: Maybe<EntryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The creator of a given draft. */
  draftCreator?: Maybe<UserInterface>;
  /** The draft ID (from the `drafts` table). */
  draftId?: Maybe<Scalars['Int']>;
  /** The name of the draft. */
  draftName?: Maybe<Scalars['String']>;
  /** The notes for the draft. */
  draftNotes?: Maybe<Scalars['String']>;
  /** The drafts for the entry. */
  drafts?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The expiry date of the entry. */
  expiryDate?: Maybe<Scalars['DateTime']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** Returns whether this is a draft. */
  isDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is a revision. */
  isRevision?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. */
  isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. **This field is deprecated.** `isUnpublishedDraft` should be used instead. */
  isUnsavedDraft?: Maybe<Scalars['Boolean']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']>;
  /** The same element in other locales. */
  localized?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<EntryInterface>;
  /** The entry’s parent, if the section is a structure. */
  parent?: Maybe<EntryInterface>;
  /** The entry’s post date. */
  postDate?: Maybe<Scalars['DateTime']>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<EntryInterface>;
  /** The creator of a given revision. */
  revisionCreator?: Maybe<UserInterface>;
  /** The revision ID (from the `revisions` table). */
  revisionId?: Maybe<Scalars['Int']>;
  /** The revisions for the entry. */
  revisions?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The handle of the section that contains the entry. */
  sectionHandle?: Maybe<Scalars['String']>;
  /** The ID of the section that contains the entry. */
  sectionId?: Maybe<Scalars['Int']>;
  seo?: Maybe<Ether_SeoData>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /**
   * Returns the entry’s canonical ID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
   */
  sourceId?: Maybe<Scalars['Int']>;
  /**
   * Returns the entry’s canonical UUID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
   */
  sourceUid?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the entry type that contains the entry. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the entry type that contains the entry. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']>;
};


export type AboutStudioSh_AboutStudioSh_Entry_CountArgs = {
  field: Scalars['String'];
};


export type AboutStudioSh_AboutStudioSh_EntryAboutStudioShArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type AboutStudioSh_AboutStudioSh_EntryAncestorsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type AboutStudioSh_AboutStudioSh_EntryChildrenArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type AboutStudioSh_AboutStudioSh_EntryDescendantsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type AboutStudioSh_AboutStudioSh_EntryDraftsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type AboutStudioSh_AboutStudioSh_EntryLocalizedArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type AboutStudioSh_AboutStudioSh_EntryNextArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type AboutStudioSh_AboutStudioSh_EntryParentArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type AboutStudioSh_AboutStudioSh_EntryPrevArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type AboutStudioSh_AboutStudioSh_EntryRevisionsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type About_MatrixBlockContainerInput = {
  footerAbout?: InputMaybe<About_FooterAbout_MatrixBlockInput>;
};

export type About_MatrixField = About_FooterAbout_BlockType;

export type About_MatrixInput = {
  blocks?: InputMaybe<Array<InputMaybe<About_MatrixBlockContainerInput>>>;
  sortOrder?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
};

export type About_FooterAbout_BlockType = ElementInterface & MatrixBlockInterface & {
  __typename: 'about_footerAbout_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  aboutText?: Maybe<Scalars['String']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The ID of the field that owns the matrix block. */
  fieldId?: Maybe<Scalars['Int']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The ID of the element that owns the matrix block. */
  ownerId?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The sort order of the matrix block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the matrix block’s type. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the matrix block’s type. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
};


export type About_FooterAbout_BlockType_CountArgs = {
  field: Scalars['String'];
};

export type About_FooterAbout_MatrixBlockInput = {
  aboutText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type Ads_ContentBanner_Entry = ElementInterface & EntryInterface & {
  __typename: 'ads_contentBanner_Entry';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  advertisingImage?: Maybe<Array<Maybe<AssetInterface>>>;
  /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The entry’s author. */
  author?: Maybe<UserInterface>;
  /** The ID of the author of this entry. */
  authorId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical ID. */
  canonicalId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical UUID. */
  canonicalUid?: Maybe<Scalars['String']>;
  /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
  children?: Maybe<Array<Maybe<EntryInterface>>>;
  clickCounter?: Maybe<Scalars['Number']>;
  /** The current revision for the entry. */
  currentRevision?: Maybe<EntryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The creator of a given draft. */
  draftCreator?: Maybe<UserInterface>;
  /** The draft ID (from the `drafts` table). */
  draftId?: Maybe<Scalars['Int']>;
  /** The name of the draft. */
  draftName?: Maybe<Scalars['String']>;
  /** The notes for the draft. */
  draftNotes?: Maybe<Scalars['String']>;
  /** The drafts for the entry. */
  drafts?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The expiry date of the entry. */
  expiryDate?: Maybe<Scalars['DateTime']>;
  externalLink?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** Returns whether this is a draft. */
  isDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is a revision. */
  isRevision?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. */
  isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. **This field is deprecated.** `isUnpublishedDraft` should be used instead. */
  isUnsavedDraft?: Maybe<Scalars['Boolean']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']>;
  /** The same element in other locales. */
  localized?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<EntryInterface>;
  /** The entry’s parent, if the section is a structure. */
  parent?: Maybe<EntryInterface>;
  /** The entry’s post date. */
  postDate?: Maybe<Scalars['DateTime']>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<EntryInterface>;
  /** The creator of a given revision. */
  revisionCreator?: Maybe<UserInterface>;
  /** The revision ID (from the `revisions` table). */
  revisionId?: Maybe<Scalars['Int']>;
  /** The revisions for the entry. */
  revisions?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The handle of the section that contains the entry. */
  sectionHandle?: Maybe<Scalars['String']>;
  /** The ID of the section that contains the entry. */
  sectionId?: Maybe<Scalars['Int']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /**
   * Returns the entry’s canonical ID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
   */
  sourceId?: Maybe<Scalars['Int']>;
  /**
   * Returns the entry’s canonical UUID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
   */
  sourceUid?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the entry type that contains the entry. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the entry type that contains the entry. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']>;
};


export type Ads_ContentBanner_Entry_CountArgs = {
  field: Scalars['String'];
};


export type Ads_ContentBanner_EntryAdvertisingImageArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Ads_ContentBanner_EntryAncestorsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Ads_ContentBanner_EntryChildrenArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Ads_ContentBanner_EntryDescendantsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Ads_ContentBanner_EntryDraftsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Ads_ContentBanner_EntryLocalizedArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Ads_ContentBanner_EntryNextArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Ads_ContentBanner_EntryParentArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Ads_ContentBanner_EntryPrevArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Ads_ContentBanner_EntryRevisionsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Ads_LandingpageBanner_Entry = ElementInterface & EntryInterface & {
  __typename: 'ads_landingpageBanner_Entry';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  advertisingImage?: Maybe<Array<Maybe<AssetInterface>>>;
  /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The entry’s author. */
  author?: Maybe<UserInterface>;
  /** The ID of the author of this entry. */
  authorId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical ID. */
  canonicalId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical UUID. */
  canonicalUid?: Maybe<Scalars['String']>;
  /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
  children?: Maybe<Array<Maybe<EntryInterface>>>;
  clickCounter?: Maybe<Scalars['Number']>;
  /** The current revision for the entry. */
  currentRevision?: Maybe<EntryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The creator of a given draft. */
  draftCreator?: Maybe<UserInterface>;
  /** The draft ID (from the `drafts` table). */
  draftId?: Maybe<Scalars['Int']>;
  /** The name of the draft. */
  draftName?: Maybe<Scalars['String']>;
  /** The notes for the draft. */
  draftNotes?: Maybe<Scalars['String']>;
  /** The drafts for the entry. */
  drafts?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The expiry date of the entry. */
  expiryDate?: Maybe<Scalars['DateTime']>;
  externalLink?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** Returns whether this is a draft. */
  isDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is a revision. */
  isRevision?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. */
  isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. **This field is deprecated.** `isUnpublishedDraft` should be used instead. */
  isUnsavedDraft?: Maybe<Scalars['Boolean']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']>;
  /** The same element in other locales. */
  localized?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<EntryInterface>;
  /** The entry’s parent, if the section is a structure. */
  parent?: Maybe<EntryInterface>;
  /** The entry’s post date. */
  postDate?: Maybe<Scalars['DateTime']>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<EntryInterface>;
  /** The creator of a given revision. */
  revisionCreator?: Maybe<UserInterface>;
  /** The revision ID (from the `revisions` table). */
  revisionId?: Maybe<Scalars['Int']>;
  /** The revisions for the entry. */
  revisions?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The handle of the section that contains the entry. */
  sectionHandle?: Maybe<Scalars['String']>;
  /** The ID of the section that contains the entry. */
  sectionId?: Maybe<Scalars['Int']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /**
   * Returns the entry’s canonical ID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
   */
  sourceId?: Maybe<Scalars['Int']>;
  /**
   * Returns the entry’s canonical UUID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
   */
  sourceUid?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the entry type that contains the entry. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the entry type that contains the entry. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']>;
};


export type Ads_LandingpageBanner_Entry_CountArgs = {
  field: Scalars['String'];
};


export type Ads_LandingpageBanner_EntryAdvertisingImageArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Ads_LandingpageBanner_EntryAncestorsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Ads_LandingpageBanner_EntryChildrenArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Ads_LandingpageBanner_EntryDescendantsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Ads_LandingpageBanner_EntryDraftsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Ads_LandingpageBanner_EntryLocalizedArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Ads_LandingpageBanner_EntryNextArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Ads_LandingpageBanner_EntryParentArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Ads_LandingpageBanner_EntryPrevArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Ads_LandingpageBanner_EntryRevisionsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Ads_SidebarBanner_Entry = ElementInterface & EntryInterface & {
  __typename: 'ads_sidebarBanner_Entry';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  advertisingImage?: Maybe<Array<Maybe<AssetInterface>>>;
  /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The entry’s author. */
  author?: Maybe<UserInterface>;
  /** The ID of the author of this entry. */
  authorId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical ID. */
  canonicalId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical UUID. */
  canonicalUid?: Maybe<Scalars['String']>;
  /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
  children?: Maybe<Array<Maybe<EntryInterface>>>;
  clickCounter?: Maybe<Scalars['Number']>;
  /** The current revision for the entry. */
  currentRevision?: Maybe<EntryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The creator of a given draft. */
  draftCreator?: Maybe<UserInterface>;
  /** The draft ID (from the `drafts` table). */
  draftId?: Maybe<Scalars['Int']>;
  /** The name of the draft. */
  draftName?: Maybe<Scalars['String']>;
  /** The notes for the draft. */
  draftNotes?: Maybe<Scalars['String']>;
  /** The drafts for the entry. */
  drafts?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The expiry date of the entry. */
  expiryDate?: Maybe<Scalars['DateTime']>;
  externalLink?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** Returns whether this is a draft. */
  isDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is a revision. */
  isRevision?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. */
  isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. **This field is deprecated.** `isUnpublishedDraft` should be used instead. */
  isUnsavedDraft?: Maybe<Scalars['Boolean']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']>;
  /** The same element in other locales. */
  localized?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<EntryInterface>;
  /** The entry’s parent, if the section is a structure. */
  parent?: Maybe<EntryInterface>;
  /** The entry’s post date. */
  postDate?: Maybe<Scalars['DateTime']>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<EntryInterface>;
  /** The creator of a given revision. */
  revisionCreator?: Maybe<UserInterface>;
  /** The revision ID (from the `revisions` table). */
  revisionId?: Maybe<Scalars['Int']>;
  /** The revisions for the entry. */
  revisions?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The handle of the section that contains the entry. */
  sectionHandle?: Maybe<Scalars['String']>;
  /** The ID of the section that contains the entry. */
  sectionId?: Maybe<Scalars['Int']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /**
   * Returns the entry’s canonical ID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
   */
  sourceId?: Maybe<Scalars['Int']>;
  /**
   * Returns the entry’s canonical UUID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
   */
  sourceUid?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the entry type that contains the entry. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the entry type that contains the entry. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']>;
};


export type Ads_SidebarBanner_Entry_CountArgs = {
  field: Scalars['String'];
};


export type Ads_SidebarBanner_EntryAdvertisingImageArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Ads_SidebarBanner_EntryAncestorsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Ads_SidebarBanner_EntryChildrenArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Ads_SidebarBanner_EntryDescendantsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Ads_SidebarBanner_EntryDraftsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Ads_SidebarBanner_EntryLocalizedArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Ads_SidebarBanner_EntryNextArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Ads_SidebarBanner_EntryParentArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Ads_SidebarBanner_EntryPrevArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Ads_SidebarBanner_EntryRevisionsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Advertise_Advertise_Entry = ElementInterface & EntryInterface & {
  __typename: 'advertise_advertise_Entry';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  advertisePdf?: Maybe<Array<Maybe<AssetInterface>>>;
  /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The entry’s author. */
  author?: Maybe<UserInterface>;
  /** The ID of the author of this entry. */
  authorId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical ID. */
  canonicalId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical UUID. */
  canonicalUid?: Maybe<Scalars['String']>;
  /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
  children?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The current revision for the entry. */
  currentRevision?: Maybe<EntryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The creator of a given draft. */
  draftCreator?: Maybe<UserInterface>;
  /** The draft ID (from the `drafts` table). */
  draftId?: Maybe<Scalars['Int']>;
  /** The name of the draft. */
  draftName?: Maybe<Scalars['String']>;
  /** The notes for the draft. */
  draftNotes?: Maybe<Scalars['String']>;
  /** The drafts for the entry. */
  drafts?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The expiry date of the entry. */
  expiryDate?: Maybe<Scalars['DateTime']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** Returns whether this is a draft. */
  isDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is a revision. */
  isRevision?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. */
  isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. **This field is deprecated.** `isUnpublishedDraft` should be used instead. */
  isUnsavedDraft?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']>;
  /** The same element in other locales. */
  localized?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<EntryInterface>;
  /** The entry’s parent, if the section is a structure. */
  parent?: Maybe<EntryInterface>;
  /** The entry’s post date. */
  postDate?: Maybe<Scalars['DateTime']>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<EntryInterface>;
  /** The creator of a given revision. */
  revisionCreator?: Maybe<UserInterface>;
  /** The revision ID (from the `revisions` table). */
  revisionId?: Maybe<Scalars['Int']>;
  /** The revisions for the entry. */
  revisions?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The handle of the section that contains the entry. */
  sectionHandle?: Maybe<Scalars['String']>;
  /** The ID of the section that contains the entry. */
  sectionId?: Maybe<Scalars['Int']>;
  seo?: Maybe<Ether_SeoData>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /**
   * Returns the entry’s canonical ID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
   */
  sourceId?: Maybe<Scalars['Int']>;
  /**
   * Returns the entry’s canonical UUID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
   */
  sourceUid?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the entry type that contains the entry. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the entry type that contains the entry. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']>;
};


export type Advertise_Advertise_Entry_CountArgs = {
  field: Scalars['String'];
};


export type Advertise_Advertise_EntryAdvertisePdfArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Advertise_Advertise_EntryAncestorsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Advertise_Advertise_EntryChildrenArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Advertise_Advertise_EntryDescendantsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Advertise_Advertise_EntryDraftsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Advertise_Advertise_EntryLocalizedArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Advertise_Advertise_EntryNextArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Advertise_Advertise_EntryParentArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Advertise_Advertise_EntryPrevArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Advertise_Advertise_EntryRevisionsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type ArchiveAssets_Asset = AssetInterface & ElementInterface & {
  __typename: 'archiveAssets_Asset';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the asset file was last modified. */
  dateModified?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** This queries for a single embedded asset. */
  embeddedAsset?: Maybe<EmbeddedAssetInterface>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The file extension for the asset file. */
  extension?: Maybe<Scalars['String']>;
  /** The filename of the asset file. */
  filename?: Maybe<Scalars['String']>;
  /** The focal point represented as an array with `x` and `y` keys, or null if it’s not an image. */
  focalPoint?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** The ID of the folder that the asset belongs to. */
  folderId?: Maybe<Scalars['Int']>;
  /** Whether a user-defined focal point is set on the asset. */
  hasFocalPoint?: Maybe<Scalars['Boolean']>;
  /** The height in pixels or null if it’s not an image. */
  height?: Maybe<Scalars['Int']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** An `<img>` tag based on this asset. */
  img?: Maybe<Scalars['String']>;
  /** The file kind. */
  kind?: Maybe<Scalars['String']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The file’s MIME type, if it can be determined. */
  mimeType?: Maybe<Scalars['String']>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<AssetInterface>;
  /** The asset’s path in the volume. */
  path?: Maybe<Scalars['String']>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<AssetInterface>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The file size in bytes. */
  size?: Maybe<Scalars['String']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** Returns a `srcset` attribute value based on the given widths or x-descriptors. */
  srcset?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The user who first added this asset (if known). */
  uploader?: Maybe<UserInterface>;
  /** The ID of the user who first added this asset (if known). */
  uploaderId?: Maybe<Scalars['Int']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  /** The full URL of the asset. This field accepts the same fields as the `transform` directive. */
  url?: Maybe<Scalars['String']>;
  /** The ID of the volume that the asset belongs to. */
  volumeId?: Maybe<Scalars['Int']>;
  /** The width in pixels or null if it’s not an image. */
  width?: Maybe<Scalars['Int']>;
};


export type ArchiveAssets_Asset_CountArgs = {
  field: Scalars['String'];
};


export type ArchiveAssets_AssetHeightArgs = {
  format?: InputMaybe<Scalars['String']>;
  handle?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  immediately?: InputMaybe<Scalars['Boolean']>;
  interlace?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  quality?: InputMaybe<Scalars['Int']>;
  transform?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};


export type ArchiveAssets_AssetNextArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ArchiveAssets_AssetPrevArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ArchiveAssets_AssetSrcsetArgs = {
  sizes: Array<Scalars['String']>;
};


export type ArchiveAssets_AssetUploaderArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  email?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasPhoto?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  username?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ArchiveAssets_AssetUrlArgs = {
  format?: InputMaybe<Scalars['String']>;
  handle?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  immediately?: InputMaybe<Scalars['Boolean']>;
  interlace?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  quality?: InputMaybe<Scalars['Int']>;
  transform?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};


export type ArchiveAssets_AssetWidthArgs = {
  format?: InputMaybe<Scalars['String']>;
  handle?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  immediately?: InputMaybe<Scalars['Boolean']>;
  interlace?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  quality?: InputMaybe<Scalars['Int']>;
  transform?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type Archive_Archive_Entry = ElementInterface & EntryInterface & {
  __typename: 'archive_archive_Entry';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The entry’s author. */
  author?: Maybe<UserInterface>;
  /** The ID of the author of this entry. */
  authorId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical ID. */
  canonicalId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical UUID. */
  canonicalUid?: Maybe<Scalars['String']>;
  /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
  children?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The current revision for the entry. */
  currentRevision?: Maybe<EntryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The creator of a given draft. */
  draftCreator?: Maybe<UserInterface>;
  /** The draft ID (from the `drafts` table). */
  draftId?: Maybe<Scalars['Int']>;
  /** The name of the draft. */
  draftName?: Maybe<Scalars['String']>;
  /** The notes for the draft. */
  draftNotes?: Maybe<Scalars['String']>;
  /** The drafts for the entry. */
  drafts?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The expiry date of the entry. */
  expiryDate?: Maybe<Scalars['DateTime']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** Returns whether this is a draft. */
  isDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is a revision. */
  isRevision?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. */
  isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. **This field is deprecated.** `isUnpublishedDraft` should be used instead. */
  isUnsavedDraft?: Maybe<Scalars['Boolean']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']>;
  /** The same element in other locales. */
  localized?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<EntryInterface>;
  /** The entry’s parent, if the section is a structure. */
  parent?: Maybe<EntryInterface>;
  /** The entry’s post date. */
  postDate?: Maybe<Scalars['DateTime']>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<EntryInterface>;
  /** The creator of a given revision. */
  revisionCreator?: Maybe<UserInterface>;
  /** The revision ID (from the `revisions` table). */
  revisionId?: Maybe<Scalars['Int']>;
  /** The revisions for the entry. */
  revisions?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The handle of the section that contains the entry. */
  sectionHandle?: Maybe<Scalars['String']>;
  /** The ID of the section that contains the entry. */
  sectionId?: Maybe<Scalars['Int']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /**
   * Returns the entry’s canonical ID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
   */
  sourceId?: Maybe<Scalars['Int']>;
  /**
   * Returns the entry’s canonical UUID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
   */
  sourceUid?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the entry type that contains the entry. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the entry type that contains the entry. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']>;
};


export type Archive_Archive_Entry_CountArgs = {
  field: Scalars['String'];
};


export type Archive_Archive_EntryAncestorsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Archive_Archive_EntryChildrenArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Archive_Archive_EntryDescendantsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Archive_Archive_EntryDraftsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Archive_Archive_EntryLocalizedArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Archive_Archive_EntryNextArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Archive_Archive_EntryParentArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Archive_Archive_EntryPrevArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Archive_Archive_EntryRevisionsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type ArchivedPost_Default_Entry = ElementInterface & EntryInterface & {
  __typename: 'archivedPost_default_Entry';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The entry’s author. */
  author?: Maybe<UserInterface>;
  /** The ID of the author of this entry. */
  authorId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical ID. */
  canonicalId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical UUID. */
  canonicalUid?: Maybe<Scalars['String']>;
  /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
  children?: Maybe<Array<Maybe<EntryInterface>>>;
  curatorArchive?: Maybe<Scalars['String']>;
  /** The current revision for the entry. */
  currentRevision?: Maybe<EntryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The creator of a given draft. */
  draftCreator?: Maybe<UserInterface>;
  /** The draft ID (from the `drafts` table). */
  draftId?: Maybe<Scalars['Int']>;
  /** The name of the draft. */
  draftName?: Maybe<Scalars['String']>;
  /** The notes for the draft. */
  draftNotes?: Maybe<Scalars['String']>;
  /** The drafts for the entry. */
  drafts?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  endOfExhibition?: Maybe<Scalars['DateTime']>;
  exhibitionTitle?: Maybe<Scalars['String']>;
  /** The expiry date of the entry. */
  expiryDate?: Maybe<Scalars['DateTime']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  imagesArchive?: Maybe<Array<Maybe<ImagesArchive_MatrixField>>>;
  /** Returns whether this is a draft. */
  isDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is a revision. */
  isRevision?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. */
  isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. **This field is deprecated.** `isUnpublishedDraft` should be used instead. */
  isUnsavedDraft?: Maybe<Scalars['Boolean']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']>;
  linkToLocationArchive?: Maybe<Scalars['String']>;
  linkToVideo?: Maybe<Scalars['String']>;
  /** The same element in other locales. */
  localized?: Maybe<Array<Maybe<EntryInterface>>>;
  locationNameArchiv?: Maybe<Scalars['String']>;
  names?: Maybe<Scalars['String']>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<EntryInterface>;
  openingExhibition?: Maybe<Scalars['DateTime']>;
  /** The entry’s parent, if the section is a structure. */
  parent?: Maybe<EntryInterface>;
  photographer?: Maybe<Scalars['String']>;
  /** The entry’s post date. */
  postDate?: Maybe<Scalars['DateTime']>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<EntryInterface>;
  /** The creator of a given revision. */
  revisionCreator?: Maybe<UserInterface>;
  /** The revision ID (from the `revisions` table). */
  revisionId?: Maybe<Scalars['Int']>;
  /** The revisions for the entry. */
  revisions?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The handle of the section that contains the entry. */
  sectionHandle?: Maybe<Scalars['String']>;
  /** The ID of the section that contains the entry. */
  sectionId?: Maybe<Scalars['Int']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /**
   * Returns the entry’s canonical ID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
   */
  sourceId?: Maybe<Scalars['Int']>;
  /**
   * Returns the entry’s canonical UUID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
   */
  sourceUid?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']>;
  subheadline?: Maybe<Scalars['String']>;
  textArchive?: Maybe<Scalars['String']>;
  textAuthor?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the entry type that contains the entry. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the entry type that contains the entry. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']>;
};


export type ArchivedPost_Default_Entry_CountArgs = {
  field: Scalars['String'];
};


export type ArchivedPost_Default_EntryAncestorsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type ArchivedPost_Default_EntryChildrenArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type ArchivedPost_Default_EntryDescendantsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type ArchivedPost_Default_EntryDraftsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type ArchivedPost_Default_EntryImagesArchiveArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ArchivedPost_Default_EntryLocalizedArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type ArchivedPost_Default_EntryNextArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type ArchivedPost_Default_EntryParentArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type ArchivedPost_Default_EntryPrevArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type ArchivedPost_Default_EntryRevisionsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Assets_Asset = AssetInterface & ElementInterface & {
  __typename: 'assets_Asset';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the asset file was last modified. */
  dateModified?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  /** This queries for a single embedded asset. */
  embeddedAsset?: Maybe<EmbeddedAssetInterface>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The file extension for the asset file. */
  extension?: Maybe<Scalars['String']>;
  /** The filename of the asset file. */
  filename?: Maybe<Scalars['String']>;
  /** The focal point represented as an array with `x` and `y` keys, or null if it’s not an image. */
  focalPoint?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** The ID of the folder that the asset belongs to. */
  folderId?: Maybe<Scalars['Int']>;
  /** Whether a user-defined focal point is set on the asset. */
  hasFocalPoint?: Maybe<Scalars['Boolean']>;
  /** The height in pixels or null if it’s not an image. */
  height?: Maybe<Scalars['Int']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** An `<img>` tag based on this asset. */
  img?: Maybe<Scalars['String']>;
  /** The file kind. */
  kind?: Maybe<Scalars['String']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The file’s MIME type, if it can be determined. */
  mimeType?: Maybe<Scalars['String']>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<AssetInterface>;
  /** The asset’s path in the volume. */
  path?: Maybe<Scalars['String']>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<AssetInterface>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The file size in bytes. */
  size?: Maybe<Scalars['String']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** Returns a `srcset` attribute value based on the given widths or x-descriptors. */
  srcset?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The user who first added this asset (if known). */
  uploader?: Maybe<UserInterface>;
  /** The ID of the user who first added this asset (if known). */
  uploaderId?: Maybe<Scalars['Int']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  /** The full URL of the asset. This field accepts the same fields as the `transform` directive. */
  url?: Maybe<Scalars['String']>;
  /** The ID of the volume that the asset belongs to. */
  volumeId?: Maybe<Scalars['Int']>;
  /** The width in pixels or null if it’s not an image. */
  width?: Maybe<Scalars['Int']>;
};


export type Assets_Asset_CountArgs = {
  field: Scalars['String'];
};


export type Assets_AssetHeightArgs = {
  format?: InputMaybe<Scalars['String']>;
  handle?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  immediately?: InputMaybe<Scalars['Boolean']>;
  interlace?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  quality?: InputMaybe<Scalars['Int']>;
  transform?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};


export type Assets_AssetNextArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Assets_AssetPrevArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Assets_AssetSrcsetArgs = {
  sizes: Array<Scalars['String']>;
};


export type Assets_AssetUploaderArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  email?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasPhoto?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  username?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Assets_AssetUrlArgs = {
  format?: InputMaybe<Scalars['String']>;
  handle?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  immediately?: InputMaybe<Scalars['Boolean']>;
  interlace?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  quality?: InputMaybe<Scalars['Int']>;
  transform?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};


export type Assets_AssetWidthArgs = {
  format?: InputMaybe<Scalars['String']>;
  handle?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  immediately?: InputMaybe<Scalars['Boolean']>;
  interlace?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  quality?: InputMaybe<Scalars['Int']>;
  transform?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type Background_MatrixBlockContainerInput = {
  image?: InputMaybe<Background_Image_MatrixBlockInput>;
  video?: InputMaybe<Background_Video_MatrixBlockInput>;
};

export type Background_MatrixField = Background_Image_BlockType | Background_Video_BlockType;

export type Background_MatrixInput = {
  blocks?: InputMaybe<Array<InputMaybe<Background_MatrixBlockContainerInput>>>;
  sortOrder?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
};

export type Background_Image_BlockType = ElementInterface & MatrixBlockInterface & {
  __typename: 'background_image_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The ID of the field that owns the matrix block. */
  fieldId?: Maybe<Scalars['Int']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Array<Maybe<AssetInterface>>>;
  imageDarkMode?: Maybe<Array<Maybe<AssetInterface>>>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The ID of the element that owns the matrix block. */
  ownerId?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The sort order of the matrix block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the matrix block’s type. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the matrix block’s type. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
};


export type Background_Image_BlockType_CountArgs = {
  field: Scalars['String'];
};


export type Background_Image_BlockTypeImageArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Background_Image_BlockTypeImageDarkModeArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Background_Image_MatrixBlockInput = {
  id?: InputMaybe<Scalars['ID']>;
  image?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  imageDarkMode?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type Background_Video_BlockType = ElementInterface & MatrixBlockInterface & {
  __typename: 'background_video_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The ID of the field that owns the matrix block. */
  fieldId?: Maybe<Scalars['Int']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The ID of the element that owns the matrix block. */
  ownerId?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The sort order of the matrix block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the matrix block’s type. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the matrix block’s type. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  video?: Maybe<Array<Maybe<AssetInterface>>>;
};


export type Background_Video_BlockType_CountArgs = {
  field: Scalars['String'];
};


export type Background_Video_BlockTypeVideoArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Background_Video_MatrixBlockInput = {
  id?: InputMaybe<Scalars['ID']>;
  video?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type Calendar_Calendar_Entry = ElementInterface & EntryInterface & {
  __typename: 'calendar_calendar_Entry';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The entry’s author. */
  author?: Maybe<UserInterface>;
  /** The ID of the author of this entry. */
  authorId?: Maybe<Scalars['Int']>;
  bgColor?: Maybe<Scalars['String']>;
  /** Returns the entry’s canonical ID. */
  canonicalId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical UUID. */
  canonicalUid?: Maybe<Scalars['String']>;
  /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
  children?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The current revision for the entry. */
  currentRevision?: Maybe<EntryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The creator of a given draft. */
  draftCreator?: Maybe<UserInterface>;
  /** The draft ID (from the `drafts` table). */
  draftId?: Maybe<Scalars['Int']>;
  /** The name of the draft. */
  draftName?: Maybe<Scalars['String']>;
  /** The notes for the draft. */
  draftNotes?: Maybe<Scalars['String']>;
  /** The drafts for the entry. */
  drafts?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The expiry date of the entry. */
  expiryDate?: Maybe<Scalars['DateTime']>;
  fontColor?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** Returns whether this is a draft. */
  isDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is a revision. */
  isRevision?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. */
  isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. **This field is deprecated.** `isUnpublishedDraft` should be used instead. */
  isUnsavedDraft?: Maybe<Scalars['Boolean']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']>;
  /** The same element in other locales. */
  localized?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<EntryInterface>;
  /** The entry’s parent, if the section is a structure. */
  parent?: Maybe<EntryInterface>;
  /** The entry’s post date. */
  postDate?: Maybe<Scalars['DateTime']>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<EntryInterface>;
  /** The creator of a given revision. */
  revisionCreator?: Maybe<UserInterface>;
  /** The revision ID (from the `revisions` table). */
  revisionId?: Maybe<Scalars['Int']>;
  /** The revisions for the entry. */
  revisions?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The handle of the section that contains the entry. */
  sectionHandle?: Maybe<Scalars['String']>;
  /** The ID of the section that contains the entry. */
  sectionId?: Maybe<Scalars['Int']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /**
   * Returns the entry’s canonical ID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
   */
  sourceId?: Maybe<Scalars['Int']>;
  /**
   * Returns the entry’s canonical UUID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
   */
  sourceUid?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the entry type that contains the entry. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the entry type that contains the entry. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']>;
};


export type Calendar_Calendar_Entry_CountArgs = {
  field: Scalars['String'];
};


export type Calendar_Calendar_EntryAncestorsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Calendar_Calendar_EntryChildrenArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Calendar_Calendar_EntryDescendantsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Calendar_Calendar_EntryDraftsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Calendar_Calendar_EntryLocalizedArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Calendar_Calendar_EntryNextArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Calendar_Calendar_EntryParentArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Calendar_Calendar_EntryPrevArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Calendar_Calendar_EntryRevisionsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Colors_Category = CategoryInterface & ElementInterface & {
  __typename: 'colors_Category';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The category’s children. */
  children?: Maybe<Array<Maybe<CategoryInterface>>>;
  color?: Maybe<Scalars['String']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The handle of the group that contains the category. */
  groupHandle?: Maybe<Scalars['String']>;
  /** The ID of the group that contains the category. */
  groupId?: Maybe<Scalars['Int']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']>;
  /** The same element in other locales. */
  localized?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<CategoryInterface>;
  /** The category’s parent. */
  parent?: Maybe<CategoryInterface>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<CategoryInterface>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']>;
};


export type Colors_Category_CountArgs = {
  field: Scalars['String'];
};


export type Colors_CategoryChildrenArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Colors_CategoryLocalizedArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Colors_CategoryNextArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Colors_CategoryParentArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Colors_CategoryPrevArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type ContactDesignStudio_TableRow = {
  __typename: 'contactDesignStudio_TableRow';
  col1?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type ContactDesignStudio_TableRowInput = {
  col1?: InputMaybe<Scalars['String']>;
};

export type ContactEditorial_TableRow = {
  __typename: 'contactEditorial_TableRow';
  col1?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type ContactEditorial_TableRowInput = {
  col1?: InputMaybe<Scalars['String']>;
};

export type ContentBlocks_MatrixBlockContainerInput = {
  Slider?: InputMaybe<ContentBlocks_Slider_MatrixBlockInput>;
  image?: InputMaybe<ContentBlocks_Image_MatrixBlockInput>;
  imagePair?: InputMaybe<ContentBlocks_ImagePair_MatrixBlockInput>;
  instagram?: InputMaybe<ContentBlocks_Instagram_MatrixBlockInput>;
  interview?: InputMaybe<ContentBlocks_Interview_MatrixBlockInput>;
  textBlock?: InputMaybe<ContentBlocks_TextBlock_MatrixBlockInput>;
  video?: InputMaybe<ContentBlocks_Video_MatrixBlockInput>;
};

export type ContentBlocks_MatrixField = ContentBlocks_Slider_BlockType | ContentBlocks_ImagePair_BlockType | ContentBlocks_Image_BlockType | ContentBlocks_Instagram_BlockType | ContentBlocks_Interview_BlockType | ContentBlocks_TextBlock_BlockType | ContentBlocks_Video_BlockType;

export type ContentBlocks_MatrixInput = {
  blocks?: InputMaybe<Array<InputMaybe<ContentBlocks_MatrixBlockContainerInput>>>;
  sortOrder?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
};

export type ContentBlocks_Slider_BlockType = ElementInterface & MatrixBlockInterface & {
  __typename: 'contentBlocks_Slider_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The ID of the field that owns the matrix block. */
  fieldId?: Maybe<Scalars['Int']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The ID of the element that owns the matrix block. */
  ownerId?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  slides?: Maybe<Array<Maybe<AssetInterface>>>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The sort order of the matrix block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the matrix block’s type. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the matrix block’s type. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
};


export type ContentBlocks_Slider_BlockType_CountArgs = {
  field: Scalars['String'];
};


export type ContentBlocks_Slider_BlockTypeSlidesArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ContentBlocks_Slider_MatrixBlockInput = {
  id?: InputMaybe<Scalars['ID']>;
  slides?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type ContentBlocks_ImagePair_BlockType = ElementInterface & MatrixBlockInterface & {
  __typename: 'contentBlocks_imagePair_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The ID of the field that owns the matrix block. */
  fieldId?: Maybe<Scalars['Int']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  kind?: Maybe<Scalars['String']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  leftImage?: Maybe<Array<Maybe<AssetInterface>>>;
  /** The ID of the element that owns the matrix block. */
  ownerId?: Maybe<Scalars['Int']>;
  rightImage?: Maybe<Array<Maybe<AssetInterface>>>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The sort order of the matrix block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the matrix block’s type. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the matrix block’s type. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
};


export type ContentBlocks_ImagePair_BlockType_CountArgs = {
  field: Scalars['String'];
};


export type ContentBlocks_ImagePair_BlockTypeKindArgs = {
  label?: InputMaybe<Scalars['Boolean']>;
};


export type ContentBlocks_ImagePair_BlockTypeLeftImageArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ContentBlocks_ImagePair_BlockTypeRightImageArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ContentBlocks_ImagePair_MatrixBlockInput = {
  id?: InputMaybe<Scalars['ID']>;
  /** The allowed values are [“small”, “big”] */
  kind?: InputMaybe<Scalars['String']>;
  leftImage?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  rightImage?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type ContentBlocks_Image_BlockType = ElementInterface & MatrixBlockInterface & {
  __typename: 'contentBlocks_image_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The ID of the field that owns the matrix block. */
  fieldId?: Maybe<Scalars['Int']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Array<Maybe<AssetInterface>>>;
  kind?: Maybe<Scalars['String']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The ID of the element that owns the matrix block. */
  ownerId?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The sort order of the matrix block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the matrix block’s type. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the matrix block’s type. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
};


export type ContentBlocks_Image_BlockType_CountArgs = {
  field: Scalars['String'];
};


export type ContentBlocks_Image_BlockTypeImageArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ContentBlocks_Image_BlockTypeKindArgs = {
  label?: InputMaybe<Scalars['Boolean']>;
};

export type ContentBlocks_Image_MatrixBlockInput = {
  id?: InputMaybe<Scalars['ID']>;
  image?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** The allowed values are [“big”, “small”] */
  kind?: InputMaybe<Scalars['String']>;
};

export type ContentBlocks_Instagram_BlockType = ElementInterface & MatrixBlockInterface & {
  __typename: 'contentBlocks_instagram_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  embedCodes?: Maybe<Array<Maybe<EmbedCodes_TableRow>>>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The ID of the field that owns the matrix block. */
  fieldId?: Maybe<Scalars['Int']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The ID of the element that owns the matrix block. */
  ownerId?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The sort order of the matrix block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the matrix block’s type. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the matrix block’s type. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
};


export type ContentBlocks_Instagram_BlockType_CountArgs = {
  field: Scalars['String'];
};

export type ContentBlocks_Instagram_MatrixBlockInput = {
  embedCodes?: InputMaybe<Array<InputMaybe<EmbedCodes_TableRowInput>>>;
  id?: InputMaybe<Scalars['ID']>;
};

export type ContentBlocks_Interview_BlockType = ElementInterface & MatrixBlockInterface & {
  __typename: 'contentBlocks_interview_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The ID of the field that owns the matrix block. */
  fieldId?: Maybe<Scalars['Int']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  interviewee?: Maybe<Array<Maybe<Interviewee_TableRow>>>;
  interviewer?: Maybe<Array<Maybe<Interviewer_TableRow>>>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The ID of the element that owns the matrix block. */
  ownerId?: Maybe<Scalars['Int']>;
  questionsAndAnswers?: Maybe<Array<Maybe<QuestionsAndAnswers_TableRow>>>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The sort order of the matrix block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the matrix block’s type. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the matrix block’s type. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
};


export type ContentBlocks_Interview_BlockType_CountArgs = {
  field: Scalars['String'];
};

export type ContentBlocks_Interview_MatrixBlockInput = {
  id?: InputMaybe<Scalars['ID']>;
  interviewee?: InputMaybe<Array<InputMaybe<Interviewee_TableRowInput>>>;
  interviewer?: InputMaybe<Array<InputMaybe<Interviewer_TableRowInput>>>;
  questionsAndAnswers?: InputMaybe<Array<InputMaybe<QuestionsAndAnswers_TableRowInput>>>;
};

export type ContentBlocks_TextBlock_BlockType = ElementInterface & MatrixBlockInterface & {
  __typename: 'contentBlocks_textBlock_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The ID of the field that owns the matrix block. */
  fieldId?: Maybe<Scalars['Int']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The ID of the element that owns the matrix block. */
  ownerId?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The sort order of the matrix block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the matrix block’s type. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the matrix block’s type. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
};


export type ContentBlocks_TextBlock_BlockType_CountArgs = {
  field: Scalars['String'];
};

export type ContentBlocks_TextBlock_MatrixBlockInput = {
  id?: InputMaybe<Scalars['ID']>;
  text?: InputMaybe<Scalars['String']>;
};

export type ContentBlocks_Video_BlockType = ElementInterface & MatrixBlockInterface & {
  __typename: 'contentBlocks_video_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The ID of the field that owns the matrix block. */
  fieldId?: Maybe<Scalars['Int']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The ID of the element that owns the matrix block. */
  ownerId?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The sort order of the matrix block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the matrix block’s type. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the matrix block’s type. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  video?: Maybe<Array<Maybe<AssetInterface>>>;
};


export type ContentBlocks_Video_BlockType_CountArgs = {
  field: Scalars['String'];
};


export type ContentBlocks_Video_BlockTypeVideoArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ContentBlocks_Video_MatrixBlockInput = {
  id?: InputMaybe<Scalars['ID']>;
  video?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type EmbedCodes_TableRow = {
  __typename: 'embedCodes_TableRow';
  col1?: Maybe<Scalars['String']>;
  embedCode?: Maybe<Scalars['String']>;
};

export type EmbedCodes_TableRowInput = {
  col1?: InputMaybe<Scalars['String']>;
};

export type EventCategory_Category = CategoryInterface & ElementInterface & {
  __typename: 'eventCategory_Category';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The category’s children. */
  children?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The handle of the group that contains the category. */
  groupHandle?: Maybe<Scalars['String']>;
  /** The ID of the group that contains the category. */
  groupId?: Maybe<Scalars['Int']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']>;
  /** The same element in other locales. */
  localized?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<CategoryInterface>;
  /** The category’s parent. */
  parent?: Maybe<CategoryInterface>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<CategoryInterface>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']>;
};


export type EventCategory_Category_CountArgs = {
  field: Scalars['String'];
};


export type EventCategory_CategoryChildrenArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type EventCategory_CategoryLocalizedArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type EventCategory_CategoryNextArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type EventCategory_CategoryParentArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type EventCategory_CategoryPrevArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Event_Form = ElementInterface & FormInterface & {
  __typename: 'event_Form';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** A list of captcha values (name and value) to assist with spam protection */
  captchas?: Maybe<Array<Maybe<FormieCaptchaType>>>;
  /** The form’s config as JSON. */
  configJson?: Maybe<Scalars['String']>;
  /** A CSRF token (name and value) */
  csrfToken?: Maybe<FormieCsrfTokenType>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The form’s fields. */
  fields?: Maybe<Array<Maybe<FieldInterface>>>;
  /** The form’s handle. */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The form’s pages. */
  pages?: Maybe<Array<Maybe<PageInterface>>>;
  /** The form’s rows. */
  rows?: Maybe<Array<Maybe<RowInterface>>>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The form’s settings. */
  settings?: Maybe<FormSettingsType>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The form’s rendered HTML. */
  templateHtml?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
};


export type Event_Form_CountArgs = {
  field: Scalars['String'];
};


export type Event_FormTemplateHtmlArgs = {
  options?: InputMaybe<Scalars['String']>;
  populateFormValues?: InputMaybe<Scalars['String']>;
};

export type Event_Submission = ElementInterface & SubmissionInterface & {
  __typename: 'event_Submission';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  consent?: Maybe<Scalars['String']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  endDate?: Maybe<Scalars['DateTime']>;
  eventCategory?: Maybe<Array<Maybe<CategoryInterface>>>;
  eventTitle?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The submission’s IP Address. */
  ipAddress?: Maybe<Scalars['String']>;
  /** Whether the submission is incomplete. */
  isIncomplete?: Maybe<Scalars['Boolean']>;
  /** Whether the submission is spam. */
  isSpam?: Maybe<Scalars['Boolean']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  linkToLocation?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  namesInvolved?: Maybe<Scalars['String']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The submission’s spam reason. */
  spamReason?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  /** The submission’s status. */
  status?: Maybe<Scalars['String']>;
  /** The submission’s status ID. */
  statusId?: Maybe<Scalars['Int']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
};


export type Event_Submission_CountArgs = {
  field: Scalars['String'];
};


export type Event_SubmissionEventCategoryArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Exhibition_Form = ElementInterface & FormInterface & {
  __typename: 'exhibition_Form';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** A list of captcha values (name and value) to assist with spam protection */
  captchas?: Maybe<Array<Maybe<FormieCaptchaType>>>;
  /** The form’s config as JSON. */
  configJson?: Maybe<Scalars['String']>;
  /** A CSRF token (name and value) */
  csrfToken?: Maybe<FormieCsrfTokenType>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The form’s fields. */
  fields?: Maybe<Array<Maybe<FieldInterface>>>;
  /** The form’s handle. */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The form’s pages. */
  pages?: Maybe<Array<Maybe<PageInterface>>>;
  /** The form’s rows. */
  rows?: Maybe<Array<Maybe<RowInterface>>>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The form’s settings. */
  settings?: Maybe<FormSettingsType>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The form’s rendered HTML. */
  templateHtml?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
};


export type Exhibition_Form_CountArgs = {
  field: Scalars['String'];
};


export type Exhibition_FormTemplateHtmlArgs = {
  options?: InputMaybe<Scalars['String']>;
  populateFormValues?: InputMaybe<Scalars['String']>;
};

export type Exhibition_Submission = ElementInterface & SubmissionInterface & {
  __typename: 'exhibition_Submission';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  artistsName?: Maybe<Scalars['String']>;
  bottomColor?: Maybe<Array<Maybe<CategoryInterface>>>;
  consent?: Maybe<Scalars['String']>;
  curator?: Maybe<Scalars['String']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  exhibitionEnd?: Maybe<Scalars['DateTime']>;
  exhibitionOpening?: Maybe<Scalars['DateTime']>;
  exhibitionTitle?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  images?: Maybe<Exhibition_Images_FormieRepeaterField>;
  /** The submission’s IP Address. */
  ipAddress?: Maybe<Scalars['String']>;
  /** Whether the submission is incomplete. */
  isIncomplete?: Maybe<Scalars['Boolean']>;
  /** Whether the submission is spam. */
  isSpam?: Maybe<Scalars['Boolean']>;
  keyImage?: Maybe<Array<Maybe<AssetInterface>>>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  linkToLocation?: Maybe<Scalars['String']>;
  linkToVideo?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  photographer?: Maybe<Scalars['String']>;
  postCategory?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  socialMediaInfo?: Maybe<Scalars['String']>;
  /** The submission’s spam reason. */
  spamReason?: Maybe<Scalars['String']>;
  /** The submission’s status. */
  status?: Maybe<Scalars['String']>;
  /** The submission’s status ID. */
  statusId?: Maybe<Scalars['Int']>;
  subheadline?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  textAuthor?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  topColor?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  yourEMail?: Maybe<Scalars['String']>;
};


export type Exhibition_Submission_CountArgs = {
  field: Scalars['String'];
};


export type Exhibition_SubmissionBottomColorArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Exhibition_SubmissionKeyImageArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Exhibition_SubmissionPostCategoryArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Exhibition_SubmissionTopColorArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Exhibition_Images_FormieRepeaterField = {
  __typename: 'exhibition_images_FormieRepeaterField';
  rows?: Maybe<Array<Maybe<Exhibition_Images_FormieRepeaterFieldRow>>>;
};

export type Exhibition_Images_FormieRepeaterFieldRow = RowInterface & {
  __typename: 'exhibition_images_FormieRepeaterFieldRow';
  caption?: Maybe<Scalars['String']>;
  /** The row’s fields. */
  fields?: Maybe<Array<Maybe<FieldInterface>>>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Array<Maybe<AssetInterface>>>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
};


export type Exhibition_Images_FormieRepeaterFieldRowImageArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Exhibition_Images_FormieRepeaterInput = {
  rows?: InputMaybe<Array<InputMaybe<Exhibition_Images_RepeaterRowInput>>>;
};

export type Exhibition_Images_RepeaterRowInput = {
  caption?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Array<InputMaybe<FileUploadInput>>>;
};

export type FollowUs_MatrixBlockContainerInput = {
  socialMediaEntry?: InputMaybe<FollowUs_SocialMediaEntry_MatrixBlockInput>;
};

export type FollowUs_MatrixField = FollowUs_SocialMediaEntry_BlockType;

export type FollowUs_MatrixInput = {
  blocks?: InputMaybe<Array<InputMaybe<FollowUs_MatrixBlockContainerInput>>>;
  sortOrder?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
};

export type FollowUs_SocialMediaEntry_BlockType = ElementInterface & MatrixBlockInterface & {
  __typename: 'followUs_socialMediaEntry_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  externalLink?: Maybe<Scalars['String']>;
  /** The ID of the field that owns the matrix block. */
  fieldId?: Maybe<Scalars['Int']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  label?: Maybe<Scalars['String']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The ID of the element that owns the matrix block. */
  ownerId?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The sort order of the matrix block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the matrix block’s type. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the matrix block’s type. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
};


export type FollowUs_SocialMediaEntry_BlockType_CountArgs = {
  field: Scalars['String'];
};

export type FollowUs_SocialMediaEntry_MatrixBlockInput = {
  externalLink?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  label?: InputMaybe<Scalars['String']>;
};

export type Footer_GlobalSet = ElementInterface & GlobalSetInterface & {
  __typename: 'footer_GlobalSet';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  about?: Maybe<Array<Maybe<About_MatrixField>>>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  blogContactEmail?: Maybe<Scalars['String']>;
  blogContactLabel?: Maybe<Scalars['String']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  followUs?: Maybe<Array<Maybe<FollowUs_MatrixField>>>;
  /** The handle of the global set. */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  linkToSingles?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The name of the global set. */
  name?: Maybe<Scalars['String']>;
  newsletterLabel?: Maybe<Scalars['String']>;
  newsletterLink?: Maybe<Scalars['String']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  studioContactEmail?: Maybe<Scalars['String']>;
  studioContactLabel?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
};


export type Footer_GlobalSet_CountArgs = {
  field: Scalars['String'];
};


export type Footer_GlobalSetAboutArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Footer_GlobalSetFollowUsArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Footer_GlobalSetLinkToSinglesArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type ImagesArchive_MatrixBlockContainerInput = {
  image?: InputMaybe<ImagesArchive_Image_MatrixBlockInput>;
};

export type ImagesArchive_MatrixField = ImagesArchive_Image_BlockType;

export type ImagesArchive_MatrixInput = {
  blocks?: InputMaybe<Array<InputMaybe<ImagesArchive_MatrixBlockContainerInput>>>;
  sortOrder?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
};

export type ImagesArchive_Image_BlockType = ElementInterface & MatrixBlockInterface & {
  __typename: 'imagesArchive_image_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  caption?: Maybe<Scalars['String']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The ID of the field that owns the matrix block. */
  fieldId?: Maybe<Scalars['Int']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Array<Maybe<AssetInterface>>>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The ID of the element that owns the matrix block. */
  ownerId?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The sort order of the matrix block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the matrix block’s type. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the matrix block’s type. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
};


export type ImagesArchive_Image_BlockType_CountArgs = {
  field: Scalars['String'];
};


export type ImagesArchive_Image_BlockTypeImageArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImagesArchive_Image_MatrixBlockInput = {
  caption?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  image?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type Imprint_Imprint_Entry = ElementInterface & EntryInterface & {
  __typename: 'imprint_imprint_Entry';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The entry’s author. */
  author?: Maybe<UserInterface>;
  /** The ID of the author of this entry. */
  authorId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical ID. */
  canonicalId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical UUID. */
  canonicalUid?: Maybe<Scalars['String']>;
  /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
  children?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The current revision for the entry. */
  currentRevision?: Maybe<EntryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The creator of a given draft. */
  draftCreator?: Maybe<UserInterface>;
  /** The draft ID (from the `drafts` table). */
  draftId?: Maybe<Scalars['Int']>;
  /** The name of the draft. */
  draftName?: Maybe<Scalars['String']>;
  /** The notes for the draft. */
  draftNotes?: Maybe<Scalars['String']>;
  /** The drafts for the entry. */
  drafts?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The expiry date of the entry. */
  expiryDate?: Maybe<Scalars['DateTime']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** Returns whether this is a draft. */
  isDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is a revision. */
  isRevision?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. */
  isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. **This field is deprecated.** `isUnpublishedDraft` should be used instead. */
  isUnsavedDraft?: Maybe<Scalars['Boolean']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']>;
  /** The same element in other locales. */
  localized?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<EntryInterface>;
  /** The entry’s parent, if the section is a structure. */
  parent?: Maybe<EntryInterface>;
  /** The entry’s post date. */
  postDate?: Maybe<Scalars['DateTime']>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<EntryInterface>;
  redactor?: Maybe<Scalars['String']>;
  /** The creator of a given revision. */
  revisionCreator?: Maybe<UserInterface>;
  /** The revision ID (from the `revisions` table). */
  revisionId?: Maybe<Scalars['Int']>;
  /** The revisions for the entry. */
  revisions?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The handle of the section that contains the entry. */
  sectionHandle?: Maybe<Scalars['String']>;
  /** The ID of the section that contains the entry. */
  sectionId?: Maybe<Scalars['Int']>;
  seo?: Maybe<Ether_SeoData>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /**
   * Returns the entry’s canonical ID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
   */
  sourceId?: Maybe<Scalars['Int']>;
  /**
   * Returns the entry’s canonical UUID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
   */
  sourceUid?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the entry type that contains the entry. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the entry type that contains the entry. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']>;
};


export type Imprint_Imprint_Entry_CountArgs = {
  field: Scalars['String'];
};


export type Imprint_Imprint_EntryAncestorsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Imprint_Imprint_EntryChildrenArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Imprint_Imprint_EntryDescendantsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Imprint_Imprint_EntryDraftsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Imprint_Imprint_EntryLocalizedArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Imprint_Imprint_EntryNextArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Imprint_Imprint_EntryParentArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Imprint_Imprint_EntryPrevArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Imprint_Imprint_EntryRevisionsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Interviewee_TableRow = {
  __typename: 'interviewee_TableRow';
  col1?: Maybe<Scalars['String']>;
  col2?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  initials?: Maybe<Scalars['String']>;
};

export type Interviewee_TableRowInput = {
  col1?: InputMaybe<Scalars['String']>;
  col2?: InputMaybe<Scalars['String']>;
};

export type Interviewer_TableRow = {
  __typename: 'interviewer_TableRow';
  col1?: Maybe<Scalars['String']>;
  col2?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  initials?: Maybe<Scalars['String']>;
};

export type Interviewer_TableRowInput = {
  col1?: InputMaybe<Scalars['String']>;
  col2?: InputMaybe<Scalars['String']>;
};

export type KubaparisVideos_4_SuperTableBlockInput = {
  /** This color is displayed in the split second before the video loads. To make the transition as smooth as possible, the color should be as close as possible to the background color at the beginning of the video. */
  backgroundColor?: InputMaybe<Scalars['String']>;
  backgroundColorDarkMode?: InputMaybe<Scalars['String']>;
  desktop?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  desktopDarkMode?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['ID']>;
  mobile?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mobileDarkMode?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type KubaparisVideos_BlockType = ElementInterface & SuperTableBlockInterface & {
  __typename: 'kubaparisVideos_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  backgroundColor?: Maybe<Scalars['String']>;
  backgroundColorDarkMode?: Maybe<Scalars['String']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  desktop?: Maybe<Array<Maybe<AssetInterface>>>;
  desktopDarkMode?: Maybe<Array<Maybe<AssetInterface>>>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The ID of the field that owns the Super Table block. */
  fieldId?: Maybe<Scalars['Int']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  mobile?: Maybe<Array<Maybe<AssetInterface>>>;
  mobileDarkMode?: Maybe<Array<Maybe<AssetInterface>>>;
  /** The ID of the element that owns the Super Table block. */
  ownerId?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The sort order of the Super Table block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The ID of the Super Table block's type. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
};


export type KubaparisVideos_BlockType_CountArgs = {
  field: Scalars['String'];
};


export type KubaparisVideos_BlockTypeDesktopArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type KubaparisVideos_BlockTypeDesktopDarkModeArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type KubaparisVideos_BlockTypeMobileArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type KubaparisVideos_BlockTypeMobileDarkModeArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type KubaparisVideos_SuperTableBlockContainerInput = {
  type_4?: InputMaybe<KubaparisVideos_4_SuperTableBlockInput>;
};

export type KubaparisVideos_SuperTableField = KubaparisVideos_BlockType;

export type KubaparisVideos_SuperTableInput = {
  blocks?: InputMaybe<Array<InputMaybe<KubaparisVideos_SuperTableBlockContainerInput>>>;
  sortOrder?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
};

export type LandingHero_1_SuperTableBlockInput = {
  background?: InputMaybe<Background_MatrixInput>;
  id?: InputMaybe<Scalars['ID']>;
};

export type LandingHero_BlockType = ElementInterface & SuperTableBlockInterface & {
  __typename: 'landingHero_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  background?: Maybe<Array<Maybe<Background_MatrixField>>>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The ID of the field that owns the Super Table block. */
  fieldId?: Maybe<Scalars['Int']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The ID of the element that owns the Super Table block. */
  ownerId?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The sort order of the Super Table block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The ID of the Super Table block's type. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
};


export type LandingHero_BlockType_CountArgs = {
  field: Scalars['String'];
};


export type LandingHero_BlockTypeBackgroundArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LandingHero_SuperTableBlockContainerInput = {
  type_1?: InputMaybe<LandingHero_1_SuperTableBlockInput>;
};

export type LandingHero_SuperTableField = LandingHero_BlockType;

export type LandingHero_SuperTableInput = {
  blocks?: InputMaybe<Array<InputMaybe<LandingHero_SuperTableBlockContainerInput>>>;
  sortOrder?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
};

export type LandingPageVideos_GlobalSet = ElementInterface & GlobalSetInterface & {
  __typename: 'landingPageVideos_GlobalSet';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The handle of the global set. */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  kubaparisVideos?: Maybe<Array<Maybe<KubaparisVideos_SuperTableField>>>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The name of the global set. */
  name?: Maybe<Scalars['String']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
};


export type LandingPageVideos_GlobalSet_CountArgs = {
  field: Scalars['String'];
};


export type LandingPageVideos_GlobalSetKubaparisVideosArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LandingPage_LandingPage_Entry = ElementInterface & EntryInterface & {
  __typename: 'landingPage_landingPage_Entry';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The entry’s author. */
  author?: Maybe<UserInterface>;
  /** The ID of the author of this entry. */
  authorId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical ID. */
  canonicalId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical UUID. */
  canonicalUid?: Maybe<Scalars['String']>;
  /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
  children?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The current revision for the entry. */
  currentRevision?: Maybe<EntryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The creator of a given draft. */
  draftCreator?: Maybe<UserInterface>;
  /** The draft ID (from the `drafts` table). */
  draftId?: Maybe<Scalars['Int']>;
  /** The name of the draft. */
  draftName?: Maybe<Scalars['String']>;
  /** The notes for the draft. */
  draftNotes?: Maybe<Scalars['String']>;
  /** The drafts for the entry. */
  drafts?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The expiry date of the entry. */
  expiryDate?: Maybe<Scalars['DateTime']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** Returns whether this is a draft. */
  isDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is a revision. */
  isRevision?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. */
  isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. **This field is deprecated.** `isUnpublishedDraft` should be used instead. */
  isUnsavedDraft?: Maybe<Scalars['Boolean']>;
  landingHero?: Maybe<Array<Maybe<LandingHero_SuperTableField>>>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']>;
  /** The same element in other locales. */
  localized?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<EntryInterface>;
  /** The entry’s parent, if the section is a structure. */
  parent?: Maybe<EntryInterface>;
  /** The entry’s post date. */
  postDate?: Maybe<Scalars['DateTime']>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<EntryInterface>;
  /** The creator of a given revision. */
  revisionCreator?: Maybe<UserInterface>;
  /** The revision ID (from the `revisions` table). */
  revisionId?: Maybe<Scalars['Int']>;
  /** The revisions for the entry. */
  revisions?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The handle of the section that contains the entry. */
  sectionHandle?: Maybe<Scalars['String']>;
  /** The ID of the section that contains the entry. */
  sectionId?: Maybe<Scalars['Int']>;
  seo?: Maybe<Ether_SeoData>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /**
   * Returns the entry’s canonical ID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
   */
  sourceId?: Maybe<Scalars['Int']>;
  /**
   * Returns the entry’s canonical UUID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
   */
  sourceUid?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the entry type that contains the entry. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the entry type that contains the entry. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']>;
};


export type LandingPage_LandingPage_Entry_CountArgs = {
  field: Scalars['String'];
};


export type LandingPage_LandingPage_EntryAncestorsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type LandingPage_LandingPage_EntryChildrenArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type LandingPage_LandingPage_EntryDescendantsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type LandingPage_LandingPage_EntryDraftsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type LandingPage_LandingPage_EntryLandingHeroArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type LandingPage_LandingPage_EntryLocalizedArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type LandingPage_LandingPage_EntryNextArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type LandingPage_LandingPage_EntryParentArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type LandingPage_LandingPage_EntryPrevArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type LandingPage_LandingPage_EntryRevisionsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type MenuSubpages_MatrixBlockContainerInput = {
  subpage?: InputMaybe<MenuSubpages_Subpage_MatrixBlockInput>;
};

export type MenuSubpages_MatrixField = MenuSubpages_Subpage_BlockType;

export type MenuSubpages_MatrixInput = {
  blocks?: InputMaybe<Array<InputMaybe<MenuSubpages_MatrixBlockContainerInput>>>;
  sortOrder?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
};

export type MenuSubpages_Subpage_BlockType = ElementInterface & MatrixBlockInterface & {
  __typename: 'menuSubpages_subpage_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The ID of the field that owns the matrix block. */
  fieldId?: Maybe<Scalars['Int']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  label?: Maybe<Scalars['String']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The ID of the element that owns the matrix block. */
  ownerId?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The sort order of the matrix block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  subpage?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the matrix block’s type. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the matrix block’s type. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
};


export type MenuSubpages_Subpage_BlockType_CountArgs = {
  field: Scalars['String'];
};


export type MenuSubpages_Subpage_BlockTypeSubpageArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type MenuSubpages_Subpage_MatrixBlockInput = {
  id?: InputMaybe<Scalars['ID']>;
  label?: InputMaybe<Scalars['String']>;
  subpage?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type Menu_GlobalSet = ElementInterface & GlobalSetInterface & {
  __typename: 'menu_GlobalSet';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The handle of the global set. */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  menuSubpages?: Maybe<Array<Maybe<MenuSubpages_MatrixField>>>;
  /** The name of the global set. */
  name?: Maybe<Scalars['String']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  socialMediaLinks?: Maybe<Array<Maybe<SocialMediaLinks_TableRow>>>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
};


export type Menu_GlobalSet_CountArgs = {
  field: Scalars['String'];
};


export type Menu_GlobalSetMenuSubpagesArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type News_Color_Entry = ElementInterface & EntryInterface & {
  __typename: 'news_color_Entry';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The entry’s author. */
  author?: Maybe<UserInterface>;
  /** The ID of the author of this entry. */
  authorId?: Maybe<Scalars['Int']>;
  backgroundColor?: Maybe<Scalars['String']>;
  /** Returns the entry’s canonical ID. */
  canonicalId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical UUID. */
  canonicalUid?: Maybe<Scalars['String']>;
  /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
  children?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The current revision for the entry. */
  currentRevision?: Maybe<EntryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The creator of a given draft. */
  draftCreator?: Maybe<UserInterface>;
  /** The draft ID (from the `drafts` table). */
  draftId?: Maybe<Scalars['Int']>;
  /** The name of the draft. */
  draftName?: Maybe<Scalars['String']>;
  /** The notes for the draft. */
  draftNotes?: Maybe<Scalars['String']>;
  /** The drafts for the entry. */
  drafts?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The expiry date of the entry. */
  expiryDate?: Maybe<Scalars['DateTime']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** Returns whether this is a draft. */
  isDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is a revision. */
  isRevision?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. */
  isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. **This field is deprecated.** `isUnpublishedDraft` should be used instead. */
  isUnsavedDraft?: Maybe<Scalars['Boolean']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']>;
  /** The same element in other locales. */
  localized?: Maybe<Array<Maybe<EntryInterface>>>;
  newsLink?: Maybe<Scalars['String']>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<EntryInterface>;
  /** The entry’s parent, if the section is a structure. */
  parent?: Maybe<EntryInterface>;
  /** The entry’s post date. */
  postDate?: Maybe<Scalars['DateTime']>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<EntryInterface>;
  /** The creator of a given revision. */
  revisionCreator?: Maybe<UserInterface>;
  /** The revision ID (from the `revisions` table). */
  revisionId?: Maybe<Scalars['Int']>;
  /** The revisions for the entry. */
  revisions?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The handle of the section that contains the entry. */
  sectionHandle?: Maybe<Scalars['String']>;
  /** The ID of the section that contains the entry. */
  sectionId?: Maybe<Scalars['Int']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /**
   * Returns the entry’s canonical ID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
   */
  sourceId?: Maybe<Scalars['Int']>;
  /**
   * Returns the entry’s canonical UUID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
   */
  sourceUid?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the entry type that contains the entry. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the entry type that contains the entry. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']>;
};


export type News_Color_Entry_CountArgs = {
  field: Scalars['String'];
};


export type News_Color_EntryAncestorsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type News_Color_EntryChildrenArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type News_Color_EntryDescendantsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type News_Color_EntryDraftsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type News_Color_EntryLocalizedArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type News_Color_EntryNextArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type News_Color_EntryParentArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type News_Color_EntryPrevArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type News_Color_EntryRevisionsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type News_Image_Entry = ElementInterface & EntryInterface & {
  __typename: 'news_image_Entry';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The entry’s author. */
  author?: Maybe<UserInterface>;
  /** The ID of the author of this entry. */
  authorId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical ID. */
  canonicalId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical UUID. */
  canonicalUid?: Maybe<Scalars['String']>;
  /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
  children?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The current revision for the entry. */
  currentRevision?: Maybe<EntryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The creator of a given draft. */
  draftCreator?: Maybe<UserInterface>;
  /** The draft ID (from the `drafts` table). */
  draftId?: Maybe<Scalars['Int']>;
  /** The name of the draft. */
  draftName?: Maybe<Scalars['String']>;
  /** The notes for the draft. */
  draftNotes?: Maybe<Scalars['String']>;
  /** The drafts for the entry. */
  drafts?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The expiry date of the entry. */
  expiryDate?: Maybe<Scalars['DateTime']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** Returns whether this is a draft. */
  isDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is a revision. */
  isRevision?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. */
  isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. **This field is deprecated.** `isUnpublishedDraft` should be used instead. */
  isUnsavedDraft?: Maybe<Scalars['Boolean']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']>;
  /** The same element in other locales. */
  localized?: Maybe<Array<Maybe<EntryInterface>>>;
  newsImage?: Maybe<Array<Maybe<AssetInterface>>>;
  newsLink?: Maybe<Scalars['String']>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<EntryInterface>;
  /** The entry’s parent, if the section is a structure. */
  parent?: Maybe<EntryInterface>;
  /** The entry’s post date. */
  postDate?: Maybe<Scalars['DateTime']>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<EntryInterface>;
  /** The creator of a given revision. */
  revisionCreator?: Maybe<UserInterface>;
  /** The revision ID (from the `revisions` table). */
  revisionId?: Maybe<Scalars['Int']>;
  /** The revisions for the entry. */
  revisions?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The handle of the section that contains the entry. */
  sectionHandle?: Maybe<Scalars['String']>;
  /** The ID of the section that contains the entry. */
  sectionId?: Maybe<Scalars['Int']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /**
   * Returns the entry’s canonical ID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
   */
  sourceId?: Maybe<Scalars['Int']>;
  /**
   * Returns the entry’s canonical UUID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
   */
  sourceUid?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the entry type that contains the entry. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the entry type that contains the entry. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']>;
};


export type News_Image_Entry_CountArgs = {
  field: Scalars['String'];
};


export type News_Image_EntryAncestorsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type News_Image_EntryChildrenArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type News_Image_EntryDescendantsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type News_Image_EntryDraftsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type News_Image_EntryLocalizedArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type News_Image_EntryNewsImageArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type News_Image_EntryNextArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type News_Image_EntryParentArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type News_Image_EntryPrevArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type News_Image_EntryRevisionsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type PostCategory_Category = CategoryInterface & ElementInterface & {
  __typename: 'postCategory_Category';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The category’s children. */
  children?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The handle of the group that contains the category. */
  groupHandle?: Maybe<Scalars['String']>;
  /** The ID of the group that contains the category. */
  groupId?: Maybe<Scalars['Int']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']>;
  /** The same element in other locales. */
  localized?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<CategoryInterface>;
  /** The category’s parent. */
  parent?: Maybe<CategoryInterface>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<CategoryInterface>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  seo?: Maybe<Ether_SeoData>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']>;
};


export type PostCategory_Category_CountArgs = {
  field: Scalars['String'];
};


export type PostCategory_CategoryChildrenArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type PostCategory_CategoryLocalizedArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type PostCategory_CategoryNextArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type PostCategory_CategoryParentArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type PostCategory_CategoryPrevArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Posts_Default_Entry = ElementInterface & EntryInterface & {
  __typename: 'posts_default_Entry';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The entry’s author. */
  author?: Maybe<UserInterface>;
  /** The ID of the author of this entry. */
  authorId?: Maybe<Scalars['Int']>;
  bottomColor?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** Returns the entry’s canonical ID. */
  canonicalId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical UUID. */
  canonicalUid?: Maybe<Scalars['String']>;
  /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
  children?: Maybe<Array<Maybe<EntryInterface>>>;
  contentBlocks?: Maybe<Array<Maybe<ContentBlocks_MatrixField>>>;
  /** The current revision for the entry. */
  currentRevision?: Maybe<EntryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The creator of a given draft. */
  draftCreator?: Maybe<UserInterface>;
  /** The draft ID (from the `drafts` table). */
  draftId?: Maybe<Scalars['Int']>;
  /** The name of the draft. */
  draftName?: Maybe<Scalars['String']>;
  /** The notes for the draft. */
  draftNotes?: Maybe<Scalars['String']>;
  /** The drafts for the entry. */
  drafts?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The expiry date of the entry. */
  expiryDate?: Maybe<Scalars['DateTime']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** Returns whether this is a draft. */
  isDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is a revision. */
  isRevision?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. */
  isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. **This field is deprecated.** `isUnpublishedDraft` should be used instead. */
  isUnsavedDraft?: Maybe<Scalars['Boolean']>;
  keyImage?: Maybe<Array<Maybe<AssetInterface>>>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']>;
  /** The same element in other locales. */
  localized?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<EntryInterface>;
  /** The entry’s parent, if the section is a structure. */
  parent?: Maybe<EntryInterface>;
  postCategory?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** The entry’s post date. */
  postDate?: Maybe<Scalars['DateTime']>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<EntryInterface>;
  projectInfo?: Maybe<Array<Maybe<ProjectInfo_TableRow>>>;
  /** The creator of a given revision. */
  revisionCreator?: Maybe<UserInterface>;
  /** The revision ID (from the `revisions` table). */
  revisionId?: Maybe<Scalars['Int']>;
  /** The revisions for the entry. */
  revisions?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The handle of the section that contains the entry. */
  sectionHandle?: Maybe<Scalars['String']>;
  /** The ID of the section that contains the entry. */
  sectionId?: Maybe<Scalars['Int']>;
  seo?: Maybe<Ether_SeoData>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /**
   * Returns the entry’s canonical ID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
   */
  sourceId?: Maybe<Scalars['Int']>;
  /**
   * Returns the entry’s canonical UUID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
   */
  sourceUid?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']>;
  subheading?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  topColor?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the entry type that contains the entry. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the entry type that contains the entry. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']>;
};


export type Posts_Default_Entry_CountArgs = {
  field: Scalars['String'];
};


export type Posts_Default_EntryAncestorsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Posts_Default_EntryBottomColorArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Posts_Default_EntryChildrenArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Posts_Default_EntryContentBlocksArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Posts_Default_EntryDescendantsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Posts_Default_EntryDraftsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Posts_Default_EntryKeyImageArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Posts_Default_EntryLocalizedArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Posts_Default_EntryNextArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Posts_Default_EntryParentArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Posts_Default_EntryPostCategoryArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Posts_Default_EntryPrevArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Posts_Default_EntryRevisionsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Posts_Default_EntryTopColorArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type PrivacyPolicy_PrivacyPolicy_Entry = ElementInterface & EntryInterface & {
  __typename: 'privacyPolicy_privacyPolicy_Entry';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The entry’s author. */
  author?: Maybe<UserInterface>;
  /** The ID of the author of this entry. */
  authorId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical ID. */
  canonicalId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical UUID. */
  canonicalUid?: Maybe<Scalars['String']>;
  /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
  children?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The current revision for the entry. */
  currentRevision?: Maybe<EntryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The creator of a given draft. */
  draftCreator?: Maybe<UserInterface>;
  /** The draft ID (from the `drafts` table). */
  draftId?: Maybe<Scalars['Int']>;
  /** The name of the draft. */
  draftName?: Maybe<Scalars['String']>;
  /** The notes for the draft. */
  draftNotes?: Maybe<Scalars['String']>;
  /** The drafts for the entry. */
  drafts?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The expiry date of the entry. */
  expiryDate?: Maybe<Scalars['DateTime']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** Returns whether this is a draft. */
  isDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is a revision. */
  isRevision?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. */
  isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. **This field is deprecated.** `isUnpublishedDraft` should be used instead. */
  isUnsavedDraft?: Maybe<Scalars['Boolean']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']>;
  /** The same element in other locales. */
  localized?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<EntryInterface>;
  /** The entry’s parent, if the section is a structure. */
  parent?: Maybe<EntryInterface>;
  /** The entry’s post date. */
  postDate?: Maybe<Scalars['DateTime']>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<EntryInterface>;
  redactor?: Maybe<Scalars['String']>;
  /** The creator of a given revision. */
  revisionCreator?: Maybe<UserInterface>;
  /** The revision ID (from the `revisions` table). */
  revisionId?: Maybe<Scalars['Int']>;
  /** The revisions for the entry. */
  revisions?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The handle of the section that contains the entry. */
  sectionHandle?: Maybe<Scalars['String']>;
  /** The ID of the section that contains the entry. */
  sectionId?: Maybe<Scalars['Int']>;
  seo?: Maybe<Ether_SeoData>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /**
   * Returns the entry’s canonical ID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
   */
  sourceId?: Maybe<Scalars['Int']>;
  /**
   * Returns the entry’s canonical UUID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
   */
  sourceUid?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the entry type that contains the entry. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the entry type that contains the entry. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']>;
};


export type PrivacyPolicy_PrivacyPolicy_Entry_CountArgs = {
  field: Scalars['String'];
};


export type PrivacyPolicy_PrivacyPolicy_EntryAncestorsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type PrivacyPolicy_PrivacyPolicy_EntryChildrenArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type PrivacyPolicy_PrivacyPolicy_EntryDescendantsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type PrivacyPolicy_PrivacyPolicy_EntryDraftsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type PrivacyPolicy_PrivacyPolicy_EntryLocalizedArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type PrivacyPolicy_PrivacyPolicy_EntryNextArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type PrivacyPolicy_PrivacyPolicy_EntryParentArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type PrivacyPolicy_PrivacyPolicy_EntryPrevArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type PrivacyPolicy_PrivacyPolicy_EntryRevisionsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type ProjectInfo_TableRow = {
  __typename: 'projectInfo_TableRow';
  col1?: Maybe<Scalars['String']>;
  projectInfo?: Maybe<Scalars['String']>;
};

export type ProjectInfo_TableRowInput = {
  col1?: InputMaybe<Scalars['String']>;
};

export type ProjectSlider_MatrixBlockContainerInput = {
  slide?: InputMaybe<ProjectSlider_Slide_MatrixBlockInput>;
};

export type ProjectSlider_MatrixField = ProjectSlider_Slide_BlockType;

export type ProjectSlider_MatrixInput = {
  blocks?: InputMaybe<Array<InputMaybe<ProjectSlider_MatrixBlockContainerInput>>>;
  sortOrder?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
};

export type ProjectSlider_Slide_BlockType = ElementInterface & MatrixBlockInterface & {
  __typename: 'projectSlider_slide_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  descriptionColor?: Maybe<Scalars['String']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The ID of the field that owns the matrix block. */
  fieldId?: Maybe<Scalars['Int']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  media?: Maybe<Array<Maybe<AssetInterface>>>;
  /** The ID of the element that owns the matrix block. */
  ownerId?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** The sort order of the matrix block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the matrix block’s type. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the matrix block’s type. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
};


export type ProjectSlider_Slide_BlockType_CountArgs = {
  field: Scalars['String'];
};


export type ProjectSlider_Slide_BlockTypeMediaArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProjectSlider_Slide_MatrixBlockInput = {
  description?: InputMaybe<Scalars['String']>;
  descriptionColor?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  media?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type Projects_Default_Entry = ElementInterface & EntryInterface & {
  __typename: 'projects_default_Entry';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The entry’s author. */
  author?: Maybe<UserInterface>;
  /** The ID of the author of this entry. */
  authorId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical ID. */
  canonicalId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical UUID. */
  canonicalUid?: Maybe<Scalars['String']>;
  /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
  children?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The current revision for the entry. */
  currentRevision?: Maybe<EntryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The creator of a given draft. */
  draftCreator?: Maybe<UserInterface>;
  /** The draft ID (from the `drafts` table). */
  draftId?: Maybe<Scalars['Int']>;
  /** The name of the draft. */
  draftName?: Maybe<Scalars['String']>;
  /** The notes for the draft. */
  draftNotes?: Maybe<Scalars['String']>;
  /** The drafts for the entry. */
  drafts?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The expiry date of the entry. */
  expiryDate?: Maybe<Scalars['DateTime']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** Returns whether this is a draft. */
  isDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is a revision. */
  isRevision?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. */
  isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. **This field is deprecated.** `isUnpublishedDraft` should be used instead. */
  isUnsavedDraft?: Maybe<Scalars['Boolean']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']>;
  /** The same element in other locales. */
  localized?: Maybe<Array<Maybe<EntryInterface>>>;
  mobileDescription?: Maybe<Scalars['String']>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<EntryInterface>;
  /** The entry’s parent, if the section is a structure. */
  parent?: Maybe<EntryInterface>;
  /** The entry’s post date. */
  postDate?: Maybe<Scalars['DateTime']>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<EntryInterface>;
  projectSlider?: Maybe<Array<Maybe<ProjectSlider_MatrixField>>>;
  /** The creator of a given revision. */
  revisionCreator?: Maybe<UserInterface>;
  /** The revision ID (from the `revisions` table). */
  revisionId?: Maybe<Scalars['Int']>;
  /** The revisions for the entry. */
  revisions?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The handle of the section that contains the entry. */
  sectionHandle?: Maybe<Scalars['String']>;
  /** The ID of the section that contains the entry. */
  sectionId?: Maybe<Scalars['Int']>;
  seo?: Maybe<Ether_SeoData>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /**
   * Returns the entry’s canonical ID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
   */
  sourceId?: Maybe<Scalars['Int']>;
  /**
   * Returns the entry’s canonical UUID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
   */
  sourceUid?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the entry type that contains the entry. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the entry type that contains the entry. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']>;
};


export type Projects_Default_Entry_CountArgs = {
  field: Scalars['String'];
};


export type Projects_Default_EntryAncestorsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Projects_Default_EntryChildrenArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Projects_Default_EntryDescendantsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Projects_Default_EntryDraftsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Projects_Default_EntryLocalizedArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Projects_Default_EntryNextArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Projects_Default_EntryParentArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Projects_Default_EntryPrevArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type Projects_Default_EntryProjectSliderArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Projects_Default_EntryRevisionsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type QuestionsAndAnswers_TableRow = {
  __typename: 'questionsAndAnswers_TableRow';
  answer?: Maybe<Scalars['String']>;
  col1?: Maybe<Scalars['String']>;
  col2?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
};

export type QuestionsAndAnswers_TableRowInput = {
  col1?: InputMaybe<Scalars['String']>;
  col2?: InputMaybe<Scalars['String']>;
};

export type SocialMediaEntries_TableRow = {
  __typename: 'socialMediaEntries_TableRow';
  col1?: Maybe<Scalars['String']>;
  col2?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type SocialMediaEntries_TableRowInput = {
  col1?: InputMaybe<Scalars['String']>;
  col2?: InputMaybe<Scalars['String']>;
};

export type SocialMediaLinks_TableRow = {
  __typename: 'socialMediaLinks_TableRow';
  col1?: Maybe<Scalars['String']>;
  col2?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
};

export type SocialMediaLinks_TableRowInput = {
  col1?: InputMaybe<Scalars['String']>;
  col2?: InputMaybe<Scalars['String']>;
};

export type StudioShAssets_Asset = AssetInterface & ElementInterface & {
  __typename: 'studioShAssets_Asset';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the asset file was last modified. */
  dateModified?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** This queries for a single embedded asset. */
  embeddedAsset?: Maybe<EmbeddedAssetInterface>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The file extension for the asset file. */
  extension?: Maybe<Scalars['String']>;
  /** The filename of the asset file. */
  filename?: Maybe<Scalars['String']>;
  /** The focal point represented as an array with `x` and `y` keys, or null if it’s not an image. */
  focalPoint?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** The ID of the folder that the asset belongs to. */
  folderId?: Maybe<Scalars['Int']>;
  /** Whether a user-defined focal point is set on the asset. */
  hasFocalPoint?: Maybe<Scalars['Boolean']>;
  /** The height in pixels or null if it’s not an image. */
  height?: Maybe<Scalars['Int']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** An `<img>` tag based on this asset. */
  img?: Maybe<Scalars['String']>;
  /** The file kind. */
  kind?: Maybe<Scalars['String']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The file’s MIME type, if it can be determined. */
  mimeType?: Maybe<Scalars['String']>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<AssetInterface>;
  /** The asset’s path in the volume. */
  path?: Maybe<Scalars['String']>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<AssetInterface>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The file size in bytes. */
  size?: Maybe<Scalars['String']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** Returns a `srcset` attribute value based on the given widths or x-descriptors. */
  srcset?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The user who first added this asset (if known). */
  uploader?: Maybe<UserInterface>;
  /** The ID of the user who first added this asset (if known). */
  uploaderId?: Maybe<Scalars['Int']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  /** The full URL of the asset. This field accepts the same fields as the `transform` directive. */
  url?: Maybe<Scalars['String']>;
  /** The ID of the volume that the asset belongs to. */
  volumeId?: Maybe<Scalars['Int']>;
  /** The width in pixels or null if it’s not an image. */
  width?: Maybe<Scalars['Int']>;
};


export type StudioShAssets_Asset_CountArgs = {
  field: Scalars['String'];
};


export type StudioShAssets_AssetHeightArgs = {
  format?: InputMaybe<Scalars['String']>;
  handle?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  immediately?: InputMaybe<Scalars['Boolean']>;
  interlace?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  quality?: InputMaybe<Scalars['Int']>;
  transform?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};


export type StudioShAssets_AssetNextArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type StudioShAssets_AssetPrevArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type StudioShAssets_AssetSrcsetArgs = {
  sizes: Array<Scalars['String']>;
};


export type StudioShAssets_AssetUploaderArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  email?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasPhoto?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  username?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type StudioShAssets_AssetUrlArgs = {
  format?: InputMaybe<Scalars['String']>;
  handle?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  immediately?: InputMaybe<Scalars['Boolean']>;
  interlace?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  quality?: InputMaybe<Scalars['Int']>;
  transform?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};


export type StudioShAssets_AssetWidthArgs = {
  format?: InputMaybe<Scalars['String']>;
  handle?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  immediately?: InputMaybe<Scalars['Boolean']>;
  interlace?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  quality?: InputMaybe<Scalars['Int']>;
  transform?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type StudioShMenu_GlobalSet = ElementInterface & GlobalSetInterface & {
  __typename: 'studioShMenu_GlobalSet';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The handle of the global set. */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  menuSubpages?: Maybe<Array<Maybe<MenuSubpages_MatrixField>>>;
  /** The name of the global set. */
  name?: Maybe<Scalars['String']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  socialMediaLinks?: Maybe<Array<Maybe<SocialMediaLinks_TableRow>>>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
};


export type StudioShMenu_GlobalSet_CountArgs = {
  field: Scalars['String'];
};


export type StudioShMenu_GlobalSetMenuSubpagesArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SubmissionSuccessful_SubmissionSuccessful_Entry = ElementInterface & EntryInterface & {
  __typename: 'submissionSuccessful_submissionSuccessful_Entry';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The entry’s author. */
  author?: Maybe<UserInterface>;
  /** The ID of the author of this entry. */
  authorId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical ID. */
  canonicalId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical UUID. */
  canonicalUid?: Maybe<Scalars['String']>;
  /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
  children?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The current revision for the entry. */
  currentRevision?: Maybe<EntryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The creator of a given draft. */
  draftCreator?: Maybe<UserInterface>;
  /** The draft ID (from the `drafts` table). */
  draftId?: Maybe<Scalars['Int']>;
  /** The name of the draft. */
  draftName?: Maybe<Scalars['String']>;
  /** The notes for the draft. */
  draftNotes?: Maybe<Scalars['String']>;
  /** The drafts for the entry. */
  drafts?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The expiry date of the entry. */
  expiryDate?: Maybe<Scalars['DateTime']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  infoText?: Maybe<Scalars['String']>;
  /** Returns whether this is a draft. */
  isDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is a revision. */
  isRevision?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. */
  isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. **This field is deprecated.** `isUnpublishedDraft` should be used instead. */
  isUnsavedDraft?: Maybe<Scalars['Boolean']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']>;
  /** The same element in other locales. */
  localized?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<EntryInterface>;
  /** The entry’s parent, if the section is a structure. */
  parent?: Maybe<EntryInterface>;
  /** The entry’s post date. */
  postDate?: Maybe<Scalars['DateTime']>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<EntryInterface>;
  /** The creator of a given revision. */
  revisionCreator?: Maybe<UserInterface>;
  /** The revision ID (from the `revisions` table). */
  revisionId?: Maybe<Scalars['Int']>;
  /** The revisions for the entry. */
  revisions?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The handle of the section that contains the entry. */
  sectionHandle?: Maybe<Scalars['String']>;
  /** The ID of the section that contains the entry. */
  sectionId?: Maybe<Scalars['Int']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /**
   * Returns the entry’s canonical ID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
   */
  sourceId?: Maybe<Scalars['Int']>;
  /**
   * Returns the entry’s canonical UUID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
   */
  sourceUid?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the entry type that contains the entry. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the entry type that contains the entry. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']>;
};


export type SubmissionSuccessful_SubmissionSuccessful_Entry_CountArgs = {
  field: Scalars['String'];
};


export type SubmissionSuccessful_SubmissionSuccessful_EntryAncestorsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type SubmissionSuccessful_SubmissionSuccessful_EntryChildrenArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type SubmissionSuccessful_SubmissionSuccessful_EntryDescendantsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type SubmissionSuccessful_SubmissionSuccessful_EntryDraftsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type SubmissionSuccessful_SubmissionSuccessful_EntryLocalizedArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type SubmissionSuccessful_SubmissionSuccessful_EntryNextArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type SubmissionSuccessful_SubmissionSuccessful_EntryParentArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type SubmissionSuccessful_SubmissionSuccessful_EntryPrevArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type SubmissionSuccessful_SubmissionSuccessful_EntryRevisionsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Submissions_Asset = AssetInterface & ElementInterface & {
  __typename: 'submissions_Asset';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the asset file was last modified. */
  dateModified?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** This queries for a single embedded asset. */
  embeddedAsset?: Maybe<EmbeddedAssetInterface>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The file extension for the asset file. */
  extension?: Maybe<Scalars['String']>;
  /** The filename of the asset file. */
  filename?: Maybe<Scalars['String']>;
  /** The focal point represented as an array with `x` and `y` keys, or null if it’s not an image. */
  focalPoint?: Maybe<Array<Maybe<Scalars['Float']>>>;
  /** The ID of the folder that the asset belongs to. */
  folderId?: Maybe<Scalars['Int']>;
  /** Whether a user-defined focal point is set on the asset. */
  hasFocalPoint?: Maybe<Scalars['Boolean']>;
  /** The height in pixels or null if it’s not an image. */
  height?: Maybe<Scalars['Int']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** An `<img>` tag based on this asset. */
  img?: Maybe<Scalars['String']>;
  /** The file kind. */
  kind?: Maybe<Scalars['String']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The file’s MIME type, if it can be determined. */
  mimeType?: Maybe<Scalars['String']>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<AssetInterface>;
  /** The asset’s path in the volume. */
  path?: Maybe<Scalars['String']>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<AssetInterface>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The file size in bytes. */
  size?: Maybe<Scalars['String']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /** Returns a `srcset` attribute value based on the given widths or x-descriptors. */
  srcset?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The user who first added this asset (if known). */
  uploader?: Maybe<UserInterface>;
  /** The ID of the user who first added this asset (if known). */
  uploaderId?: Maybe<Scalars['Int']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  /** The full URL of the asset. This field accepts the same fields as the `transform` directive. */
  url?: Maybe<Scalars['String']>;
  /** The ID of the volume that the asset belongs to. */
  volumeId?: Maybe<Scalars['Int']>;
  /** The width in pixels or null if it’s not an image. */
  width?: Maybe<Scalars['Int']>;
};


export type Submissions_Asset_CountArgs = {
  field: Scalars['String'];
};


export type Submissions_AssetHeightArgs = {
  format?: InputMaybe<Scalars['String']>;
  handle?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  immediately?: InputMaybe<Scalars['Boolean']>;
  interlace?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  quality?: InputMaybe<Scalars['Int']>;
  transform?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};


export type Submissions_AssetNextArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Submissions_AssetPrevArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Submissions_AssetSrcsetArgs = {
  sizes: Array<Scalars['String']>;
};


export type Submissions_AssetUploaderArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  email?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasPhoto?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  username?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Submissions_AssetUrlArgs = {
  format?: InputMaybe<Scalars['String']>;
  handle?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  immediately?: InputMaybe<Scalars['Boolean']>;
  interlace?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  quality?: InputMaybe<Scalars['Int']>;
  transform?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};


export type Submissions_AssetWidthArgs = {
  format?: InputMaybe<Scalars['String']>;
  handle?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  immediately?: InputMaybe<Scalars['Boolean']>;
  interlace?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  quality?: InputMaybe<Scalars['Int']>;
  transform?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type SubmitEvent_SubmitEvent_Entry = ElementInterface & EntryInterface & {
  __typename: 'submitEvent_submitEvent_Entry';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The entry’s author. */
  author?: Maybe<UserInterface>;
  /** The ID of the author of this entry. */
  authorId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical ID. */
  canonicalId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical UUID. */
  canonicalUid?: Maybe<Scalars['String']>;
  /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
  children?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The current revision for the entry. */
  currentRevision?: Maybe<EntryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The creator of a given draft. */
  draftCreator?: Maybe<UserInterface>;
  /** The draft ID (from the `drafts` table). */
  draftId?: Maybe<Scalars['Int']>;
  /** The name of the draft. */
  draftName?: Maybe<Scalars['String']>;
  /** The notes for the draft. */
  draftNotes?: Maybe<Scalars['String']>;
  /** The drafts for the entry. */
  drafts?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The expiry date of the entry. */
  expiryDate?: Maybe<Scalars['DateTime']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  infoText?: Maybe<Scalars['String']>;
  /** Returns whether this is a draft. */
  isDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is a revision. */
  isRevision?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. */
  isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. **This field is deprecated.** `isUnpublishedDraft` should be used instead. */
  isUnsavedDraft?: Maybe<Scalars['Boolean']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']>;
  /** The same element in other locales. */
  localized?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<EntryInterface>;
  /** The entry’s parent, if the section is a structure. */
  parent?: Maybe<EntryInterface>;
  /** The entry’s post date. */
  postDate?: Maybe<Scalars['DateTime']>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<EntryInterface>;
  /** The creator of a given revision. */
  revisionCreator?: Maybe<UserInterface>;
  /** The revision ID (from the `revisions` table). */
  revisionId?: Maybe<Scalars['Int']>;
  /** The revisions for the entry. */
  revisions?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The handle of the section that contains the entry. */
  sectionHandle?: Maybe<Scalars['String']>;
  /** The ID of the section that contains the entry. */
  sectionId?: Maybe<Scalars['Int']>;
  seo?: Maybe<Ether_SeoData>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /**
   * Returns the entry’s canonical ID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
   */
  sourceId?: Maybe<Scalars['Int']>;
  /**
   * Returns the entry’s canonical UUID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
   */
  sourceUid?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the entry type that contains the entry. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the entry type that contains the entry. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']>;
};


export type SubmitEvent_SubmitEvent_Entry_CountArgs = {
  field: Scalars['String'];
};


export type SubmitEvent_SubmitEvent_EntryAncestorsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type SubmitEvent_SubmitEvent_EntryChildrenArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type SubmitEvent_SubmitEvent_EntryDescendantsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type SubmitEvent_SubmitEvent_EntryDraftsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type SubmitEvent_SubmitEvent_EntryLocalizedArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type SubmitEvent_SubmitEvent_EntryNextArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type SubmitEvent_SubmitEvent_EntryParentArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type SubmitEvent_SubmitEvent_EntryPrevArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type SubmitEvent_SubmitEvent_EntryRevisionsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type SubmitExhibition_SubmitExhibition_Entry = ElementInterface & EntryInterface & {
  __typename: 'submitExhibition_submitExhibition_Entry';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The entry’s author. */
  author?: Maybe<UserInterface>;
  /** The ID of the author of this entry. */
  authorId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical ID. */
  canonicalId?: Maybe<Scalars['Int']>;
  /** Returns the entry’s canonical UUID. */
  canonicalUid?: Maybe<Scalars['String']>;
  /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
  children?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The current revision for the entry. */
  currentRevision?: Maybe<EntryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The creator of a given draft. */
  draftCreator?: Maybe<UserInterface>;
  /** The draft ID (from the `drafts` table). */
  draftId?: Maybe<Scalars['Int']>;
  /** The name of the draft. */
  draftName?: Maybe<Scalars['String']>;
  /** The notes for the draft. */
  draftNotes?: Maybe<Scalars['String']>;
  /** The drafts for the entry. */
  drafts?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The expiry date of the entry. */
  expiryDate?: Maybe<Scalars['DateTime']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  infoText?: Maybe<Scalars['String']>;
  /** Returns whether this is a draft. */
  isDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is a revision. */
  isRevision?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. */
  isUnpublishedDraft?: Maybe<Scalars['Boolean']>;
  /** Returns whether this is an unpublished draft. **This field is deprecated.** `isUnpublishedDraft` should be used instead. */
  isUnsavedDraft?: Maybe<Scalars['Boolean']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']>;
  /** The same element in other locales. */
  localized?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<EntryInterface>;
  /** The entry’s parent, if the section is a structure. */
  parent?: Maybe<EntryInterface>;
  /** The entry’s post date. */
  postDate?: Maybe<Scalars['DateTime']>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<EntryInterface>;
  /** The creator of a given revision. */
  revisionCreator?: Maybe<UserInterface>;
  /** The revision ID (from the `revisions` table). */
  revisionId?: Maybe<Scalars['Int']>;
  /** The revisions for the entry. */
  revisions?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The handle of the section that contains the entry. */
  sectionHandle?: Maybe<Scalars['String']>;
  /** The ID of the section that contains the entry. */
  sectionId?: Maybe<Scalars['Int']>;
  seo?: Maybe<Ether_SeoData>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  /**
   * Returns the entry’s canonical ID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
   */
  sourceId?: Maybe<Scalars['Int']>;
  /**
   * Returns the entry’s canonical UUID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
   */
  sourceUid?: Maybe<Scalars['String']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the entry type that contains the entry. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the entry type that contains the entry. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']>;
};


export type SubmitExhibition_SubmitExhibition_Entry_CountArgs = {
  field: Scalars['String'];
};


export type SubmitExhibition_SubmitExhibition_EntryAncestorsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type SubmitExhibition_SubmitExhibition_EntryChildrenArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type SubmitExhibition_SubmitExhibition_EntryDescendantsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type SubmitExhibition_SubmitExhibition_EntryDraftsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type SubmitExhibition_SubmitExhibition_EntryLocalizedArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type SubmitExhibition_SubmitExhibition_EntryNextArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type SubmitExhibition_SubmitExhibition_EntryParentArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type SubmitExhibition_SubmitExhibition_EntryPrevArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};


export type SubmitExhibition_SubmitExhibition_EntryRevisionsArgs = {
  advertisePdf?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  advertisingImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  after?: InputMaybe<Scalars['String']>;
  ancestorDist?: InputMaybe<Scalars['Int']>;
  ancestorOf?: InputMaybe<Scalars['Int']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  backgroundColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  before?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  bottomColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  clickCounter?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  contactKubaparis?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  curatorArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descendantDist?: InputMaybe<Scalars['Int']>;
  descendantOf?: InputMaybe<Scalars['Int']>;
  draftCreator?: InputMaybe<Scalars['Int']>;
  draftId?: InputMaybe<Scalars['Int']>;
  draftOf?: InputMaybe<Scalars['QueryArgument']>;
  drafts?: InputMaybe<Scalars['Boolean']>;
  editable?: InputMaybe<Scalars['Boolean']>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  endOfExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  exhibitionTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  externalLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  fontColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  infoText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  keyImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  label?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  leaves?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  linkToLocationArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  linkToVideo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  locationNameArchiv?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  mobileDescription?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  newsLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  openingExhibition?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  photographer?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']>;
  positionedBefore?: InputMaybe<Scalars['Int']>;
  postCategory?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']>;
  projectInfo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  provisionalDrafts?: InputMaybe<Scalars['Boolean']>;
  redactor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  revisionCreator?: InputMaybe<Scalars['Int']>;
  revisionId?: InputMaybe<Scalars['Int']>;
  revisionOf?: InputMaybe<Scalars['QueryArgument']>;
  revisions?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  seo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Scalars['Int']>;
  subheading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  subheadline?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textArchive?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  textAuthor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  topColor?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']>;
};

export type Team_MatrixBlockContainerInput = {
  member?: InputMaybe<Team_Member_MatrixBlockInput>;
};

export type Team_MatrixField = Team_Member_BlockType;

export type Team_MatrixInput = {
  blocks?: InputMaybe<Array<InputMaybe<Team_MatrixBlockContainerInput>>>;
  sortOrder?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
};

export type Team_Member_BlockType = ElementInterface & MatrixBlockInterface & {
  __typename: 'team_member_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']>;
  /** Whether the element is archived or not. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']>;
  /** Whether the element is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** The ID of the field that owns the matrix block. */
  fieldId?: Maybe<Scalars['Int']>;
  fullName?: Maybe<Scalars['String']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']>;
  /** The ID of the element that owns the matrix block. */
  ownerId?: Maybe<Scalars['Int']>;
  portrait?: Maybe<Array<Maybe<AssetInterface>>>;
  position?: Maybe<Scalars['String']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['String']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']>;
  socialMediaLink?: Maybe<Scalars['String']>;
  /** The sort order of the matrix block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']>;
  /** Whether the element has been soft-deleted or not. */
  trashed?: Maybe<Scalars['Boolean']>;
  /** The handle of the matrix block’s type. */
  typeHandle?: Maybe<Scalars['String']>;
  /** The ID of the matrix block’s type. */
  typeId?: Maybe<Scalars['Int']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']>;
};


export type Team_Member_BlockType_CountArgs = {
  field: Scalars['String'];
};


export type Team_Member_BlockTypePortraitArgs = {
  archived?: InputMaybe<Scalars['Boolean']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dateModified?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  enabledForSite?: InputMaybe<Scalars['Boolean']>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  trashed?: InputMaybe<Scalars['Boolean']>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unique?: InputMaybe<Scalars['Boolean']>;
  uploader?: InputMaybe<Scalars['QueryArgument']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Team_Member_MatrixBlockInput = {
  fullName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  portrait?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  position?: InputMaybe<Scalars['String']>;
  socialMediaLink?: InputMaybe<Scalars['String']>;
};

export type SmallAdFragment = { __typename: 'ads_sidebarBanner_Entry', id?: string | null, title?: string | null, externalLink?: string | null, advertisingImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', id?: string | null, kind?: string | null, url?: string | null, width?: number | null, height?: number | null, title?: string | null, description?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null };

export type BigAdFragment = { __typename: 'ads_contentBanner_Entry', id?: string | null, title?: string | null, externalLink?: string | null, advertisingImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', id?: string | null, kind?: string | null, url?: string | null, width?: number | null, height?: number | null, title?: string | null, description?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null };

export type MegaAdFragment = { __typename: 'ads_landingpageBanner_Entry', id?: string | null, title?: string | null, externalLink?: string | null, advertisingImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', id?: string | null, kind?: string | null, url?: string | null, width?: number | null, height?: number | null, title?: string | null, description?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null };

export type ArchivedPostFragment = { __typename: 'archivedPost_default_Entry', id?: string | null, title?: string | null, names?: string | null, exhibitionTitle?: string | null, subheadline?: string | null, locationNameArchiv?: string | null, linkToLocationArchive?: string | null, curatorArchive?: string | null, textAuthor?: string | null, photographer?: string | null, linkToVideo?: string | null, textArchive?: string | null, year?: any | null, startDate?: any | null, endDate?: any | null, imagesArchive?: Array<{ __typename: 'imagesArchive_image_BlockType', id?: string | null, caption?: string | null, image?: Array<{ __typename: 'archiveAssets_Asset', id?: string | null, url?: string | null, title?: string | null, width?: number | null, height?: number | null } | { __typename: 'assets_Asset' } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null } | null> | null, seoImage?: Array<{ __typename: 'imagesArchive_image_BlockType', id?: string | null, caption?: string | null, image?: Array<{ __typename: 'archiveAssets_Asset', id?: string | null, url?: string | null, title?: string | null, width?: number | null, height?: number | null } | { __typename: 'assets_Asset' } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null } | null> | null };

export type ArchivedPostTeaserFragment = { __typename: 'archivedPost_default_Entry', id?: string | null, slug?: string | null, title?: string | null, uri?: string | null, exhibitionTitle?: string | null, openingExhibition?: any | null, endOfExhibition?: any | null, year?: any | null, date?: any | null, imagesArchive?: Array<{ __typename: 'imagesArchive_image_BlockType', image?: Array<{ __typename: 'archiveAssets_Asset', url?: string | null, width?: number | null, height?: number | null } | { __typename: 'assets_Asset' } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null } | null> | null };

export type ImageBlockFragment = { __typename: 'contentBlocks_image_BlockType', id?: string | null, kind?: string | null, image?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', id?: string | null, url?: string | null, width?: number | null, height?: number | null, srcset?: string | null, description?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null };

export type ImagePairFragment = { __typename: 'contentBlocks_imagePair_BlockType', id?: string | null, kind?: string | null, leftImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', id?: string | null, url?: string | null, width?: number | null, height?: number | null, srcset?: string | null, description?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null, rightImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', id?: string | null, url?: string | null, width?: number | null, height?: number | null, srcset?: string | null, description?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null };

export type TextBlockFragment = { __typename: 'contentBlocks_textBlock_BlockType', id?: string | null, text?: string | null };

export type InterviewBlockFragment = { __typename: 'contentBlocks_interview_BlockType', id?: string | null, interviewer?: Array<{ __typename: 'interviewer_TableRow', fullName?: string | null, initials?: string | null } | null> | null, interviewee?: Array<{ __typename: 'interviewee_TableRow', fullName?: string | null, initials?: string | null } | null> | null, questionsAndAnswers?: Array<{ __typename: 'questionsAndAnswers_TableRow', question?: string | null, answer?: string | null } | null> | null };

export type SliderBlockFragment = { __typename: 'contentBlocks_Slider_BlockType', id?: string | null, slides?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', title?: string | null, id?: string | null, url?: string | null, width?: number | null, height?: number | null, srcset?: string | null, description?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null };

export type InstagramBlockFragment = { __typename: 'contentBlocks_instagram_BlockType', id?: string | null, embedCodes?: Array<{ __typename: 'embedCodes_TableRow', embedCode?: string | null } | null> | null };

export type VideoBlockFragment = { __typename: 'contentBlocks_video_BlockType', id?: string | null, video?: Array<{ __typename: 'archiveAssets_Asset', embeddedAsset?: { __typename: 'EmbeddedAsset', title?: string | null, description?: string | null, aspectRatio?: number | null, height?: number | null, width?: number | null, html?: string | null } | null } | { __typename: 'assets_Asset', title?: string | null, kind?: string | null, url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, description?: string | null, embeddedAsset?: { __typename: 'EmbeddedAsset', title?: string | null, description?: string | null, aspectRatio?: number | null, height?: number | null, width?: number | null, html?: string | null } | null } | { __typename: 'studioShAssets_Asset', embeddedAsset?: { __typename: 'EmbeddedAsset', title?: string | null, description?: string | null, aspectRatio?: number | null, height?: number | null, width?: number | null, html?: string | null } | null } | { __typename: 'submissions_Asset', embeddedAsset?: { __typename: 'EmbeddedAsset', title?: string | null, description?: string | null, aspectRatio?: number | null, height?: number | null, width?: number | null, html?: string | null } | null } | null> | null };

export type NewsColorSlideFragment = { __typename: 'news_color_Entry', id?: string | null, title?: string | null, newsLink?: string | null, backgroundColor?: string | null };

export type NewsImageSlideFragment = { __typename: 'news_image_Entry', id?: string | null, title?: string | null, newsLink?: string | null, newsImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', url?: string | null, srcset?: string | null, width?: number | null, height?: number | null, description?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null };

export type PostTeaserFragment = { __typename: 'posts_default_Entry', id?: string | null, title?: string | null, uri?: string | null, dateCreated?: any | null, date?: any | null, timestamp?: any | null, postCategory?: Array<{ __typename: 'colors_Category', title?: string | null, slug?: string | null } | { __typename: 'eventCategory_Category', title?: string | null, slug?: string | null } | { __typename: 'postCategory_Category', title?: string | null, slug?: string | null } | null> | null, keyImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', id?: string | null, url?: string | null, width?: number | null, height?: number | null, srcset?: string | null, description?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null };

export type SubmissionTeaserFragment = { __typename: 'exhibition_Submission', id?: string | null, title?: string | null, dateCreated?: any | null, status?: string | null, date?: any | null, timestamp?: any | null, postCategory?: Array<{ __typename: 'colors_Category', title?: string | null, slug?: string | null } | { __typename: 'eventCategory_Category', title?: string | null, slug?: string | null } | { __typename: 'postCategory_Category', title?: string | null, slug?: string | null } | null> | null, keyImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset' } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset', id?: string | null, url?: string | null, width?: number | null, height?: number | null, srcset?: string | null } | null> | null };

export type PostTeaserMiniFragment = { __typename: 'posts_default_Entry', id?: string | null, title?: string | null, uri?: string | null, dateCreated?: any | null, timestamp?: any | null, keyImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', id?: string | null, title?: string | null, url?: string | null, width?: number | null, height?: number | null, srcset?: string | null, description?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null };

export type ExhibitionTeaserMiniFragment = { __typename: 'exhibition_Submission', id?: string | null, title?: string | null, dateCreated?: any | null, status?: string | null, timestamp?: any | null, keyImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset' } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset', id?: string | null, title?: string | null, url?: string | null, width?: number | null, height?: number | null, srcset?: string | null } | null> | null };

export type ExhibitionFragment = { __typename: 'exhibition_Submission', id?: string | null, title?: string | null, exhibitionTitle?: string | null, exhibitionEnd?: any | null, exhibitionOpening?: any | null, curator?: string | null, artistsName?: string | null, locationName?: string | null, linkToVideo?: string | null, linkToLocation?: string | null, photographer?: string | null, socialMediaInfo?: string | null, status?: string | null, subheadline?: string | null, text?: string | null, textAuthor?: string | null, topColor?: Array<{ __typename: 'colors_Category', color?: string | null } | { __typename: 'eventCategory_Category' } | { __typename: 'postCategory_Category' } | null> | null, bottomColor?: Array<{ __typename: 'colors_Category', color?: string | null } | { __typename: 'eventCategory_Category' } | { __typename: 'postCategory_Category' } | null> | null, images?: { __typename: 'exhibition_images_FormieRepeaterField', rows?: Array<{ __typename: 'exhibition_images_FormieRepeaterFieldRow', caption?: string | null, image?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset' } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset', id?: string | null, width?: number | null, url?: string | null, title?: string | null, srcset?: string | null, height?: number | null } | null> | null } | null> | null } | null, keyImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset' } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset', id?: string | null, width?: number | null, url?: string | null, title?: string | null, srcset?: string | null, height?: number | null } | null> | null, seoImage?: Array<{ __typename: 'archiveAssets_Asset', url?: string | null, width?: number | null, height?: number | null } | { __typename: 'assets_Asset', url?: string | null, width?: number | null, height?: number | null } | { __typename: 'studioShAssets_Asset', url?: string | null, width?: number | null, height?: number | null } | { __typename: 'submissions_Asset', url?: string | null, width?: number | null, height?: number | null } | null> | null };

export type UpdateContentBannerClickCountMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  clickCount?: InputMaybe<Scalars['Number']>;
}>;


export type UpdateContentBannerClickCountMutation = { __typename: 'Mutation', save_ads_contentBanner_Entry?: { __typename: 'ads_contentBanner_Entry', id?: string | null, clickCounter?: any | null } | null };

export type UpdateSidebarBannerClickCountMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  clickCount?: InputMaybe<Scalars['Number']>;
}>;


export type UpdateSidebarBannerClickCountMutation = { __typename: 'Mutation', save_ads_sidebarBanner_Entry?: { __typename: 'ads_sidebarBanner_Entry', id?: string | null, clickCounter?: any | null } | null };

export type AboutKubaparisQueryVariables = Exact<{ [key: string]: never; }>;


export type AboutKubaparisQuery = { __typename: 'Query', entry?: { __typename: 'aboutKubaparis_aboutKubaparis_Entry', id?: string | null, title?: string | null, redactor?: string | null, contactKubaparis?: string | null, team?: Array<{ __typename: 'team_member_BlockType', id?: string | null, fullName?: string | null, socialMediaLink?: string | null, position?: string | null, portrait?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', id?: string | null, url?: string | null, width?: number | null, height?: number | null, srcset?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null } | null> | null, seo?: { __typename: 'Ether_SeoData', description?: string | null, title?: string | null, social?: { __typename: 'Ether_SeoSocialNetworks', facebook?: { __typename: 'Ether_SeoSocialData', description?: string | null, title?: string | null, image?: { __typename: 'archiveAssets_Asset', url?: string | null } | { __typename: 'assets_Asset', url?: string | null } | { __typename: 'studioShAssets_Asset', url?: string | null } | { __typename: 'submissions_Asset', url?: string | null } | null } | null, twitter?: { __typename: 'Ether_SeoSocialData', description?: string | null, title?: string | null, image?: { __typename: 'archiveAssets_Asset', url?: string | null } | { __typename: 'assets_Asset', url?: string | null } | { __typename: 'studioShAssets_Asset', url?: string | null } | { __typename: 'submissions_Asset', url?: string | null } | null } | null } | null } | null } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry' } | { __typename: 'ads_contentBanner_Entry' } | { __typename: 'ads_landingpageBanner_Entry' } | { __typename: 'ads_sidebarBanner_Entry' } | { __typename: 'advertise_advertise_Entry' } | { __typename: 'archive_archive_Entry' } | { __typename: 'archivedPost_default_Entry' } | { __typename: 'calendar_calendar_Entry' } | { __typename: 'imprint_imprint_Entry' } | { __typename: 'landingPage_landingPage_Entry' } | { __typename: 'news_color_Entry' } | { __typename: 'news_image_Entry' } | { __typename: 'posts_default_Entry' } | { __typename: 'privacyPolicy_privacyPolicy_Entry' } | { __typename: 'projects_default_Entry' } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry' } | { __typename: 'submitEvent_submitEvent_Entry' } | { __typename: 'submitExhibition_submitExhibition_Entry' } | null };

export type LandingPageQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type LandingPageQuery = { __typename: 'Query', exhibitionCount: number, postCount: number, content?: { __typename: 'aboutKubaparis_aboutKubaparis_Entry' } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry' } | { __typename: 'ads_contentBanner_Entry' } | { __typename: 'ads_landingpageBanner_Entry' } | { __typename: 'ads_sidebarBanner_Entry' } | { __typename: 'advertise_advertise_Entry' } | { __typename: 'archive_archive_Entry' } | { __typename: 'archivedPost_default_Entry' } | { __typename: 'calendar_calendar_Entry' } | { __typename: 'imprint_imprint_Entry' } | { __typename: 'landingPage_landingPage_Entry', title?: string | null, landingHero?: Array<{ __typename: 'landingHero_BlockType', background?: Array<{ __typename: 'background_image_BlockType', image?: Array<{ __typename: 'archiveAssets_Asset', title?: string | null, id?: string | null, url?: string | null, width?: number | null, height?: number | null, srcset?: string | null } | { __typename: 'assets_Asset', title?: string | null, id?: string | null, url?: string | null, width?: number | null, height?: number | null, srcset?: string | null } | { __typename: 'studioShAssets_Asset', title?: string | null, id?: string | null, url?: string | null, width?: number | null, height?: number | null, srcset?: string | null } | { __typename: 'submissions_Asset', title?: string | null, id?: string | null, url?: string | null, width?: number | null, height?: number | null, srcset?: string | null } | null> | null, imageDarkMode?: Array<{ __typename: 'archiveAssets_Asset', title?: string | null, id?: string | null, url?: string | null, width?: number | null, height?: number | null, srcset?: string | null } | { __typename: 'assets_Asset', title?: string | null, id?: string | null, url?: string | null, width?: number | null, height?: number | null, srcset?: string | null } | { __typename: 'studioShAssets_Asset', title?: string | null, id?: string | null, url?: string | null, width?: number | null, height?: number | null, srcset?: string | null } | { __typename: 'submissions_Asset', title?: string | null, id?: string | null, url?: string | null, width?: number | null, height?: number | null, srcset?: string | null } | null> | null } | { __typename: 'background_video_BlockType', video?: Array<{ __typename: 'archiveAssets_Asset', id?: string | null, embeddedAsset?: { __typename: 'EmbeddedAsset', title?: string | null, description?: string | null, aspectRatio?: number | null, height?: number | null, width?: number | null, html?: string | null } | null } | { __typename: 'assets_Asset', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, description?: string | null, id?: string | null, embeddedAsset?: { __typename: 'EmbeddedAsset', title?: string | null, description?: string | null, aspectRatio?: number | null, height?: number | null, width?: number | null, html?: string | null } | null } | { __typename: 'studioShAssets_Asset', id?: string | null, embeddedAsset?: { __typename: 'EmbeddedAsset', title?: string | null, description?: string | null, aspectRatio?: number | null, height?: number | null, width?: number | null, html?: string | null } | null } | { __typename: 'submissions_Asset', id?: string | null, embeddedAsset?: { __typename: 'EmbeddedAsset', title?: string | null, description?: string | null, aspectRatio?: number | null, height?: number | null, width?: number | null, html?: string | null } | null } | null> | null } | null> | null } | null> | null, seo?: { __typename: 'Ether_SeoData', description?: string | null, title?: string | null, social?: { __typename: 'Ether_SeoSocialNetworks', facebook?: { __typename: 'Ether_SeoSocialData', description?: string | null, title?: string | null, image?: { __typename: 'archiveAssets_Asset', url?: string | null } | { __typename: 'assets_Asset', url?: string | null } | { __typename: 'studioShAssets_Asset', url?: string | null } | { __typename: 'submissions_Asset', url?: string | null } | null } | null, twitter?: { __typename: 'Ether_SeoSocialData', description?: string | null, title?: string | null, image?: { __typename: 'archiveAssets_Asset', url?: string | null } | { __typename: 'assets_Asset', url?: string | null } | { __typename: 'studioShAssets_Asset', url?: string | null } | { __typename: 'submissions_Asset', url?: string | null } | null } | null } | null } | null } | { __typename: 'news_color_Entry' } | { __typename: 'news_image_Entry' } | { __typename: 'posts_default_Entry' } | { __typename: 'privacyPolicy_privacyPolicy_Entry' } | { __typename: 'projects_default_Entry' } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry' } | { __typename: 'submitEvent_submitEvent_Entry' } | { __typename: 'submitExhibition_submitExhibition_Entry' } | null, ads?: Array<{ __typename: 'aboutKubaparis_aboutKubaparis_Entry' } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry' } | { __typename: 'ads_contentBanner_Entry', id?: string | null, title?: string | null, externalLink?: string | null, advertisingImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', id?: string | null, kind?: string | null, url?: string | null, width?: number | null, height?: number | null, title?: string | null, description?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null } | { __typename: 'ads_landingpageBanner_Entry', id?: string | null, title?: string | null, externalLink?: string | null, advertisingImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', id?: string | null, kind?: string | null, url?: string | null, width?: number | null, height?: number | null, title?: string | null, description?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null } | { __typename: 'ads_sidebarBanner_Entry', id?: string | null, title?: string | null, externalLink?: string | null, advertisingImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', id?: string | null, kind?: string | null, url?: string | null, width?: number | null, height?: number | null, title?: string | null, description?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null } | { __typename: 'advertise_advertise_Entry' } | { __typename: 'archive_archive_Entry' } | { __typename: 'archivedPost_default_Entry' } | { __typename: 'calendar_calendar_Entry' } | { __typename: 'imprint_imprint_Entry' } | { __typename: 'landingPage_landingPage_Entry' } | { __typename: 'news_color_Entry' } | { __typename: 'news_image_Entry' } | { __typename: 'posts_default_Entry' } | { __typename: 'privacyPolicy_privacyPolicy_Entry' } | { __typename: 'projects_default_Entry' } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry' } | { __typename: 'submitEvent_submitEvent_Entry' } | { __typename: 'submitExhibition_submitExhibition_Entry' } | null> | null, news?: Array<{ __typename: 'aboutKubaparis_aboutKubaparis_Entry' } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry' } | { __typename: 'ads_contentBanner_Entry' } | { __typename: 'ads_landingpageBanner_Entry' } | { __typename: 'ads_sidebarBanner_Entry' } | { __typename: 'advertise_advertise_Entry' } | { __typename: 'archive_archive_Entry' } | { __typename: 'archivedPost_default_Entry' } | { __typename: 'calendar_calendar_Entry' } | { __typename: 'imprint_imprint_Entry' } | { __typename: 'landingPage_landingPage_Entry' } | { __typename: 'news_color_Entry', id?: string | null, title?: string | null, newsLink?: string | null, backgroundColor?: string | null } | { __typename: 'news_image_Entry', id?: string | null, title?: string | null, newsLink?: string | null, newsImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', url?: string | null, srcset?: string | null, width?: number | null, height?: number | null, description?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null } | { __typename: 'posts_default_Entry' } | { __typename: 'privacyPolicy_privacyPolicy_Entry' } | { __typename: 'projects_default_Entry' } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry' } | { __typename: 'submitEvent_submitEvent_Entry' } | { __typename: 'submitExhibition_submitExhibition_Entry' } | null> | null, posts?: Array<{ __typename: 'aboutKubaparis_aboutKubaparis_Entry' } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry' } | { __typename: 'ads_contentBanner_Entry' } | { __typename: 'ads_landingpageBanner_Entry' } | { __typename: 'ads_sidebarBanner_Entry' } | { __typename: 'advertise_advertise_Entry' } | { __typename: 'archive_archive_Entry' } | { __typename: 'archivedPost_default_Entry' } | { __typename: 'calendar_calendar_Entry' } | { __typename: 'imprint_imprint_Entry' } | { __typename: 'landingPage_landingPage_Entry' } | { __typename: 'news_color_Entry' } | { __typename: 'news_image_Entry' } | { __typename: 'posts_default_Entry', id?: string | null, title?: string | null, uri?: string | null, dateCreated?: any | null, date?: any | null, timestamp?: any | null, postCategory?: Array<{ __typename: 'colors_Category', title?: string | null, slug?: string | null } | { __typename: 'eventCategory_Category', title?: string | null, slug?: string | null } | { __typename: 'postCategory_Category', title?: string | null, slug?: string | null } | null> | null, keyImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', id?: string | null, url?: string | null, width?: number | null, height?: number | null, srcset?: string | null, description?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null } | { __typename: 'privacyPolicy_privacyPolicy_Entry' } | { __typename: 'projects_default_Entry' } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry' } | { __typename: 'submitEvent_submitEvent_Entry' } | { __typename: 'submitExhibition_submitExhibition_Entry' } | null> | null, submissions?: Array<{ __typename: 'event_Submission' } | { __typename: 'exhibition_Submission', id?: string | null, title?: string | null, dateCreated?: any | null, status?: string | null, date?: any | null, timestamp?: any | null, postCategory?: Array<{ __typename: 'colors_Category', title?: string | null, slug?: string | null } | { __typename: 'eventCategory_Category', title?: string | null, slug?: string | null } | { __typename: 'postCategory_Category', title?: string | null, slug?: string | null } | null> | null, keyImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset' } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset', id?: string | null, url?: string | null, width?: number | null, height?: number | null, srcset?: string | null } | null> | null } | null> | null, overlayVideos?: { __typename: 'footer_GlobalSet' } | { __typename: 'landingPageVideos_GlobalSet', kubaparisVideos?: Array<{ __typename: 'kubaparisVideos_BlockType', backgroundColor?: string | null, backgroundColorDarkMode?: string | null, desktop?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', url?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null, mobile?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', url?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null, desktopDarkMode?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', url?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null, mobileDarkMode?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', url?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null } | null> | null } | { __typename: 'menu_GlobalSet' } | { __typename: 'studioShMenu_GlobalSet' } | null };

export type MorePostsAndSubmissionsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type MorePostsAndSubmissionsQuery = { __typename: 'Query', posts?: Array<{ __typename: 'aboutKubaparis_aboutKubaparis_Entry' } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry' } | { __typename: 'ads_contentBanner_Entry' } | { __typename: 'ads_landingpageBanner_Entry' } | { __typename: 'ads_sidebarBanner_Entry' } | { __typename: 'advertise_advertise_Entry' } | { __typename: 'archive_archive_Entry' } | { __typename: 'archivedPost_default_Entry' } | { __typename: 'calendar_calendar_Entry' } | { __typename: 'imprint_imprint_Entry' } | { __typename: 'landingPage_landingPage_Entry' } | { __typename: 'news_color_Entry' } | { __typename: 'news_image_Entry' } | { __typename: 'posts_default_Entry', id?: string | null, title?: string | null, uri?: string | null, dateCreated?: any | null, date?: any | null, timestamp?: any | null, postCategory?: Array<{ __typename: 'colors_Category', title?: string | null, slug?: string | null } | { __typename: 'eventCategory_Category', title?: string | null, slug?: string | null } | { __typename: 'postCategory_Category', title?: string | null, slug?: string | null } | null> | null, keyImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', id?: string | null, url?: string | null, width?: number | null, height?: number | null, srcset?: string | null, description?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null } | { __typename: 'privacyPolicy_privacyPolicy_Entry' } | { __typename: 'projects_default_Entry' } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry' } | { __typename: 'submitEvent_submitEvent_Entry' } | { __typename: 'submitExhibition_submitExhibition_Entry' } | null> | null, submissions?: Array<{ __typename: 'event_Submission' } | { __typename: 'exhibition_Submission', id?: string | null, title?: string | null, dateCreated?: any | null, status?: string | null, date?: any | null, timestamp?: any | null, postCategory?: Array<{ __typename: 'colors_Category', title?: string | null, slug?: string | null } | { __typename: 'eventCategory_Category', title?: string | null, slug?: string | null } | { __typename: 'postCategory_Category', title?: string | null, slug?: string | null } | null> | null, keyImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset' } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset', id?: string | null, url?: string | null, width?: number | null, height?: number | null, srcset?: string | null } | null> | null } | null> | null };

export type MenuFragmentFragment = { __typename: 'menu_GlobalSet', socialMediaLinks?: Array<{ __typename: 'socialMediaLinks_TableRow', label?: string | null, link?: string | null } | null> | null, menuSubpages?: Array<{ __typename: 'menuSubpages_subpage_BlockType', id?: string | null, label?: string | null, subpage?: Array<{ __typename: 'aboutKubaparis_aboutKubaparis_Entry', uri?: string | null } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry', uri?: string | null } | { __typename: 'ads_contentBanner_Entry', uri?: string | null } | { __typename: 'ads_landingpageBanner_Entry', uri?: string | null } | { __typename: 'ads_sidebarBanner_Entry', uri?: string | null } | { __typename: 'advertise_advertise_Entry', uri?: string | null } | { __typename: 'archive_archive_Entry', uri?: string | null } | { __typename: 'archivedPost_default_Entry', uri?: string | null } | { __typename: 'calendar_calendar_Entry', uri?: string | null } | { __typename: 'imprint_imprint_Entry', uri?: string | null } | { __typename: 'landingPage_landingPage_Entry', uri?: string | null } | { __typename: 'news_color_Entry', uri?: string | null } | { __typename: 'news_image_Entry', uri?: string | null } | { __typename: 'posts_default_Entry', uri?: string | null } | { __typename: 'privacyPolicy_privacyPolicy_Entry', uri?: string | null } | { __typename: 'projects_default_Entry', uri?: string | null } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry', uri?: string | null } | { __typename: 'submitEvent_submitEvent_Entry', uri?: string | null } | { __typename: 'submitExhibition_submitExhibition_Entry', uri?: string | null } | null> | null } | null> | null };

export type GlobalContentQueryVariables = Exact<{ [key: string]: never; }>;


export type GlobalContentQuery = { __typename: 'Query', kubaparisMenu?: { __typename: 'footer_GlobalSet' } | { __typename: 'landingPageVideos_GlobalSet' } | { __typename: 'menu_GlobalSet', socialMediaLinks?: Array<{ __typename: 'socialMediaLinks_TableRow', label?: string | null, link?: string | null } | null> | null, menuSubpages?: Array<{ __typename: 'menuSubpages_subpage_BlockType', id?: string | null, label?: string | null, subpage?: Array<{ __typename: 'aboutKubaparis_aboutKubaparis_Entry', uri?: string | null } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry', uri?: string | null } | { __typename: 'ads_contentBanner_Entry', uri?: string | null } | { __typename: 'ads_landingpageBanner_Entry', uri?: string | null } | { __typename: 'ads_sidebarBanner_Entry', uri?: string | null } | { __typename: 'advertise_advertise_Entry', uri?: string | null } | { __typename: 'archive_archive_Entry', uri?: string | null } | { __typename: 'archivedPost_default_Entry', uri?: string | null } | { __typename: 'calendar_calendar_Entry', uri?: string | null } | { __typename: 'imprint_imprint_Entry', uri?: string | null } | { __typename: 'landingPage_landingPage_Entry', uri?: string | null } | { __typename: 'news_color_Entry', uri?: string | null } | { __typename: 'news_image_Entry', uri?: string | null } | { __typename: 'posts_default_Entry', uri?: string | null } | { __typename: 'privacyPolicy_privacyPolicy_Entry', uri?: string | null } | { __typename: 'projects_default_Entry', uri?: string | null } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry', uri?: string | null } | { __typename: 'submitEvent_submitEvent_Entry', uri?: string | null } | { __typename: 'submitExhibition_submitExhibition_Entry', uri?: string | null } | null> | null } | null> | null } | { __typename: 'studioShMenu_GlobalSet' } | null, postCategories?: Array<{ __typename: 'colors_Category', id?: string | null, title?: string | null, uri?: string | null } | { __typename: 'eventCategory_Category', id?: string | null, title?: string | null, uri?: string | null } | { __typename: 'postCategory_Category', id?: string | null, title?: string | null, uri?: string | null } | null> | null, submissionPages?: Array<{ __typename: 'aboutKubaparis_aboutKubaparis_Entry' } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry' } | { __typename: 'ads_contentBanner_Entry' } | { __typename: 'ads_landingpageBanner_Entry' } | { __typename: 'ads_sidebarBanner_Entry' } | { __typename: 'advertise_advertise_Entry' } | { __typename: 'archive_archive_Entry' } | { __typename: 'archivedPost_default_Entry' } | { __typename: 'calendar_calendar_Entry' } | { __typename: 'imprint_imprint_Entry' } | { __typename: 'landingPage_landingPage_Entry' } | { __typename: 'news_color_Entry' } | { __typename: 'news_image_Entry' } | { __typename: 'posts_default_Entry' } | { __typename: 'privacyPolicy_privacyPolicy_Entry' } | { __typename: 'projects_default_Entry' } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry' } | { __typename: 'submitEvent_submitEvent_Entry', id?: string | null, title?: string | null, uri?: string | null } | { __typename: 'submitExhibition_submitExhibition_Entry', id?: string | null, uri?: string | null, title?: string | null } | null> | null, footer?: { __typename: 'footer_GlobalSet', id?: string | null, name?: string | null, newsletterLabel?: string | null, newsletterLink?: string | null, blogContactEmail?: string | null, blogContactLabel?: string | null, studioContactEmail?: string | null, studioContactLabel?: string | null, about?: Array<{ __typename: 'about_footerAbout_BlockType', id?: string | null, aboutText?: string | null } | null> | null, followUs?: Array<{ __typename: 'followUs_socialMediaEntry_BlockType', id?: string | null, externalLink?: string | null, label?: string | null } | null> | null, linkToSingles?: Array<{ __typename: 'aboutKubaparis_aboutKubaparis_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'ads_contentBanner_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'ads_landingpageBanner_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'ads_sidebarBanner_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'advertise_advertise_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'archive_archive_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'archivedPost_default_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'calendar_calendar_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'imprint_imprint_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'landingPage_landingPage_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'news_color_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'news_image_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'posts_default_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'privacyPolicy_privacyPolicy_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'projects_default_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'submitEvent_submitEvent_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'submitExhibition_submitExhibition_Entry', id?: string | null, uri?: string | null, title?: string | null } | null> | null } | { __typename: 'landingPageVideos_GlobalSet' } | { __typename: 'menu_GlobalSet' } | { __typename: 'studioShMenu_GlobalSet' } | null, ads?: Array<{ __typename: 'aboutKubaparis_aboutKubaparis_Entry' } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry' } | { __typename: 'ads_contentBanner_Entry', id?: string | null, title?: string | null, externalLink?: string | null, advertisingImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', id?: string | null, kind?: string | null, url?: string | null, width?: number | null, height?: number | null, title?: string | null, description?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null } | { __typename: 'ads_landingpageBanner_Entry', id?: string | null, title?: string | null, externalLink?: string | null, advertisingImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', id?: string | null, kind?: string | null, url?: string | null, width?: number | null, height?: number | null, title?: string | null, description?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null } | { __typename: 'ads_sidebarBanner_Entry', id?: string | null, title?: string | null, externalLink?: string | null, advertisingImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', id?: string | null, kind?: string | null, url?: string | null, width?: number | null, height?: number | null, title?: string | null, description?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null } | { __typename: 'advertise_advertise_Entry' } | { __typename: 'archive_archive_Entry' } | { __typename: 'archivedPost_default_Entry' } | { __typename: 'calendar_calendar_Entry' } | { __typename: 'imprint_imprint_Entry' } | { __typename: 'landingPage_landingPage_Entry' } | { __typename: 'news_color_Entry' } | { __typename: 'news_image_Entry' } | { __typename: 'posts_default_Entry' } | { __typename: 'privacyPolicy_privacyPolicy_Entry' } | { __typename: 'projects_default_Entry' } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry' } | { __typename: 'submitEvent_submitEvent_Entry' } | { __typename: 'submitExhibition_submitExhibition_Entry' } | null> | null };

export type CalendarQueryVariables = Exact<{ [key: string]: never; }>;


export type CalendarQuery = { __typename: 'Query', entry?: { __typename: 'aboutKubaparis_aboutKubaparis_Entry' } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry' } | { __typename: 'ads_contentBanner_Entry' } | { __typename: 'ads_landingpageBanner_Entry' } | { __typename: 'ads_sidebarBanner_Entry' } | { __typename: 'advertise_advertise_Entry' } | { __typename: 'archive_archive_Entry' } | { __typename: 'archivedPost_default_Entry' } | { __typename: 'calendar_calendar_Entry', id?: string | null, bgColor?: string | null, fontColor?: string | null } | { __typename: 'imprint_imprint_Entry' } | { __typename: 'landingPage_landingPage_Entry' } | { __typename: 'news_color_Entry' } | { __typename: 'news_image_Entry' } | { __typename: 'posts_default_Entry' } | { __typename: 'privacyPolicy_privacyPolicy_Entry' } | { __typename: 'projects_default_Entry' } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry' } | { __typename: 'submitEvent_submitEvent_Entry' } | { __typename: 'submitExhibition_submitExhibition_Entry' } | null, events?: Array<{ __typename: 'event_Submission', id?: string | null, title?: string | null, linkToLocation?: string | null, locationName?: string | null, namesInvolved?: string | null, eventTitle?: string | null, slug?: string | null, startDate?: any | null, endDate?: any | null, status?: string | null, city?: string | null, eventCategory?: Array<{ __typename: 'colors_Category' } | { __typename: 'eventCategory_Category', id?: string | null, title?: string | null, slug?: string | null } | { __typename: 'postCategory_Category' } | null> | null } | { __typename: 'exhibition_Submission' } | null> | null };

export type EventTeaserFragment = { __typename: 'event_Submission', id?: string | null, title?: string | null, linkToLocation?: string | null, locationName?: string | null, namesInvolved?: string | null, eventTitle?: string | null, slug?: string | null, startDate?: any | null, endDate?: any | null, status?: string | null, city?: string | null, eventCategory?: Array<{ __typename: 'colors_Category' } | { __typename: 'eventCategory_Category', id?: string | null, title?: string | null, slug?: string | null } | { __typename: 'postCategory_Category' } | null> | null };

export type SubmitExhibitionQueryVariables = Exact<{ [key: string]: never; }>;


export type SubmitExhibitionQuery = { __typename: 'Query', entry?: { __typename: 'aboutKubaparis_aboutKubaparis_Entry' } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry' } | { __typename: 'ads_contentBanner_Entry' } | { __typename: 'ads_landingpageBanner_Entry' } | { __typename: 'ads_sidebarBanner_Entry' } | { __typename: 'advertise_advertise_Entry' } | { __typename: 'archive_archive_Entry' } | { __typename: 'archivedPost_default_Entry' } | { __typename: 'calendar_calendar_Entry' } | { __typename: 'imprint_imprint_Entry' } | { __typename: 'landingPage_landingPage_Entry' } | { __typename: 'news_color_Entry' } | { __typename: 'news_image_Entry' } | { __typename: 'posts_default_Entry' } | { __typename: 'privacyPolicy_privacyPolicy_Entry' } | { __typename: 'projects_default_Entry' } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry' } | { __typename: 'submitEvent_submitEvent_Entry' } | { __typename: 'submitExhibition_submitExhibition_Entry', infoText?: string | null } | null, formieForm?: { __typename: 'event_Form', id?: string | null, handle?: string | null, templateHtml?: string | null, configJson?: string | null } | { __typename: 'exhibition_Form', id?: string | null, handle?: string | null, templateHtml?: string | null, configJson?: string | null } | null };

export type SubmitEventQueryVariables = Exact<{ [key: string]: never; }>;


export type SubmitEventQuery = { __typename: 'Query', entry?: { __typename: 'aboutKubaparis_aboutKubaparis_Entry' } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry' } | { __typename: 'ads_contentBanner_Entry' } | { __typename: 'ads_landingpageBanner_Entry' } | { __typename: 'ads_sidebarBanner_Entry' } | { __typename: 'advertise_advertise_Entry' } | { __typename: 'archive_archive_Entry' } | { __typename: 'archivedPost_default_Entry' } | { __typename: 'calendar_calendar_Entry' } | { __typename: 'imprint_imprint_Entry' } | { __typename: 'landingPage_landingPage_Entry' } | { __typename: 'news_color_Entry' } | { __typename: 'news_image_Entry' } | { __typename: 'posts_default_Entry' } | { __typename: 'privacyPolicy_privacyPolicy_Entry' } | { __typename: 'projects_default_Entry' } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry' } | { __typename: 'submitEvent_submitEvent_Entry', infoText?: string | null } | { __typename: 'submitExhibition_submitExhibition_Entry' } | null, formieForm?: { __typename: 'event_Form', id?: string | null, handle?: string | null, templateHtml?: string | null, configJson?: string | null } | { __typename: 'exhibition_Form', id?: string | null, handle?: string | null, templateHtml?: string | null, configJson?: string | null } | null };

export type SubmissionSuccessfulQueryVariables = Exact<{ [key: string]: never; }>;


export type SubmissionSuccessfulQuery = { __typename: 'Query', entry?: { __typename: 'aboutKubaparis_aboutKubaparis_Entry' } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry' } | { __typename: 'ads_contentBanner_Entry' } | { __typename: 'ads_landingpageBanner_Entry' } | { __typename: 'ads_sidebarBanner_Entry' } | { __typename: 'advertise_advertise_Entry' } | { __typename: 'archive_archive_Entry' } | { __typename: 'archivedPost_default_Entry' } | { __typename: 'calendar_calendar_Entry' } | { __typename: 'imprint_imprint_Entry' } | { __typename: 'landingPage_landingPage_Entry' } | { __typename: 'news_color_Entry' } | { __typename: 'news_image_Entry' } | { __typename: 'posts_default_Entry' } | { __typename: 'privacyPolicy_privacyPolicy_Entry' } | { __typename: 'projects_default_Entry' } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry', infoText?: string | null } | { __typename: 'submitEvent_submitEvent_Entry' } | { __typename: 'submitExhibition_submitExhibition_Entry' } | null };

export type ImprintQueryVariables = Exact<{ [key: string]: never; }>;


export type ImprintQuery = { __typename: 'Query', entry?: { __typename: 'aboutKubaparis_aboutKubaparis_Entry' } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry' } | { __typename: 'ads_contentBanner_Entry' } | { __typename: 'ads_landingpageBanner_Entry' } | { __typename: 'ads_sidebarBanner_Entry' } | { __typename: 'advertise_advertise_Entry' } | { __typename: 'archive_archive_Entry' } | { __typename: 'archivedPost_default_Entry' } | { __typename: 'calendar_calendar_Entry' } | { __typename: 'imprint_imprint_Entry', id?: string | null, title?: string | null, redactor?: string | null, seo?: { __typename: 'Ether_SeoData', description?: string | null, title?: string | null, social?: { __typename: 'Ether_SeoSocialNetworks', facebook?: { __typename: 'Ether_SeoSocialData', description?: string | null, title?: string | null, image?: { __typename: 'archiveAssets_Asset', url?: string | null } | { __typename: 'assets_Asset', url?: string | null } | { __typename: 'studioShAssets_Asset', url?: string | null } | { __typename: 'submissions_Asset', url?: string | null } | null } | null, twitter?: { __typename: 'Ether_SeoSocialData', description?: string | null, title?: string | null, image?: { __typename: 'archiveAssets_Asset', url?: string | null } | { __typename: 'assets_Asset', url?: string | null } | { __typename: 'studioShAssets_Asset', url?: string | null } | { __typename: 'submissions_Asset', url?: string | null } | null } | null } | null } | null } | { __typename: 'landingPage_landingPage_Entry' } | { __typename: 'news_color_Entry' } | { __typename: 'news_image_Entry' } | { __typename: 'posts_default_Entry' } | { __typename: 'privacyPolicy_privacyPolicy_Entry' } | { __typename: 'projects_default_Entry' } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry' } | { __typename: 'submitEvent_submitEvent_Entry' } | { __typename: 'submitExhibition_submitExhibition_Entry' } | null };

export type AdvertiseQueryVariables = Exact<{ [key: string]: never; }>;


export type AdvertiseQuery = { __typename: 'Query', entry?: { __typename: 'aboutKubaparis_aboutKubaparis_Entry' } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry' } | { __typename: 'ads_contentBanner_Entry' } | { __typename: 'ads_landingpageBanner_Entry' } | { __typename: 'ads_sidebarBanner_Entry' } | { __typename: 'advertise_advertise_Entry', title?: string | null, label?: string | null, advertisePdf?: Array<{ __typename: 'archiveAssets_Asset', id?: string | null, url?: string | null } | { __typename: 'assets_Asset', id?: string | null, url?: string | null } | { __typename: 'studioShAssets_Asset', id?: string | null, url?: string | null } | { __typename: 'submissions_Asset', id?: string | null, url?: string | null } | null> | null, seo?: { __typename: 'Ether_SeoData', description?: string | null, title?: string | null, social?: { __typename: 'Ether_SeoSocialNetworks', facebook?: { __typename: 'Ether_SeoSocialData', description?: string | null, title?: string | null, image?: { __typename: 'archiveAssets_Asset', url?: string | null } | { __typename: 'assets_Asset', url?: string | null } | { __typename: 'studioShAssets_Asset', url?: string | null } | { __typename: 'submissions_Asset', url?: string | null } | null } | null, twitter?: { __typename: 'Ether_SeoSocialData', description?: string | null, title?: string | null, image?: { __typename: 'archiveAssets_Asset', url?: string | null } | { __typename: 'assets_Asset', url?: string | null } | { __typename: 'studioShAssets_Asset', url?: string | null } | { __typename: 'submissions_Asset', url?: string | null } | null } | null } | null } | null } | { __typename: 'archive_archive_Entry' } | { __typename: 'archivedPost_default_Entry' } | { __typename: 'calendar_calendar_Entry' } | { __typename: 'imprint_imprint_Entry' } | { __typename: 'landingPage_landingPage_Entry' } | { __typename: 'news_color_Entry' } | { __typename: 'news_image_Entry' } | { __typename: 'posts_default_Entry' } | { __typename: 'privacyPolicy_privacyPolicy_Entry' } | { __typename: 'projects_default_Entry' } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry' } | { __typename: 'submitEvent_submitEvent_Entry' } | { __typename: 'submitExhibition_submitExhibition_Entry' } | null };

export type PrivacyPolicyQueryVariables = Exact<{ [key: string]: never; }>;


export type PrivacyPolicyQuery = { __typename: 'Query', entry?: { __typename: 'aboutKubaparis_aboutKubaparis_Entry' } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry' } | { __typename: 'ads_contentBanner_Entry' } | { __typename: 'ads_landingpageBanner_Entry' } | { __typename: 'ads_sidebarBanner_Entry' } | { __typename: 'advertise_advertise_Entry' } | { __typename: 'archive_archive_Entry' } | { __typename: 'archivedPost_default_Entry' } | { __typename: 'calendar_calendar_Entry' } | { __typename: 'imprint_imprint_Entry' } | { __typename: 'landingPage_landingPage_Entry' } | { __typename: 'news_color_Entry' } | { __typename: 'news_image_Entry' } | { __typename: 'posts_default_Entry' } | { __typename: 'privacyPolicy_privacyPolicy_Entry', title?: string | null, redactor?: string | null, seo?: { __typename: 'Ether_SeoData', description?: string | null, title?: string | null, social?: { __typename: 'Ether_SeoSocialNetworks', facebook?: { __typename: 'Ether_SeoSocialData', description?: string | null, title?: string | null, image?: { __typename: 'archiveAssets_Asset', url?: string | null } | { __typename: 'assets_Asset', url?: string | null } | { __typename: 'studioShAssets_Asset', url?: string | null } | { __typename: 'submissions_Asset', url?: string | null } | null } | null, twitter?: { __typename: 'Ether_SeoSocialData', description?: string | null, title?: string | null, image?: { __typename: 'archiveAssets_Asset', url?: string | null } | { __typename: 'assets_Asset', url?: string | null } | { __typename: 'studioShAssets_Asset', url?: string | null } | { __typename: 'submissions_Asset', url?: string | null } | null } | null } | null } | null } | { __typename: 'projects_default_Entry' } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry' } | { __typename: 'submitEvent_submitEvent_Entry' } | { __typename: 'submitExhibition_submitExhibition_Entry' } | null };

export type ExhibitionQueryVariables = Exact<{
  post_id?: InputMaybe<Scalars['QueryArgument']>;
}>;


export type ExhibitionQuery = { __typename: 'Query', exhibition?: { __typename: 'event_Submission' } | { __typename: 'exhibition_Submission', id?: string | null, title?: string | null, exhibitionTitle?: string | null, exhibitionEnd?: any | null, exhibitionOpening?: any | null, curator?: string | null, artistsName?: string | null, locationName?: string | null, linkToVideo?: string | null, linkToLocation?: string | null, photographer?: string | null, socialMediaInfo?: string | null, status?: string | null, subheadline?: string | null, text?: string | null, textAuthor?: string | null, topColor?: Array<{ __typename: 'colors_Category', color?: string | null } | { __typename: 'eventCategory_Category' } | { __typename: 'postCategory_Category' } | null> | null, bottomColor?: Array<{ __typename: 'colors_Category', color?: string | null } | { __typename: 'eventCategory_Category' } | { __typename: 'postCategory_Category' } | null> | null, images?: { __typename: 'exhibition_images_FormieRepeaterField', rows?: Array<{ __typename: 'exhibition_images_FormieRepeaterFieldRow', caption?: string | null, image?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset' } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset', id?: string | null, width?: number | null, url?: string | null, title?: string | null, srcset?: string | null, height?: number | null } | null> | null } | null> | null } | null, keyImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset' } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset', id?: string | null, width?: number | null, url?: string | null, title?: string | null, srcset?: string | null, height?: number | null } | null> | null, seoImage?: Array<{ __typename: 'archiveAssets_Asset', url?: string | null, width?: number | null, height?: number | null } | { __typename: 'assets_Asset', url?: string | null, width?: number | null, height?: number | null } | { __typename: 'studioShAssets_Asset', url?: string | null, width?: number | null, height?: number | null } | { __typename: 'submissions_Asset', url?: string | null, width?: number | null, height?: number | null } | null> | null } | null, morePosts?: Array<{ __typename: 'aboutKubaparis_aboutKubaparis_Entry' } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry' } | { __typename: 'ads_contentBanner_Entry' } | { __typename: 'ads_landingpageBanner_Entry' } | { __typename: 'ads_sidebarBanner_Entry' } | { __typename: 'advertise_advertise_Entry' } | { __typename: 'archive_archive_Entry' } | { __typename: 'archivedPost_default_Entry' } | { __typename: 'calendar_calendar_Entry' } | { __typename: 'imprint_imprint_Entry' } | { __typename: 'landingPage_landingPage_Entry' } | { __typename: 'news_color_Entry' } | { __typename: 'news_image_Entry' } | { __typename: 'posts_default_Entry', id?: string | null, title?: string | null, uri?: string | null, dateCreated?: any | null, timestamp?: any | null, keyImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', id?: string | null, title?: string | null, url?: string | null, width?: number | null, height?: number | null, srcset?: string | null, description?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null } | { __typename: 'privacyPolicy_privacyPolicy_Entry' } | { __typename: 'projects_default_Entry' } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry' } | { __typename: 'submitEvent_submitEvent_Entry' } | { __typename: 'submitExhibition_submitExhibition_Entry' } | null> | null, moreExhibitions?: Array<{ __typename: 'event_Submission' } | { __typename: 'exhibition_Submission', id?: string | null, title?: string | null, dateCreated?: any | null, status?: string | null, timestamp?: any | null, keyImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset' } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset', id?: string | null, title?: string | null, url?: string | null, width?: number | null, height?: number | null, srcset?: string | null } | null> | null } | null> | null };

export type PostQueryVariables = Exact<{
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type PostQuery = { __typename: 'Query', entry?: { __typename: 'aboutKubaparis_aboutKubaparis_Entry', id?: string | null } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry', id?: string | null } | { __typename: 'ads_contentBanner_Entry', id?: string | null } | { __typename: 'ads_landingpageBanner_Entry', id?: string | null } | { __typename: 'ads_sidebarBanner_Entry', id?: string | null } | { __typename: 'advertise_advertise_Entry', id?: string | null } | { __typename: 'archive_archive_Entry', id?: string | null } | { __typename: 'archivedPost_default_Entry', id?: string | null } | { __typename: 'calendar_calendar_Entry', id?: string | null } | { __typename: 'imprint_imprint_Entry', id?: string | null } | { __typename: 'landingPage_landingPage_Entry', id?: string | null } | { __typename: 'news_color_Entry', id?: string | null } | { __typename: 'news_image_Entry', id?: string | null } | { __typename: 'posts_default_Entry', id?: string | null, title?: string | null, slug?: string | null, subheading?: string | null, projectInfo?: Array<{ __typename: 'projectInfo_TableRow', projectInfo?: string | null } | null> | null, topColor?: Array<{ __typename: 'colors_Category', color?: string | null } | { __typename: 'eventCategory_Category' } | { __typename: 'postCategory_Category' } | null> | null, bottomColor?: Array<{ __typename: 'colors_Category', color?: string | null } | { __typename: 'eventCategory_Category' } | { __typename: 'postCategory_Category' } | null> | null, keyImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', url?: string | null, width?: number | null, height?: number | null, srcset?: string | null, description?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null, contentBlocks?: Array<{ __typename: 'contentBlocks_Slider_BlockType', id?: string | null, slides?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', title?: string | null, id?: string | null, url?: string | null, width?: number | null, height?: number | null, srcset?: string | null, description?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null } | { __typename: 'contentBlocks_imagePair_BlockType', id?: string | null, kind?: string | null, leftImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', id?: string | null, url?: string | null, width?: number | null, height?: number | null, srcset?: string | null, description?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null, rightImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', id?: string | null, url?: string | null, width?: number | null, height?: number | null, srcset?: string | null, description?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null } | { __typename: 'contentBlocks_image_BlockType', id?: string | null, kind?: string | null, image?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', id?: string | null, url?: string | null, width?: number | null, height?: number | null, srcset?: string | null, description?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null } | { __typename: 'contentBlocks_instagram_BlockType', id?: string | null, embedCodes?: Array<{ __typename: 'embedCodes_TableRow', embedCode?: string | null } | null> | null } | { __typename: 'contentBlocks_interview_BlockType', id?: string | null, interviewer?: Array<{ __typename: 'interviewer_TableRow', fullName?: string | null, initials?: string | null } | null> | null, interviewee?: Array<{ __typename: 'interviewee_TableRow', fullName?: string | null, initials?: string | null } | null> | null, questionsAndAnswers?: Array<{ __typename: 'questionsAndAnswers_TableRow', question?: string | null, answer?: string | null } | null> | null } | { __typename: 'contentBlocks_textBlock_BlockType', id?: string | null, text?: string | null } | { __typename: 'contentBlocks_video_BlockType', id?: string | null, video?: Array<{ __typename: 'archiveAssets_Asset', embeddedAsset?: { __typename: 'EmbeddedAsset', title?: string | null, description?: string | null, aspectRatio?: number | null, height?: number | null, width?: number | null, html?: string | null } | null } | { __typename: 'assets_Asset', title?: string | null, kind?: string | null, url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, description?: string | null, embeddedAsset?: { __typename: 'EmbeddedAsset', title?: string | null, description?: string | null, aspectRatio?: number | null, height?: number | null, width?: number | null, html?: string | null } | null } | { __typename: 'studioShAssets_Asset', embeddedAsset?: { __typename: 'EmbeddedAsset', title?: string | null, description?: string | null, aspectRatio?: number | null, height?: number | null, width?: number | null, html?: string | null } | null } | { __typename: 'submissions_Asset', embeddedAsset?: { __typename: 'EmbeddedAsset', title?: string | null, description?: string | null, aspectRatio?: number | null, height?: number | null, width?: number | null, html?: string | null } | null } | null> | null } | null> | null, seo?: { __typename: 'Ether_SeoData', description?: string | null, title?: string | null, social?: { __typename: 'Ether_SeoSocialNetworks', facebook?: { __typename: 'Ether_SeoSocialData', description?: string | null, title?: string | null, image?: { __typename: 'archiveAssets_Asset', url?: string | null } | { __typename: 'assets_Asset', url?: string | null } | { __typename: 'studioShAssets_Asset', url?: string | null } | { __typename: 'submissions_Asset', url?: string | null } | null } | null, twitter?: { __typename: 'Ether_SeoSocialData', description?: string | null, title?: string | null, image?: { __typename: 'archiveAssets_Asset', url?: string | null } | { __typename: 'assets_Asset', url?: string | null } | { __typename: 'studioShAssets_Asset', url?: string | null } | { __typename: 'submissions_Asset', url?: string | null } | null } | null } | null } | null } | { __typename: 'privacyPolicy_privacyPolicy_Entry', id?: string | null } | { __typename: 'projects_default_Entry', id?: string | null } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry', id?: string | null } | { __typename: 'submitEvent_submitEvent_Entry', id?: string | null } | { __typename: 'submitExhibition_submitExhibition_Entry', id?: string | null } | null, morePosts?: Array<{ __typename: 'aboutKubaparis_aboutKubaparis_Entry' } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry' } | { __typename: 'ads_contentBanner_Entry' } | { __typename: 'ads_landingpageBanner_Entry' } | { __typename: 'ads_sidebarBanner_Entry' } | { __typename: 'advertise_advertise_Entry' } | { __typename: 'archive_archive_Entry' } | { __typename: 'archivedPost_default_Entry' } | { __typename: 'calendar_calendar_Entry' } | { __typename: 'imprint_imprint_Entry' } | { __typename: 'landingPage_landingPage_Entry' } | { __typename: 'news_color_Entry' } | { __typename: 'news_image_Entry' } | { __typename: 'posts_default_Entry', id?: string | null, title?: string | null, uri?: string | null, dateCreated?: any | null, timestamp?: any | null, keyImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', id?: string | null, title?: string | null, url?: string | null, width?: number | null, height?: number | null, srcset?: string | null, description?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null } | { __typename: 'privacyPolicy_privacyPolicy_Entry' } | { __typename: 'projects_default_Entry' } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry' } | { __typename: 'submitEvent_submitEvent_Entry' } | { __typename: 'submitExhibition_submitExhibition_Entry' } | null> | null, moreExhibitions?: Array<{ __typename: 'event_Submission' } | { __typename: 'exhibition_Submission', id?: string | null, title?: string | null, dateCreated?: any | null, status?: string | null, timestamp?: any | null, keyImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset' } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset', id?: string | null, title?: string | null, url?: string | null, width?: number | null, height?: number | null, srcset?: string | null } | null> | null } | null> | null };

export type PostsByCategoryQueryVariables = Exact<{
  category?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type PostsByCategoryQuery = { __typename: 'Query', posts?: Array<{ __typename: 'aboutKubaparis_aboutKubaparis_Entry', id?: string | null } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry', id?: string | null } | { __typename: 'ads_contentBanner_Entry', id?: string | null } | { __typename: 'ads_landingpageBanner_Entry', id?: string | null } | { __typename: 'ads_sidebarBanner_Entry', id?: string | null } | { __typename: 'advertise_advertise_Entry', id?: string | null } | { __typename: 'archive_archive_Entry', id?: string | null } | { __typename: 'archivedPost_default_Entry', id?: string | null } | { __typename: 'calendar_calendar_Entry', id?: string | null } | { __typename: 'imprint_imprint_Entry', id?: string | null } | { __typename: 'landingPage_landingPage_Entry', id?: string | null } | { __typename: 'news_color_Entry', id?: string | null } | { __typename: 'news_image_Entry', id?: string | null } | { __typename: 'posts_default_Entry', id?: string | null, title?: string | null, uri?: string | null, dateCreated?: any | null, date?: any | null, timestamp?: any | null, postCategory?: Array<{ __typename: 'colors_Category', title?: string | null, slug?: string | null } | { __typename: 'eventCategory_Category', title?: string | null, slug?: string | null } | { __typename: 'postCategory_Category', title?: string | null, slug?: string | null } | null> | null, keyImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', id?: string | null, url?: string | null, width?: number | null, height?: number | null, srcset?: string | null, description?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null } | { __typename: 'privacyPolicy_privacyPolicy_Entry', id?: string | null } | { __typename: 'projects_default_Entry', id?: string | null } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry', id?: string | null } | { __typename: 'submitEvent_submitEvent_Entry', id?: string | null } | { __typename: 'submitExhibition_submitExhibition_Entry', id?: string | null } | null> | null, submissions?: Array<{ __typename: 'event_Submission' } | { __typename: 'exhibition_Submission', id?: string | null, title?: string | null, dateCreated?: any | null, status?: string | null, date?: any | null, timestamp?: any | null, postCategory?: Array<{ __typename: 'colors_Category', title?: string | null, slug?: string | null } | { __typename: 'eventCategory_Category', title?: string | null, slug?: string | null } | { __typename: 'postCategory_Category', title?: string | null, slug?: string | null } | null> | null, keyImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset' } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset', id?: string | null, url?: string | null, width?: number | null, height?: number | null, srcset?: string | null } | null> | null } | null> | null, category?: { __typename: 'colors_Category' } | { __typename: 'eventCategory_Category' } | { __typename: 'postCategory_Category', seo?: { __typename: 'Ether_SeoData', description?: string | null, title?: string | null, social?: { __typename: 'Ether_SeoSocialNetworks', facebook?: { __typename: 'Ether_SeoSocialData', description?: string | null, title?: string | null, image?: { __typename: 'archiveAssets_Asset', url?: string | null } | { __typename: 'assets_Asset', url?: string | null } | { __typename: 'studioShAssets_Asset', url?: string | null } | { __typename: 'submissions_Asset', url?: string | null } | null } | null, twitter?: { __typename: 'Ether_SeoSocialData', description?: string | null, title?: string | null, image?: { __typename: 'archiveAssets_Asset', url?: string | null } | { __typename: 'assets_Asset', url?: string | null } | { __typename: 'studioShAssets_Asset', url?: string | null } | { __typename: 'submissions_Asset', url?: string | null } | null } | null } | null } | null } | null };

export type SearchPostsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type SearchPostsQuery = { __typename: 'Query', posts?: Array<{ __typename: 'aboutKubaparis_aboutKubaparis_Entry', searchScore?: string | null } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry', searchScore?: string | null } | { __typename: 'ads_contentBanner_Entry', searchScore?: string | null } | { __typename: 'ads_landingpageBanner_Entry', searchScore?: string | null } | { __typename: 'ads_sidebarBanner_Entry', searchScore?: string | null } | { __typename: 'advertise_advertise_Entry', searchScore?: string | null } | { __typename: 'archive_archive_Entry', searchScore?: string | null } | { __typename: 'archivedPost_default_Entry', searchScore?: string | null } | { __typename: 'calendar_calendar_Entry', searchScore?: string | null } | { __typename: 'imprint_imprint_Entry', searchScore?: string | null } | { __typename: 'landingPage_landingPage_Entry', searchScore?: string | null } | { __typename: 'news_color_Entry', searchScore?: string | null } | { __typename: 'news_image_Entry', searchScore?: string | null } | { __typename: 'posts_default_Entry', searchScore?: string | null, id?: string | null, title?: string | null, uri?: string | null, dateCreated?: any | null, date?: any | null, timestamp?: any | null, postCategory?: Array<{ __typename: 'colors_Category', title?: string | null, slug?: string | null } | { __typename: 'eventCategory_Category', title?: string | null, slug?: string | null } | { __typename: 'postCategory_Category', title?: string | null, slug?: string | null } | null> | null, keyImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', id?: string | null, url?: string | null, width?: number | null, height?: number | null, srcset?: string | null, description?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null } | { __typename: 'privacyPolicy_privacyPolicy_Entry', searchScore?: string | null } | { __typename: 'projects_default_Entry', searchScore?: string | null } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry', searchScore?: string | null } | { __typename: 'submitEvent_submitEvent_Entry', searchScore?: string | null } | { __typename: 'submitExhibition_submitExhibition_Entry', searchScore?: string | null } | null> | null, submissions?: Array<{ __typename: 'event_Submission', searchScore?: string | null } | { __typename: 'exhibition_Submission', searchScore?: string | null, id?: string | null, title?: string | null, dateCreated?: any | null, status?: string | null, date?: any | null, timestamp?: any | null, postCategory?: Array<{ __typename: 'colors_Category', title?: string | null, slug?: string | null } | { __typename: 'eventCategory_Category', title?: string | null, slug?: string | null } | { __typename: 'postCategory_Category', title?: string | null, slug?: string | null } | null> | null, keyImage?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset' } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset', id?: string | null, url?: string | null, width?: number | null, height?: number | null, srcset?: string | null } | null> | null } | null> | null, archivedPosts?: Array<{ __typename: 'aboutKubaparis_aboutKubaparis_Entry', searchScore?: string | null } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry', searchScore?: string | null } | { __typename: 'ads_contentBanner_Entry', searchScore?: string | null } | { __typename: 'ads_landingpageBanner_Entry', searchScore?: string | null } | { __typename: 'ads_sidebarBanner_Entry', searchScore?: string | null } | { __typename: 'advertise_advertise_Entry', searchScore?: string | null } | { __typename: 'archive_archive_Entry', searchScore?: string | null } | { __typename: 'archivedPost_default_Entry', searchScore?: string | null, id?: string | null, slug?: string | null, title?: string | null, uri?: string | null, exhibitionTitle?: string | null, openingExhibition?: any | null, endOfExhibition?: any | null, year?: any | null, date?: any | null, imagesArchive?: Array<{ __typename: 'imagesArchive_image_BlockType', image?: Array<{ __typename: 'archiveAssets_Asset', url?: string | null, width?: number | null, height?: number | null } | { __typename: 'assets_Asset' } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null } | null> | null } | { __typename: 'calendar_calendar_Entry', searchScore?: string | null } | { __typename: 'imprint_imprint_Entry', searchScore?: string | null } | { __typename: 'landingPage_landingPage_Entry', searchScore?: string | null } | { __typename: 'news_color_Entry', searchScore?: string | null } | { __typename: 'news_image_Entry', searchScore?: string | null } | { __typename: 'posts_default_Entry', searchScore?: string | null } | { __typename: 'privacyPolicy_privacyPolicy_Entry', searchScore?: string | null } | { __typename: 'projects_default_Entry', searchScore?: string | null } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry', searchScore?: string | null } | { __typename: 'submitEvent_submitEvent_Entry', searchScore?: string | null } | { __typename: 'submitExhibition_submitExhibition_Entry', searchScore?: string | null } | null> | null };

export type ArchiveQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type ArchiveQuery = { __typename: 'Query', archivedPosts?: Array<{ __typename: 'aboutKubaparis_aboutKubaparis_Entry' } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry' } | { __typename: 'ads_contentBanner_Entry' } | { __typename: 'ads_landingpageBanner_Entry' } | { __typename: 'ads_sidebarBanner_Entry' } | { __typename: 'advertise_advertise_Entry' } | { __typename: 'archive_archive_Entry' } | { __typename: 'archivedPost_default_Entry', id?: string | null, slug?: string | null, title?: string | null, uri?: string | null, exhibitionTitle?: string | null, openingExhibition?: any | null, endOfExhibition?: any | null, year?: any | null, date?: any | null, imagesArchive?: Array<{ __typename: 'imagesArchive_image_BlockType', image?: Array<{ __typename: 'archiveAssets_Asset', url?: string | null, width?: number | null, height?: number | null } | { __typename: 'assets_Asset' } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null } | null> | null } | { __typename: 'calendar_calendar_Entry' } | { __typename: 'imprint_imprint_Entry' } | { __typename: 'landingPage_landingPage_Entry' } | { __typename: 'news_color_Entry' } | { __typename: 'news_image_Entry' } | { __typename: 'posts_default_Entry' } | { __typename: 'privacyPolicy_privacyPolicy_Entry' } | { __typename: 'projects_default_Entry' } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry' } | { __typename: 'submitEvent_submitEvent_Entry' } | { __typename: 'submitExhibition_submitExhibition_Entry' } | null> | null };

export type GetAdClickCountQueryVariables = Exact<{
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']>> | InputMaybe<Scalars['QueryArgument']>>;
}>;


export type GetAdClickCountQuery = { __typename: 'Query', entry?: { __typename: 'aboutKubaparis_aboutKubaparis_Entry', id?: string | null, title?: string | null } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry', id?: string | null, title?: string | null } | { __typename: 'ads_contentBanner_Entry', clickCounter?: any | null, id?: string | null, title?: string | null } | { __typename: 'ads_landingpageBanner_Entry', id?: string | null, title?: string | null } | { __typename: 'ads_sidebarBanner_Entry', clickCounter?: any | null, id?: string | null, title?: string | null } | { __typename: 'advertise_advertise_Entry', id?: string | null, title?: string | null } | { __typename: 'archive_archive_Entry', id?: string | null, title?: string | null } | { __typename: 'archivedPost_default_Entry', id?: string | null, title?: string | null } | { __typename: 'calendar_calendar_Entry', id?: string | null, title?: string | null } | { __typename: 'imprint_imprint_Entry', id?: string | null, title?: string | null } | { __typename: 'landingPage_landingPage_Entry', id?: string | null, title?: string | null } | { __typename: 'news_color_Entry', id?: string | null, title?: string | null } | { __typename: 'news_image_Entry', id?: string | null, title?: string | null } | { __typename: 'posts_default_Entry', id?: string | null, title?: string | null } | { __typename: 'privacyPolicy_privacyPolicy_Entry', id?: string | null, title?: string | null } | { __typename: 'projects_default_Entry', id?: string | null, title?: string | null } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry', id?: string | null, title?: string | null } | { __typename: 'submitEvent_submitEvent_Entry', id?: string | null, title?: string | null } | { __typename: 'submitExhibition_submitExhibition_Entry', id?: string | null, title?: string | null } | null };

export type ArchivedPostQueryVariables = Exact<{
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type ArchivedPostQuery = { __typename: 'Query', archivedPost?: { __typename: 'aboutKubaparis_aboutKubaparis_Entry' } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry' } | { __typename: 'ads_contentBanner_Entry' } | { __typename: 'ads_landingpageBanner_Entry' } | { __typename: 'ads_sidebarBanner_Entry' } | { __typename: 'advertise_advertise_Entry' } | { __typename: 'archive_archive_Entry' } | { __typename: 'archivedPost_default_Entry', id?: string | null, title?: string | null, names?: string | null, exhibitionTitle?: string | null, subheadline?: string | null, locationNameArchiv?: string | null, linkToLocationArchive?: string | null, curatorArchive?: string | null, textAuthor?: string | null, photographer?: string | null, linkToVideo?: string | null, textArchive?: string | null, year?: any | null, startDate?: any | null, endDate?: any | null, imagesArchive?: Array<{ __typename: 'imagesArchive_image_BlockType', id?: string | null, caption?: string | null, image?: Array<{ __typename: 'archiveAssets_Asset', id?: string | null, url?: string | null, title?: string | null, width?: number | null, height?: number | null } | { __typename: 'assets_Asset' } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null } | null> | null, seoImage?: Array<{ __typename: 'imagesArchive_image_BlockType', id?: string | null, caption?: string | null, image?: Array<{ __typename: 'archiveAssets_Asset', id?: string | null, url?: string | null, title?: string | null, width?: number | null, height?: number | null } | { __typename: 'assets_Asset' } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null } | null> | null } | { __typename: 'calendar_calendar_Entry' } | { __typename: 'imprint_imprint_Entry' } | { __typename: 'landingPage_landingPage_Entry' } | { __typename: 'news_color_Entry' } | { __typename: 'news_image_Entry' } | { __typename: 'posts_default_Entry' } | { __typename: 'privacyPolicy_privacyPolicy_Entry' } | { __typename: 'projects_default_Entry' } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry' } | { __typename: 'submitEvent_submitEvent_Entry' } | { __typename: 'submitExhibition_submitExhibition_Entry' } | null };

export type FooterFragment = { __typename: 'footer_GlobalSet', id?: string | null, name?: string | null, newsletterLabel?: string | null, newsletterLink?: string | null, blogContactEmail?: string | null, blogContactLabel?: string | null, studioContactEmail?: string | null, studioContactLabel?: string | null, about?: Array<{ __typename: 'about_footerAbout_BlockType', id?: string | null, aboutText?: string | null } | null> | null, followUs?: Array<{ __typename: 'followUs_socialMediaEntry_BlockType', id?: string | null, externalLink?: string | null, label?: string | null } | null> | null, linkToSingles?: Array<{ __typename: 'aboutKubaparis_aboutKubaparis_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'ads_contentBanner_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'ads_landingpageBanner_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'ads_sidebarBanner_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'advertise_advertise_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'archive_archive_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'archivedPost_default_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'calendar_calendar_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'imprint_imprint_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'landingPage_landingPage_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'news_color_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'news_image_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'posts_default_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'privacyPolicy_privacyPolicy_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'projects_default_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'submitEvent_submitEvent_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'submitExhibition_submitExhibition_Entry', id?: string | null, uri?: string | null, title?: string | null } | null> | null };

export type KubaparisOverlayVideosFragment = { __typename: 'kubaparisVideos_BlockType', backgroundColor?: string | null, backgroundColorDarkMode?: string | null, desktop?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', url?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null, mobile?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', url?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null, desktopDarkMode?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', url?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null, mobileDarkMode?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset', url?: string | null } | { __typename: 'studioShAssets_Asset' } | { __typename: 'submissions_Asset' } | null> | null };

export type VideoAssetFragment = { __typename: 'assets_Asset', url?: string | null };

export type SeoFragment = { __typename: 'Ether_SeoData', description?: string | null, title?: string | null, social?: { __typename: 'Ether_SeoSocialNetworks', facebook?: { __typename: 'Ether_SeoSocialData', description?: string | null, title?: string | null, image?: { __typename: 'archiveAssets_Asset', url?: string | null } | { __typename: 'assets_Asset', url?: string | null } | { __typename: 'studioShAssets_Asset', url?: string | null } | { __typename: 'submissions_Asset', url?: string | null } | null } | null, twitter?: { __typename: 'Ether_SeoSocialData', description?: string | null, title?: string | null, image?: { __typename: 'archiveAssets_Asset', url?: string | null } | { __typename: 'assets_Asset', url?: string | null } | { __typename: 'studioShAssets_Asset', url?: string | null } | { __typename: 'submissions_Asset', url?: string | null } | null } | null } | null };

export type SeoExhibitionFragment = { __typename: 'exhibition_Submission', title?: string | null, subheadline?: string | null, seoImage?: Array<{ __typename: 'archiveAssets_Asset', url?: string | null, width?: number | null, height?: number | null } | { __typename: 'assets_Asset', url?: string | null, width?: number | null, height?: number | null } | { __typename: 'studioShAssets_Asset', url?: string | null, width?: number | null, height?: number | null } | { __typename: 'submissions_Asset', url?: string | null, width?: number | null, height?: number | null } | null> | null };

export type ProjectSlideFragment = { __typename: 'projectSlider_slide_BlockType', id?: string | null, description?: string | null, descriptionColor?: string | null, media?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset' } | { __typename: 'studioShAssets_Asset', id?: string | null, url?: string | null, kind?: string | null, width?: number | null, height?: number | null, srcset?: string | null, title?: string | null, embeddedAsset?: { __typename: 'EmbeddedAsset', title?: string | null, description?: string | null, image?: string | null, imageHeight?: number | null, imageWidth?: number | null, html?: string | null } | null } | { __typename: 'submissions_Asset' } | null> | null };

export type ProjectFragment = { __typename: 'projects_default_Entry', title?: string | null, id?: string | null, uri?: string | null, mobileDescription?: string | null, projectSlider?: Array<{ __typename: 'projectSlider_slide_BlockType', id?: string | null, description?: string | null, descriptionColor?: string | null, media?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset' } | { __typename: 'studioShAssets_Asset', id?: string | null, url?: string | null, kind?: string | null, width?: number | null, height?: number | null, srcset?: string | null, title?: string | null, embeddedAsset?: { __typename: 'EmbeddedAsset', title?: string | null, description?: string | null, image?: string | null, imageHeight?: number | null, imageWidth?: number | null, html?: string | null } | null } | { __typename: 'submissions_Asset' } | null> | null } | null> | null, seo?: { __typename: 'Ether_SeoData', description?: string | null, title?: string | null, social?: { __typename: 'Ether_SeoSocialNetworks', facebook?: { __typename: 'Ether_SeoSocialData', description?: string | null, title?: string | null, image?: { __typename: 'archiveAssets_Asset', url?: string | null } | { __typename: 'assets_Asset', url?: string | null } | { __typename: 'studioShAssets_Asset', url?: string | null } | { __typename: 'submissions_Asset', url?: string | null } | null } | null, twitter?: { __typename: 'Ether_SeoSocialData', description?: string | null, title?: string | null, image?: { __typename: 'archiveAssets_Asset', url?: string | null } | { __typename: 'assets_Asset', url?: string | null } | { __typename: 'studioShAssets_Asset', url?: string | null } | { __typename: 'submissions_Asset', url?: string | null } | null } | null } | null } | null };

export type ProjectMenuItemFragment = { __typename: 'projects_default_Entry', id?: string | null, title?: string | null, uri?: string | null };

export type StudioShMenuQueryVariables = Exact<{ [key: string]: never; }>;


export type StudioShMenuQuery = { __typename: 'Query', menu?: { __typename: 'footer_GlobalSet' } | { __typename: 'landingPageVideos_GlobalSet' } | { __typename: 'menu_GlobalSet' } | { __typename: 'studioShMenu_GlobalSet', socialMediaLinks?: Array<{ __typename: 'socialMediaLinks_TableRow', label?: string | null, link?: string | null } | null> | null, menuSubpages?: Array<{ __typename: 'menuSubpages_subpage_BlockType', id?: string | null, label?: string | null, subpage?: Array<{ __typename: 'aboutKubaparis_aboutKubaparis_Entry', uri?: string | null } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry', uri?: string | null } | { __typename: 'ads_contentBanner_Entry', uri?: string | null } | { __typename: 'ads_landingpageBanner_Entry', uri?: string | null } | { __typename: 'ads_sidebarBanner_Entry', uri?: string | null } | { __typename: 'advertise_advertise_Entry', uri?: string | null } | { __typename: 'archive_archive_Entry', uri?: string | null } | { __typename: 'archivedPost_default_Entry', uri?: string | null } | { __typename: 'calendar_calendar_Entry', uri?: string | null } | { __typename: 'imprint_imprint_Entry', uri?: string | null } | { __typename: 'landingPage_landingPage_Entry', uri?: string | null } | { __typename: 'news_color_Entry', uri?: string | null } | { __typename: 'news_image_Entry', uri?: string | null } | { __typename: 'posts_default_Entry', uri?: string | null } | { __typename: 'privacyPolicy_privacyPolicy_Entry', uri?: string | null } | { __typename: 'projects_default_Entry', uri?: string | null } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry', uri?: string | null } | { __typename: 'submitEvent_submitEvent_Entry', uri?: string | null } | { __typename: 'submitExhibition_submitExhibition_Entry', uri?: string | null } | null> | null } | null> | null } | null, projectTitles?: Array<{ __typename: 'aboutKubaparis_aboutKubaparis_Entry' } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry' } | { __typename: 'ads_contentBanner_Entry' } | { __typename: 'ads_landingpageBanner_Entry' } | { __typename: 'ads_sidebarBanner_Entry' } | { __typename: 'advertise_advertise_Entry' } | { __typename: 'archive_archive_Entry' } | { __typename: 'archivedPost_default_Entry' } | { __typename: 'calendar_calendar_Entry' } | { __typename: 'imprint_imprint_Entry' } | { __typename: 'landingPage_landingPage_Entry' } | { __typename: 'news_color_Entry' } | { __typename: 'news_image_Entry' } | { __typename: 'posts_default_Entry' } | { __typename: 'privacyPolicy_privacyPolicy_Entry' } | { __typename: 'projects_default_Entry', id?: string | null, title?: string | null, uri?: string | null } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry' } | { __typename: 'submitEvent_submitEvent_Entry' } | { __typename: 'submitExhibition_submitExhibition_Entry' } | null> | null, footer?: { __typename: 'footer_GlobalSet', id?: string | null, name?: string | null, newsletterLabel?: string | null, newsletterLink?: string | null, blogContactEmail?: string | null, blogContactLabel?: string | null, studioContactEmail?: string | null, studioContactLabel?: string | null, about?: Array<{ __typename: 'about_footerAbout_BlockType', id?: string | null, aboutText?: string | null } | null> | null, followUs?: Array<{ __typename: 'followUs_socialMediaEntry_BlockType', id?: string | null, externalLink?: string | null, label?: string | null } | null> | null, linkToSingles?: Array<{ __typename: 'aboutKubaparis_aboutKubaparis_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'ads_contentBanner_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'ads_landingpageBanner_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'ads_sidebarBanner_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'advertise_advertise_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'archive_archive_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'archivedPost_default_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'calendar_calendar_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'imprint_imprint_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'landingPage_landingPage_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'news_color_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'news_image_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'posts_default_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'privacyPolicy_privacyPolicy_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'projects_default_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'submitEvent_submitEvent_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename: 'submitExhibition_submitExhibition_Entry', id?: string | null, uri?: string | null, title?: string | null } | null> | null } | { __typename: 'landingPageVideos_GlobalSet' } | { __typename: 'menu_GlobalSet' } | { __typename: 'studioShMenu_GlobalSet' } | null };

export type ProjectQueryVariables = Exact<{
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type ProjectQuery = { __typename: 'Query', project?: { __typename: 'aboutKubaparis_aboutKubaparis_Entry' } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry' } | { __typename: 'ads_contentBanner_Entry' } | { __typename: 'ads_landingpageBanner_Entry' } | { __typename: 'ads_sidebarBanner_Entry' } | { __typename: 'advertise_advertise_Entry' } | { __typename: 'archive_archive_Entry' } | { __typename: 'archivedPost_default_Entry' } | { __typename: 'calendar_calendar_Entry' } | { __typename: 'imprint_imprint_Entry' } | { __typename: 'landingPage_landingPage_Entry' } | { __typename: 'news_color_Entry' } | { __typename: 'news_image_Entry' } | { __typename: 'posts_default_Entry' } | { __typename: 'privacyPolicy_privacyPolicy_Entry' } | { __typename: 'projects_default_Entry', title?: string | null, id?: string | null, uri?: string | null, mobileDescription?: string | null, projectSlider?: Array<{ __typename: 'projectSlider_slide_BlockType', id?: string | null, description?: string | null, descriptionColor?: string | null, media?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset' } | { __typename: 'studioShAssets_Asset', id?: string | null, url?: string | null, kind?: string | null, width?: number | null, height?: number | null, srcset?: string | null, title?: string | null, embeddedAsset?: { __typename: 'EmbeddedAsset', title?: string | null, description?: string | null, image?: string | null, imageHeight?: number | null, imageWidth?: number | null, html?: string | null } | null } | { __typename: 'submissions_Asset' } | null> | null } | null> | null, seo?: { __typename: 'Ether_SeoData', description?: string | null, title?: string | null, social?: { __typename: 'Ether_SeoSocialNetworks', facebook?: { __typename: 'Ether_SeoSocialData', description?: string | null, title?: string | null, image?: { __typename: 'archiveAssets_Asset', url?: string | null } | { __typename: 'assets_Asset', url?: string | null } | { __typename: 'studioShAssets_Asset', url?: string | null } | { __typename: 'submissions_Asset', url?: string | null } | null } | null, twitter?: { __typename: 'Ether_SeoSocialData', description?: string | null, title?: string | null, image?: { __typename: 'archiveAssets_Asset', url?: string | null } | { __typename: 'assets_Asset', url?: string | null } | { __typename: 'studioShAssets_Asset', url?: string | null } | { __typename: 'submissions_Asset', url?: string | null } | null } | null } | null } | null } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry' } | { __typename: 'submitEvent_submitEvent_Entry' } | { __typename: 'submitExhibition_submitExhibition_Entry' } | null };

export type ProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectsQuery = { __typename: 'Query', projects?: Array<{ __typename: 'aboutKubaparis_aboutKubaparis_Entry' } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry' } | { __typename: 'ads_contentBanner_Entry' } | { __typename: 'ads_landingpageBanner_Entry' } | { __typename: 'ads_sidebarBanner_Entry' } | { __typename: 'advertise_advertise_Entry' } | { __typename: 'archive_archive_Entry' } | { __typename: 'archivedPost_default_Entry' } | { __typename: 'calendar_calendar_Entry' } | { __typename: 'imprint_imprint_Entry' } | { __typename: 'landingPage_landingPage_Entry' } | { __typename: 'news_color_Entry' } | { __typename: 'news_image_Entry' } | { __typename: 'posts_default_Entry' } | { __typename: 'privacyPolicy_privacyPolicy_Entry' } | { __typename: 'projects_default_Entry', title?: string | null, id?: string | null, uri?: string | null, mobileDescription?: string | null, projectSlider?: Array<{ __typename: 'projectSlider_slide_BlockType', id?: string | null, description?: string | null, descriptionColor?: string | null, media?: Array<{ __typename: 'archiveAssets_Asset' } | { __typename: 'assets_Asset' } | { __typename: 'studioShAssets_Asset', id?: string | null, url?: string | null, kind?: string | null, width?: number | null, height?: number | null, srcset?: string | null, title?: string | null, embeddedAsset?: { __typename: 'EmbeddedAsset', title?: string | null, description?: string | null, image?: string | null, imageHeight?: number | null, imageWidth?: number | null, html?: string | null } | null } | { __typename: 'submissions_Asset' } | null> | null } | null> | null, seo?: { __typename: 'Ether_SeoData', description?: string | null, title?: string | null, social?: { __typename: 'Ether_SeoSocialNetworks', facebook?: { __typename: 'Ether_SeoSocialData', description?: string | null, title?: string | null, image?: { __typename: 'archiveAssets_Asset', url?: string | null } | { __typename: 'assets_Asset', url?: string | null } | { __typename: 'studioShAssets_Asset', url?: string | null } | { __typename: 'submissions_Asset', url?: string | null } | null } | null, twitter?: { __typename: 'Ether_SeoSocialData', description?: string | null, title?: string | null, image?: { __typename: 'archiveAssets_Asset', url?: string | null } | { __typename: 'assets_Asset', url?: string | null } | { __typename: 'studioShAssets_Asset', url?: string | null } | { __typename: 'submissions_Asset', url?: string | null } | null } | null } | null } | null } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry' } | { __typename: 'submitEvent_submitEvent_Entry' } | { __typename: 'submitExhibition_submitExhibition_Entry' } | null> | null };

export type AboutStudioShQueryVariables = Exact<{ [key: string]: never; }>;


export type AboutStudioShQuery = { __typename: 'Query', entry?: { __typename: 'aboutKubaparis_aboutKubaparis_Entry', id?: string | null, title?: string | null } | { __typename: 'aboutStudioSh_aboutStudioSh_Entry', id?: string | null, title?: string | null, aboutStudioSh?: Array<{ __typename: 'aboutStudioSh_BlockType', id?: string | null, intoText?: string | null, socialMediaHeading?: string | null, contactDesignStudio?: Array<{ __typename: 'contactDesignStudio_TableRow', text?: string | null } | null> | null, contactEditorial?: Array<{ __typename: 'contactEditorial_TableRow', text?: string | null } | null> | null, socialMediaEntries?: Array<{ __typename: 'socialMediaEntries_TableRow', text?: string | null, link?: string | null } | null> | null } | null> | null, seo?: { __typename: 'Ether_SeoData', description?: string | null, title?: string | null, social?: { __typename: 'Ether_SeoSocialNetworks', facebook?: { __typename: 'Ether_SeoSocialData', description?: string | null, title?: string | null, image?: { __typename: 'archiveAssets_Asset', url?: string | null } | { __typename: 'assets_Asset', url?: string | null } | { __typename: 'studioShAssets_Asset', url?: string | null } | { __typename: 'submissions_Asset', url?: string | null } | null } | null, twitter?: { __typename: 'Ether_SeoSocialData', description?: string | null, title?: string | null, image?: { __typename: 'archiveAssets_Asset', url?: string | null } | { __typename: 'assets_Asset', url?: string | null } | { __typename: 'studioShAssets_Asset', url?: string | null } | { __typename: 'submissions_Asset', url?: string | null } | null } | null } | null } | null } | { __typename: 'ads_contentBanner_Entry', id?: string | null, title?: string | null } | { __typename: 'ads_landingpageBanner_Entry', id?: string | null, title?: string | null } | { __typename: 'ads_sidebarBanner_Entry', id?: string | null, title?: string | null } | { __typename: 'advertise_advertise_Entry', id?: string | null, title?: string | null } | { __typename: 'archive_archive_Entry', id?: string | null, title?: string | null } | { __typename: 'archivedPost_default_Entry', id?: string | null, title?: string | null } | { __typename: 'calendar_calendar_Entry', id?: string | null, title?: string | null } | { __typename: 'imprint_imprint_Entry', id?: string | null, title?: string | null } | { __typename: 'landingPage_landingPage_Entry', id?: string | null, title?: string | null } | { __typename: 'news_color_Entry', id?: string | null, title?: string | null } | { __typename: 'news_image_Entry', id?: string | null, title?: string | null } | { __typename: 'posts_default_Entry', id?: string | null, title?: string | null } | { __typename: 'privacyPolicy_privacyPolicy_Entry', id?: string | null, title?: string | null } | { __typename: 'projects_default_Entry', id?: string | null, title?: string | null } | { __typename: 'submissionSuccessful_submissionSuccessful_Entry', id?: string | null, title?: string | null } | { __typename: 'submitEvent_submitEvent_Entry', id?: string | null, title?: string | null } | { __typename: 'submitExhibition_submitExhibition_Entry', id?: string | null, title?: string | null } | null };

export const SmallAdFragmentDoc = `
    fragment smallAd on ads_sidebarBanner_Entry {
  id
  title
  __typename
  externalLink
  advertisingImage {
    ... on assets_Asset {
      __typename
      id
      kind
      url
      width
      height
      title
      description
    }
  }
}
    `;
export const BigAdFragmentDoc = `
    fragment bigAd on ads_contentBanner_Entry {
  id
  title
  __typename
  externalLink
  advertisingImage {
    ... on assets_Asset {
      __typename
      id
      kind
      url
      width
      height
      title
      description
    }
  }
}
    `;
export const MegaAdFragmentDoc = `
    fragment megaAd on ads_landingpageBanner_Entry {
  id
  title
  __typename
  externalLink
  advertisingImage {
    ... on assets_Asset {
      __typename
      id
      kind
      url
      width
      height
      title
      description
    }
  }
}
    `;
export const ArchivedPostFragmentDoc = `
    fragment archivedPost on archivedPost_default_Entry {
  ... on archivedPost_default_Entry {
    __typename
    id
    title
    names
    exhibitionTitle
    subheadline
    locationNameArchiv
    linkToLocationArchive
    year: openingExhibition @formatDateTime(format: "Y")
    startDate: openingExhibition @formatDateTime(format: "d.m")
    endDate: endOfExhibition @formatDateTime(format: "d.m.Y")
    curatorArchive
    textAuthor
    photographer
    linkToVideo
    textArchive
    imagesArchive {
      ... on imagesArchive_image_BlockType {
        __typename
        id
        image {
          ... on archiveAssets_Asset {
            __typename
            id
            url
            title
            width
            height
          }
        }
        caption
      }
    }
    seoImage: imagesArchive(limit: 1) {
      ... on imagesArchive_image_BlockType {
        __typename
        id
        image @transform(width: 1200, height: 628) {
          ... on archiveAssets_Asset {
            __typename
            id
            url
            title
            width
            height
          }
        }
        caption
      }
    }
  }
}
    `;
export const ArchivedPostTeaserFragmentDoc = `
    fragment archivedPostTeaser on archivedPost_default_Entry {
  ... on archivedPost_default_Entry {
    __typename
    id
    slug
    title
    uri
    exhibitionTitle
    openingExhibition
    year: openingExhibition @formatDateTime(format: "Y")
    date: openingExhibition @formatDateTime(format: "d.m.y")
    endOfExhibition
    imagesArchive(limit: 1) {
      ... on imagesArchive_image_BlockType {
        __typename
        image {
          ... on archiveAssets_Asset {
            __typename
            url
            width
            height
          }
        }
      }
    }
  }
}
    `;
export const ImageBlockFragmentDoc = `
    fragment imageBlock on contentBlocks_image_BlockType {
  id
  kind
  image @transform(width: 1920, height: 1080, mode: "fit") {
    __typename
    ... on assets_Asset {
      id
      url
      width
      height
      srcset(sizes: ["2048w", "1680w", "1366w", "424w"])
      description
    }
  }
}
    `;
export const ImagePairFragmentDoc = `
    fragment imagePair on contentBlocks_imagePair_BlockType {
  id
  kind
  leftImage {
    ... on assets_Asset {
      __typename
      id
      url
      width
      height
      srcset(sizes: ["1366w", "424w"])
      description
    }
  }
  rightImage {
    ... on assets_Asset {
      __typename
      id
      url
      width
      height
      srcset(sizes: ["1366w", "424w"])
      description
    }
  }
}
    `;
export const TextBlockFragmentDoc = `
    fragment textBlock on contentBlocks_textBlock_BlockType {
  id
  text
}
    `;
export const InterviewBlockFragmentDoc = `
    fragment interviewBlock on contentBlocks_interview_BlockType {
  id
  interviewer {
    fullName
    initials
  }
  interviewee {
    fullName
    initials
  }
  questionsAndAnswers {
    question
    answer
  }
}
    `;
export const SliderBlockFragmentDoc = `
    fragment sliderBlock on contentBlocks_Slider_BlockType {
  id
  slides @transform(width: 1920, height: 1080, mode: "fit") {
    __typename
    ... on assets_Asset {
      __typename
      title
      id
      url
      width
      height
      srcset(sizes: ["2048w", "1680w", "1366w", "424w"])
      description
    }
  }
}
    `;
export const InstagramBlockFragmentDoc = `
    fragment instagramBlock on contentBlocks_instagram_BlockType {
  id
  __typename
  embedCodes {
    embedCode
  }
}
    `;
export const VideoBlockFragmentDoc = `
    fragment videoBlock on contentBlocks_video_BlockType {
  id
  __typename
  video {
    ... on assets_Asset {
      __typename
      title
      kind
      url
      width
      height
      mimeType
      description
    }
    embeddedAsset {
      ... on EmbeddedAsset {
        __typename
        title
        description
        aspectRatio
        height
        width
        html
      }
    }
  }
}
    `;
export const NewsColorSlideFragmentDoc = `
    fragment newsColorSlide on news_color_Entry {
  __typename
  id
  title
  newsLink
  backgroundColor
}
    `;
export const NewsImageSlideFragmentDoc = `
    fragment newsImageSlide on news_image_Entry {
  __typename
  id
  title
  newsLink
  newsImage {
    ... on assets_Asset {
      __typename
      url
      srcset(sizes: ["400w", "640w", "960w", "1280w"])
      width
      height
      description
    }
  }
}
    `;
export const PostTeaserFragmentDoc = `
    fragment postTeaser on posts_default_Entry {
  id
  __typename
  title
  uri
  dateCreated
  postCategory {
    __typename
    title
    slug
  }
  date: postDate @formatDateTime(format: "d.m.y")
  keyImage @transform(width: 1440, height: 1920) {
    ... on assets_Asset {
      id
      __typename
      url
      width
      height
      srcset(sizes: ["1000"])
      description
    }
  }
  timestamp: postDate @formatDateTime(format: "YmdHis")
}
    `;
export const SubmissionTeaserFragmentDoc = `
    fragment submissionTeaser on exhibition_Submission {
  __typename
  id
  title
  dateCreated
  status
  postCategory {
    __typename
    title
    slug
  }
  date: exhibitionOpening @formatDateTime(format: "d.m.y")
  keyImage @transform(width: 1440, height: 1920) {
    ... on submissions_Asset {
      id
      __typename
      url
      width
      height
      srcset(sizes: ["1000"])
    }
  }
  timestamp: dateCreated @formatDateTime(format: "YmdHis")
}
    `;
export const PostTeaserMiniFragmentDoc = `
    fragment postTeaserMini on posts_default_Entry {
  id
  __typename
  title
  uri
  dateCreated
  keyImage @transform(width: 500) {
    ... on assets_Asset {
      id
      title
      __typename
      url
      width
      height
      srcset(sizes: ["50w", "100w", "150w", "300w", "600w"])
      description
    }
  }
  timestamp: postDate @formatDateTime(format: "YmdHis")
}
    `;
export const ExhibitionTeaserMiniFragmentDoc = `
    fragment exhibitionTeaserMini on exhibition_Submission {
  __typename
  id
  title
  dateCreated
  status
  keyImage @transform(width: 500) {
    ... on submissions_Asset {
      id
      title
      __typename
      url
      width
      height
      srcset(sizes: ["50w", "100w", "150w", "300w", "600w"])
    }
  }
  timestamp: dateCreated @formatDateTime(format: "YmdHis")
}
    `;
export const SeoExhibitionFragmentDoc = `
    fragment seoExhibition on exhibition_Submission {
  __typename
  title
  subheadline
  seoImage: keyImage @transform(width: 1200, height: 628, format: "jpeg") {
    url
    width
    height
  }
}
    `;
export const ExhibitionFragmentDoc = `
    fragment exhibition on exhibition_Submission {
  __typename
  id
  title
  exhibitionTitle
  exhibitionEnd
  exhibitionOpening
  curator
  artistsName
  locationName
  linkToVideo
  linkToLocation
  photographer
  socialMediaInfo
  status
  subheadline
  text
  textAuthor
  topColor {
    ... on colors_Category {
      __typename
      color
    }
  }
  bottomColor {
    ... on colors_Category {
      __typename
      color
    }
  }
  images {
    __typename
    rows {
      __typename
      caption
      image {
        ... on submissions_Asset {
          __typename
          id
          width
          url
          title
          srcset(sizes: "1920")
          height
        }
      }
    }
  }
  keyImage {
    ... on submissions_Asset {
      id
      width
      url
      title
      srcset(sizes: "1920")
      height
    }
  }
  ...seoExhibition
}
    ${SeoExhibitionFragmentDoc}`;
export const MenuFragmentFragmentDoc = `
    fragment menuFragment on menu_GlobalSet {
  __typename
  socialMediaLinks {
    label
    link
  }
  menuSubpages {
    ... on menuSubpages_subpage_BlockType {
      id
      __typename
      label
      subpage {
        uri
      }
    }
  }
}
    `;
export const EventTeaserFragmentDoc = `
    fragment eventTeaser on event_Submission {
  __typename
  id
  title
  linkToLocation
  locationName
  namesInvolved
  eventTitle
  slug
  startDate
  endDate
  status
  city
  eventCategory {
    ... on eventCategory_Category {
      __typename
      id
      title
      slug
    }
  }
}
    `;
export const FooterFragmentDoc = `
    fragment footer on footer_GlobalSet {
  __typename
  id
  name
  newsletterLabel
  newsletterLink
  about {
    __typename
    ... on about_footerAbout_BlockType {
      __typename
      id
      aboutText
    }
  }
  followUs {
    __typename
    ... on followUs_socialMediaEntry_BlockType {
      __typename
      id
      externalLink
      label
    }
  }
  blogContactEmail
  blogContactLabel
  studioContactEmail
  studioContactLabel
  linkToSingles {
    id
    uri
    title
  }
}
    `;
export const VideoAssetFragmentDoc = `
    fragment videoAsset on assets_Asset {
  __typename
  url
}
    `;
export const KubaparisOverlayVideosFragmentDoc = `
    fragment kubaparisOverlayVideos on kubaparisVideos_BlockType {
  ... on kubaparisVideos_BlockType {
    __typename
    desktop {
      ...videoAsset
    }
    mobile {
      ...videoAsset
    }
    backgroundColor
    desktopDarkMode {
      ...videoAsset
    }
    mobileDarkMode {
      ...videoAsset
    }
    backgroundColorDarkMode
  }
}
    ${VideoAssetFragmentDoc}`;
export const ProjectSlideFragmentDoc = `
    fragment projectSlide on projectSlider_slide_BlockType {
  ... on projectSlider_slide_BlockType {
    __typename
    id
    description
    descriptionColor
    media {
      ... on studioShAssets_Asset {
        id
        __typename
        id
        url
        kind
        width
        height
        srcset(sizes: ["2560w", "2048w", "1680w", "1366w", "424w"])
        title
        embeddedAsset {
          ... on EmbeddedAsset {
            title
            description
            image
            imageHeight
            imageWidth
          }
          html
        }
      }
    }
  }
}
    `;
export const SeoFragmentDoc = `
    fragment seo on Ether_SeoData {
  description
  title
  social {
    facebook {
      description
      title
      image {
        url(width: 1200, height: 628, immediately: false)
      }
    }
    twitter {
      description
      title
      image {
        url(width: 1200, height: 628, immediately: false)
      }
    }
  }
}
    `;
export const ProjectFragmentDoc = `
    fragment project on projects_default_Entry {
  title
  id
  __typename
  uri
  projectSlider {
    ...projectSlide
  }
  mobileDescription
  seo {
    ...seo
  }
}
    ${ProjectSlideFragmentDoc}
${SeoFragmentDoc}`;
export const ProjectMenuItemFragmentDoc = `
    fragment projectMenuItem on projects_default_Entry {
  __typename
  id
  title
  uri
}
    `;
export const UpdateContentBannerClickCountDocument = `
    mutation updateContentBannerClickCount($id: ID, $clickCount: Number) {
  save_ads_contentBanner_Entry(id: $id, clickCounter: $clickCount) {
    id
    clickCounter
  }
}
    `;
export const UpdateSidebarBannerClickCountDocument = `
    mutation updateSidebarBannerClickCount($id: ID, $clickCount: Number) {
  save_ads_sidebarBanner_Entry(id: $id, clickCounter: $clickCount) {
    id
    clickCounter
  }
}
    `;
export const AboutKubaparisDocument = `
    query aboutKubaparis {
  entry(site: "kubaparis", section: "aboutKubaparis") {
    __typename
    ... on aboutKubaparis_aboutKubaparis_Entry {
      id
      title
      redactor
      contactKubaparis
      team {
        ... on team_member_BlockType {
          id
          fullName
          socialMediaLink
          position
          portrait @transform(width: 300, height: 400, format: "webp") {
            ... on assets_Asset {
              __typename
              id
              url
              width
              height
              srcset(sizes: ["400w", "640w", "960w", "1280w"])
            }
          }
        }
      }
      seo {
        ...seo
      }
    }
  }
}
    ${SeoFragmentDoc}`;
export const LandingPageDocument = `
    query landingPage($limit: Int) {
  __typename
  content: entry(site: "kubaparis", section: "landingPage") {
    __typename
    ... on landingPage_landingPage_Entry {
      __typename
      title
      landingHero {
        __typename
        ... on landingHero_BlockType {
          background {
            __typename
            ... on background_image_BlockType {
              image @transform(width: 1920, height: 1080) {
                title
                id
                url
                width
                height
                srcset(sizes: ["2048w", "1680w", "1366w", "424w"])
              }
              imageDarkMode @transform(width: 1920, height: 1080) {
                title
                id
                url
                width
                height
                srcset(sizes: ["2048w", "1680w", "1366w", "424w"])
              }
            }
            ... on background_video_BlockType {
              video {
                id
                __typename
                ... on assets_Asset {
                  url
                  width
                  height
                  mimeType
                  description
                }
                embeddedAsset {
                  ... on EmbeddedAsset {
                    title
                    description
                    aspectRatio
                    height
                    width
                    html
                  }
                }
              }
            }
          }
        }
      }
      seo {
        ...seo
      }
    }
  }
  ads: entries(site: "kubaparis", section: "ads") {
    ...megaAd
    ...bigAd
    ...smallAd
  }
  news: entries(site: "kubaparis", section: "news") {
    ...newsColorSlide
    ...newsImageSlide
  }
  posts: entries(site: "kubaparis", section: "posts", limit: $limit) {
    ...postTeaser
  }
  submissions: formieSubmissions(
    form: "exhibition"
    status: "published"
    limit: $limit
  ) {
    ...submissionTeaser
  }
  overlayVideos: globalSet(handle: "landingPageVideos") {
    __typename
    ... on landingPageVideos_GlobalSet {
      kubaparisVideos {
        ...kubaparisOverlayVideos
      }
    }
  }
  exhibitionCount: formieSubmissionCount(form: "exhibition", status: "published")
  postCount: entryCount(section: "posts", enabledForSite: true)
}
    ${SeoFragmentDoc}
${MegaAdFragmentDoc}
${BigAdFragmentDoc}
${SmallAdFragmentDoc}
${NewsColorSlideFragmentDoc}
${NewsImageSlideFragmentDoc}
${PostTeaserFragmentDoc}
${SubmissionTeaserFragmentDoc}
${KubaparisOverlayVideosFragmentDoc}`;
export const MorePostsAndSubmissionsDocument = `
    query morePostsAndSubmissions($limit: Int, $offset: Int) {
  posts: entries(
    site: "kubaparis"
    section: "posts"
    limit: $limit
    offset: $offset
  ) {
    ...postTeaser
  }
  submissions: formieSubmissions(
    form: "exhibition"
    status: "published"
    limit: $limit
    offset: $offset
  ) {
    ...submissionTeaser
  }
}
    ${PostTeaserFragmentDoc}
${SubmissionTeaserFragmentDoc}`;
export const GlobalContentDocument = `
    query globalContent {
  kubaparisMenu: globalSet(site: "kubaparis", handle: "menu") {
    ...menuFragment
  }
  postCategories: categories(site: "kubaparis", group: "postCategory") {
    id
    title
    uri
  }
  submissionPages: entries(
    site: "kubaparis"
    section: ["submitEvent", "submitExhibition"]
  ) {
    ... on submitEvent_submitEvent_Entry {
      __typename
      id
      title
      uri
    }
    ... on submitExhibition_submitExhibition_Entry {
      __typename
      id
      uri
      title
    }
  }
  footer: globalSet(site: "kubaparis", handle: "footer") {
    ...footer
  }
  ads: entries(site: "kubaparis", section: "ads") {
    ...megaAd
    ...smallAd
    ...bigAd
  }
}
    ${MenuFragmentFragmentDoc}
${FooterFragmentDoc}
${MegaAdFragmentDoc}
${SmallAdFragmentDoc}
${BigAdFragmentDoc}`;
export const CalendarDocument = `
    query calendar {
  entry(site: "kubaparis", section: "calendar") {
    ... on calendar_calendar_Entry {
      __typename
      id
      bgColor
      fontColor
    }
  }
  events: formieSubmissions(form: "event", status: "published") {
    ...eventTeaser
  }
}
    ${EventTeaserFragmentDoc}`;
export const SubmitExhibitionDocument = `
    query submitExhibition {
  entry(site: "kubaparis", section: "submitExhibition") {
    __typename
    ... on submitExhibition_submitExhibition_Entry {
      infoText
    }
  }
  formieForm(handle: "exhibition") {
    id
    handle
    templateHtml(options: "{\\"includeScriptsInline\\": true}")
    configJson
  }
}
    `;
export const SubmitEventDocument = `
    query submitEvent {
  entry(site: "kubaparis", section: "submitEvent") {
    __typename
    ... on submitEvent_submitEvent_Entry {
      infoText
    }
  }
  formieForm(handle: "event") {
    id
    handle
    templateHtml(options: "{\\"includeScriptsInline\\": true}")
    configJson
  }
}
    `;
export const SubmissionSuccessfulDocument = `
    query submissionSuccessful {
  entry(site: "kubaparis", section: "submissionSuccessful") {
    __typename
    ... on submissionSuccessful_submissionSuccessful_Entry {
      infoText
    }
  }
}
    `;
export const ImprintDocument = `
    query imprint {
  entry(site: "kubaparis", section: "imprint") {
    __typename
    ... on imprint_imprint_Entry {
      id
      title
      redactor
      seo {
        ...seo
      }
    }
  }
}
    ${SeoFragmentDoc}`;
export const AdvertiseDocument = `
    query advertise {
  entry(site: "kubaparis", section: "advertise") {
    __typename
    ... on advertise_advertise_Entry {
      title
      label
      advertisePdf {
        id
        url
      }
      seo {
        ...seo
      }
    }
  }
}
    ${SeoFragmentDoc}`;
export const PrivacyPolicyDocument = `
    query privacyPolicy {
  entry(site: "kubaparis", section: "privacyPolicy") {
    __typename
    ... on privacyPolicy_privacyPolicy_Entry {
      __typename
      title
      redactor
      seo {
        ...seo
      }
    }
  }
}
    ${SeoFragmentDoc}`;
export const ExhibitionDocument = `
    query exhibition($post_id: QueryArgument) {
  exhibition: formieSubmission(
    form: "exhibition"
    id: [$post_id]
    status: "published"
  ) {
    ...exhibition
  }
  morePosts: entries(
    site: "kubaparis"
    section: "posts"
    limit: 20
    orderBy: "postDate DESC"
  ) {
    ...postTeaserMini
  }
  moreExhibitions: formieSubmissions(
    form: "exhibition"
    limit: 30
    orderBy: "dateCreated DESC"
    id: ["not", $post_id]
    status: "published"
  ) {
    ...exhibitionTeaserMini
  }
}
    ${ExhibitionFragmentDoc}
${PostTeaserMiniFragmentDoc}
${ExhibitionTeaserMiniFragmentDoc}`;
export const PostDocument = `
    query post($slug: [String]) {
  entry(site: "kubaparis", slug: $slug) {
    id
    ... on posts_default_Entry {
      id
      __typename
      title
      slug
      subheading
      projectInfo {
        ... on projectInfo_TableRow {
          projectInfo
        }
      }
      topColor {
        ... on colors_Category {
          __typename
          color
        }
      }
      bottomColor {
        ... on colors_Category {
          __typename
          color
        }
      }
      keyImage {
        ... on assets_Asset {
          __typename
          url
          width
          height
          srcset(sizes: ["1920"])
          description
        }
      }
      contentBlocks {
        __typename
        ...imageBlock
        ...imagePair
        ...textBlock
        ...interviewBlock
        ...sliderBlock
        ...instagramBlock
        ...videoBlock
      }
      seo {
        ...seo
      }
    }
  }
  morePosts: entries(
    site: "kubaparis"
    section: "posts"
    limit: 20
    orderBy: "postDate DESC"
    slug: ["not", "$slug"]
  ) {
    ...postTeaserMini
  }
  moreExhibitions: formieSubmissions(
    form: "exhibition"
    limit: 30
    orderBy: "dateCreated DESC"
    status: "published"
  ) {
    ...exhibitionTeaserMini
  }
}
    ${ImageBlockFragmentDoc}
${ImagePairFragmentDoc}
${TextBlockFragmentDoc}
${InterviewBlockFragmentDoc}
${SliderBlockFragmentDoc}
${InstagramBlockFragmentDoc}
${VideoBlockFragmentDoc}
${SeoFragmentDoc}
${PostTeaserMiniFragmentDoc}
${ExhibitionTeaserMiniFragmentDoc}`;
export const PostsByCategoryDocument = `
    query postsByCategory($category: [String], $limit: Int) {
  posts: entries(
    site: "kubaparis"
    relatedToCategories: {slug: $category}
    limit: $limit
  ) {
    id
    __typename
    ...postTeaser
  }
  submissions: formieSubmissions(
    site: "kubaparis"
    form: "exhibition"
    relatedToCategories: {slug: $category}
    status: "published"
    limit: $limit
  ) {
    ...submissionTeaser
  }
  category(site: "kubaparis", slug: $category) {
    ... on postCategory_Category {
      __typename
      seo {
        ...seo
      }
    }
  }
}
    ${PostTeaserFragmentDoc}
${SubmissionTeaserFragmentDoc}
${SeoFragmentDoc}`;
export const SearchPostsDocument = `
    query searchPosts($search: String, $limit: Int) {
  posts: entries(
    site: "kubaparis"
    section: "posts"
    search: $search
    orderBy: "score"
    limit: $limit
  ) {
    ...postTeaser
    searchScore
  }
  submissions: formieSubmissions(
    site: "kubaparis"
    form: "exhibition"
    search: $search
    orderBy: "score"
    status: "published"
  ) {
    ...submissionTeaser
    searchScore
  }
  archivedPosts: entries(
    site: "kubaparis"
    section: "archivedPost"
    search: $search
    orderBy: "score"
    limit: $limit
  ) {
    ...archivedPostTeaser
    searchScore
  }
}
    ${PostTeaserFragmentDoc}
${SubmissionTeaserFragmentDoc}
${ArchivedPostTeaserFragmentDoc}`;
export const ArchiveDocument = `
    query archive($limit: Int, $offset: Int) {
  archivedPosts: entries(
    site: "kubaparis"
    section: "archivedPost"
    limit: $limit
    offset: $offset
    orderBy: "openingExhibition DESC"
  ) {
    ...archivedPostTeaser
  }
}
    ${ArchivedPostTeaserFragmentDoc}`;
export const GetAdClickCountDocument = `
    query getAdClickCount($id: [QueryArgument]) {
  entry(id: $id, section: "ads", site: "kubaparis") {
    __typename
    id
    title
    ... on ads_sidebarBanner_Entry {
      clickCounter
    }
    ... on ads_contentBanner_Entry {
      clickCounter
    }
  }
}
    `;
export const ArchivedPostDocument = `
    query archivedPost($slug: [String]) {
  archivedPost: entry(site: "kubaparis", section: "archivedPost", slug: $slug) {
    ...archivedPost
  }
}
    ${ArchivedPostFragmentDoc}`;
export const StudioShMenuDocument = `
    query studioShMenu {
  menu: globalSet(site: "studioSh", handle: "studioShMenu") {
    ... on studioShMenu_GlobalSet {
      __typename
      socialMediaLinks {
        label
        link
      }
      menuSubpages {
        ... on menuSubpages_subpage_BlockType {
          id
          __typename
          label
          subpage {
            uri
          }
        }
      }
    }
  }
  projectTitles: entries(site: "studioSh", section: "projects") {
    ...projectMenuItem
  }
  footer: globalSet(handle: "footer") {
    ...footer
  }
}
    ${ProjectMenuItemFragmentDoc}
${FooterFragmentDoc}`;
export const ProjectDocument = `
    query project($slug: [String]) {
  project: entry(site: "studioSh", section: "projects", slug: $slug) {
    ...project
  }
}
    ${ProjectFragmentDoc}`;
export const ProjectsDocument = `
    query projects {
  projects: entries(site: "studioSh", section: "projects") {
    ...project
  }
}
    ${ProjectFragmentDoc}`;
export const AboutStudioShDocument = `
    query aboutStudioSh {
  entry(site: "studioSh", section: "aboutStudioSh") {
    id
    title
    ... on aboutStudioSh_aboutStudioSh_Entry {
      id
      __typename
      aboutStudioSh {
        ... on aboutStudioSh_BlockType {
          __typename
          id
          intoText
          contactDesignStudio {
            text
          }
          contactEditorial {
            text
          }
          socialMediaHeading
          socialMediaEntries {
            text
            link
          }
        }
      }
      seo {
        ...seo
      }
    }
  }
}
    ${SeoFragmentDoc}`;
export type Requester<C = {}, E = unknown> = <R, V>(doc: string, vars?: V, options?: C) => Promise<R>
export function getSdk<C, E>(requester: Requester<C, E>) {
  return {
    updateContentBannerClickCount(variables?: UpdateContentBannerClickCountMutationVariables, options?: C): Promise<UpdateContentBannerClickCountMutation> {
      return requester<UpdateContentBannerClickCountMutation, UpdateContentBannerClickCountMutationVariables>(UpdateContentBannerClickCountDocument, variables, options);
    },
    updateSidebarBannerClickCount(variables?: UpdateSidebarBannerClickCountMutationVariables, options?: C): Promise<UpdateSidebarBannerClickCountMutation> {
      return requester<UpdateSidebarBannerClickCountMutation, UpdateSidebarBannerClickCountMutationVariables>(UpdateSidebarBannerClickCountDocument, variables, options);
    },
    aboutKubaparis(variables?: AboutKubaparisQueryVariables, options?: C): Promise<AboutKubaparisQuery> {
      return requester<AboutKubaparisQuery, AboutKubaparisQueryVariables>(AboutKubaparisDocument, variables, options);
    },
    landingPage(variables?: LandingPageQueryVariables, options?: C): Promise<LandingPageQuery> {
      return requester<LandingPageQuery, LandingPageQueryVariables>(LandingPageDocument, variables, options);
    },
    morePostsAndSubmissions(variables?: MorePostsAndSubmissionsQueryVariables, options?: C): Promise<MorePostsAndSubmissionsQuery> {
      return requester<MorePostsAndSubmissionsQuery, MorePostsAndSubmissionsQueryVariables>(MorePostsAndSubmissionsDocument, variables, options);
    },
    globalContent(variables?: GlobalContentQueryVariables, options?: C): Promise<GlobalContentQuery> {
      return requester<GlobalContentQuery, GlobalContentQueryVariables>(GlobalContentDocument, variables, options);
    },
    calendar(variables?: CalendarQueryVariables, options?: C): Promise<CalendarQuery> {
      return requester<CalendarQuery, CalendarQueryVariables>(CalendarDocument, variables, options);
    },
    submitExhibition(variables?: SubmitExhibitionQueryVariables, options?: C): Promise<SubmitExhibitionQuery> {
      return requester<SubmitExhibitionQuery, SubmitExhibitionQueryVariables>(SubmitExhibitionDocument, variables, options);
    },
    submitEvent(variables?: SubmitEventQueryVariables, options?: C): Promise<SubmitEventQuery> {
      return requester<SubmitEventQuery, SubmitEventQueryVariables>(SubmitEventDocument, variables, options);
    },
    submissionSuccessful(variables?: SubmissionSuccessfulQueryVariables, options?: C): Promise<SubmissionSuccessfulQuery> {
      return requester<SubmissionSuccessfulQuery, SubmissionSuccessfulQueryVariables>(SubmissionSuccessfulDocument, variables, options);
    },
    imprint(variables?: ImprintQueryVariables, options?: C): Promise<ImprintQuery> {
      return requester<ImprintQuery, ImprintQueryVariables>(ImprintDocument, variables, options);
    },
    advertise(variables?: AdvertiseQueryVariables, options?: C): Promise<AdvertiseQuery> {
      return requester<AdvertiseQuery, AdvertiseQueryVariables>(AdvertiseDocument, variables, options);
    },
    privacyPolicy(variables?: PrivacyPolicyQueryVariables, options?: C): Promise<PrivacyPolicyQuery> {
      return requester<PrivacyPolicyQuery, PrivacyPolicyQueryVariables>(PrivacyPolicyDocument, variables, options);
    },
    exhibition(variables?: ExhibitionQueryVariables, options?: C): Promise<ExhibitionQuery> {
      return requester<ExhibitionQuery, ExhibitionQueryVariables>(ExhibitionDocument, variables, options);
    },
    post(variables?: PostQueryVariables, options?: C): Promise<PostQuery> {
      return requester<PostQuery, PostQueryVariables>(PostDocument, variables, options);
    },
    postsByCategory(variables?: PostsByCategoryQueryVariables, options?: C): Promise<PostsByCategoryQuery> {
      return requester<PostsByCategoryQuery, PostsByCategoryQueryVariables>(PostsByCategoryDocument, variables, options);
    },
    searchPosts(variables?: SearchPostsQueryVariables, options?: C): Promise<SearchPostsQuery> {
      return requester<SearchPostsQuery, SearchPostsQueryVariables>(SearchPostsDocument, variables, options);
    },
    archive(variables?: ArchiveQueryVariables, options?: C): Promise<ArchiveQuery> {
      return requester<ArchiveQuery, ArchiveQueryVariables>(ArchiveDocument, variables, options);
    },
    getAdClickCount(variables?: GetAdClickCountQueryVariables, options?: C): Promise<GetAdClickCountQuery> {
      return requester<GetAdClickCountQuery, GetAdClickCountQueryVariables>(GetAdClickCountDocument, variables, options);
    },
    archivedPost(variables?: ArchivedPostQueryVariables, options?: C): Promise<ArchivedPostQuery> {
      return requester<ArchivedPostQuery, ArchivedPostQueryVariables>(ArchivedPostDocument, variables, options);
    },
    studioShMenu(variables?: StudioShMenuQueryVariables, options?: C): Promise<StudioShMenuQuery> {
      return requester<StudioShMenuQuery, StudioShMenuQueryVariables>(StudioShMenuDocument, variables, options);
    },
    project(variables?: ProjectQueryVariables, options?: C): Promise<ProjectQuery> {
      return requester<ProjectQuery, ProjectQueryVariables>(ProjectDocument, variables, options);
    },
    projects(variables?: ProjectsQueryVariables, options?: C): Promise<ProjectsQuery> {
      return requester<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, variables, options);
    },
    aboutStudioSh(variables?: AboutStudioShQueryVariables, options?: C): Promise<AboutStudioShQuery> {
      return requester<AboutStudioShQuery, AboutStudioShQueryVariables>(AboutStudioShDocument, variables, options);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;